//js code packages
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

//general functions
import * as JSFUNC from '../Library/JSFUNC.js';
import * as LibraryReact from '../Library/LibraryReact.js';
import * as JSPHP from '../CaptureExecLocalDatabaseMobx/JSPHP.js';
import * as CEGeneralReact from './CEGeneralReact.js';
import * as CEIconsReact from './CEIconsReact.js';

import * as CapturesReact from '../CaptureExecReactMobxPairs/Captures/CapturesReact.js';


//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//Folders/Files
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const FileFolderSystem = inject("DatabaseMobx", "UserMobx")(observer(
class FileFolderSystem extends Component { //props: 
  //p_tblName, p_tblMapOfMaps, p_tblFilterValuesObj, p_title, p_defaultXmlType, p_allowedExtsArray, p_disableUploadFilesTF, p_disableCreateOnlineLinkDocsTF, p_disableCreateFoldersTF, p_viewWideTrueNarrowFalse, p_navigateToFolderID, 
  //f_onPerformFFSAction(i_actionText, i_descriptionText)
  //f_onNavigateToFolder(p_navigateToFolderIDOrUndefined)
  //
  //p_tblName:                      db tbl name in the fileFolderSystem format
  //p_tblMapOfMaps:                 local memory mapOfMaps version of db fileFolderSystem tbl (unfiltered, needs to be filtered and split into files and folders with each sorted within this function)
  //p_tblFilterValuesObj:           {capture_id:22, teammate_id:4, contract_type_id:2} all columns in tbl to filter on for this fileFolderSystem, uses these variables when saving new entries to db to fill in values for these columns
  //p_title:                        (optional) places a title centered above the upload boxes in the gray space
  //p_defaultXmlType:               (optional) default value for "xml_type" field for an upload
  //p_allowedExtsArray:             (optional) array of file extension strings (without '.') that will only be accepted for upload, if any of the multiple files to upload do not match these, a warming box is put up and 0 files are uploaded
  //p_disableUploadFilesTF:         (optional) [default false], if true, removes the 'Click or Drag to Upload Files' dashed blue box for dragging file uploads
  //p_disableCreateOnlineLinkDocsTF:(optional) [default false], if true, removes the 'Create New Online Link Document' button so that link files cannot be created in the FFS
  //p_disableCreateFoldersTF:       (optional) [default false], if true, removes the 'Create New Folder' button so that folders cannot be created in the FFS
  //p_viewWideTrueNarrowFalse:      (optional) true - (default) file rows are 1 line tall with all fields of info on the same line, false - file rows are 2 lines high for narrow screens (mobile) so that file name has full length to show characters
  //p_navigateToFolderID:           (optional) when this input changes value, it forces the internal state "s_folderIDOpen" to change to this folderID to navigate to this specified folder
  //f_onPerformFFSAction:           (optional) external function run when the file(s)/folder(s) are successfully uploaded, created, moved, or deleted
  //f_onNavigateToFolder:           (optional) external function run when the input p_navigateToFolderID has detected and change and updated the internal s_folderIDOpen state, this function can reset a global variable holding an input value for p_navigateToFolderID to undefined
  //
  //fileFolderSystem db tbl columns (standardized for every copy of this table, seaparate tables because each has different filtering columns):
  //  - "id"
  //  - [custom filter column examples: "capture_id", "teammate_id", "contract_type_id"  (optional filter fields in an example table)]
  //  - "folder0_file1"             0-folder, 1-file
  //  - "parent_folder_id"          -1 file or folder at root level of this system, 1-N file or folder is within parent subfolder with id equal to this number
  //  - "fileupload0_onlinelink1"   0-uploaded file from user's desktop that is physically copied to our AWS servers, 1-user pastes a URL link to an online document
  //  - "file_loc"                  files - file path (after server upload folder) "tbl_name/capture_id22/teammate_id4/contract_type_id2/file_name.ext", folders - db_name underscore version of the folder display_name
  //  - "display_name"              masked file name with ext, masked folder name
  //  - "keywords"
  //  - "notes"
  //  - "content_unique_lowercase"  all unique words stripped from file text content
  //  - "upload_date"
  //  - "upload_user_id"
  //  - "upload_user_name"
  //  - "access"                    only used for admin template uploads
  //  - "xml_type"                  only used for admin template uploads (default value for new upload affected by input p_defaultXmlType)

  constructor(props) {
    super(props);
    this.state = {
      s_currentSortFieldDbName: "display_name",
      s_currentSortIsAscTF: true,
      s_folderIDOpen: -1, //-1 flag currently at the top level seeing all folders where parent_folder_id is -1 and all files where folder_id is -1, positive id means you are in a subfolder viewing those subfolders and files
      s_creatingNewLinkToOnlineDocumentTF: false,
      s_creatingNewFolderTF: false,
      s_notesViewTF: false
    };
  }

  componentDidMount() {
    this.navigate_to_folder_id_and_call_on_navigate_to_folder(this.props.p_navigateToFolderID);
  }

  componentDidUpdate(prevProps) { //handle forced incoming input to redirect what subfolder is currently displayed (comes from clicking a file within documents search)
    if(this.props.p_navigateToFolderID !== prevProps.p_navigateToFolderID) {
      this.navigate_to_folder_id_and_call_on_navigate_to_folder(this.props.p_navigateToFolderID);
    }
  }

  navigate_to_folder_id_and_call_on_navigate_to_folder = (i_navigateToFolderID) => {
    if(JSFUNC.is_number(i_navigateToFolderID) && (i_navigateToFolderID !== this.state.s_folderIDOpen)) { //force navigation if the input is a valid number (-1 for root level or any positive id number) and is not the folder that is currently open (no need to update it in that case)
      this.setState({
        s_folderIDOpen: this.props.p_navigateToFolderID,
        s_creatingNewFolderTF: false
      });

      if(JSFUNC.is_function(this.props.f_onNavigateToFolder)) {
        this.props.f_onNavigateToFolder(undefined); //used reset global variable from forced folder entry
      }
    }
  }

  get_filter_field_names_and_values = () => {
    const p_tblFilterValuesObj = this.props.p_tblFilterValuesObj; //given {capture_id:22, teammate_id:4, contract_type_id:2}

    var filterFieldNamesArray = []; //becomes ["capture_id", "teammate_id", "contract_type_id"]
    var filterValuesArray = []; //becomes [22, 4, 2]
    if(JSFUNC.is_obj(p_tblFilterValuesObj)) {
      for(var property in p_tblFilterValuesObj) {
        if(p_tblFilterValuesObj.hasOwnProperty(property)) {
          filterFieldNamesArray.push(property);
          filterValuesArray.push(p_tblFilterValuesObj[property]);
        }
      }
    }
    return([filterFieldNamesArray, filterValuesArray]);
  }

  get_root_folders_path = () => {
    const p_tblName = this.props.p_tblName;

    const [filterFieldNamesArray, filterValuesArray] = this.get_filter_field_names_and_values();
    var rootFoldersPath = p_tblName; //becomes "tbl_name/capture_id22/teammate_id4/contract_type_id2"
    for(let f = 0; f < filterFieldNamesArray.length; f++) {
      rootFoldersPath += "/" + filterFieldNamesArray[f] + filterValuesArray[f];
    }
    return(rootFoldersPath);
  }

  onclick_create_new_link_to_online_document = () => {
    this.setState({s_creatingNewLinkToOnlineDocumentTF:true});
  }

  onclick_confirm_create_new_link_to_online_document = (i_newLinkToOnlineDocumentObj) => {
    const s_folderIDOpen = this.state.s_folderIDOpen;

    const p_tblName = this.props.p_tblName;

    const o_userID = this.props.UserMobx.o_userID;
    const c_userName = this.props.UserMobx.c_userName;

    //call database update in fileFolderSystem tbl
    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - FileFolderSystem", "onclick_confirm_create_new_link_to_online_document", ["i_newLinkToOnlineDocumentObj"], [i_newLinkToOnlineDocumentObj]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    //fields required in the fileFolderSystem db tbl (with values for a new folder)
    var tblFieldNamesArray = ["folder0_file1", "parent_folder_id", "fileupload0_onlinelink1", "file_loc", "display_name", "keywords", "notes", "content_unique_lowercase", "upload_date", "upload_user_id", "upload_user_name", "access", "xml_type"];
    var newValuesArray = [1, s_folderIDOpen, 1, i_newLinkToOnlineDocumentObj.url, i_newLinkToOnlineDocumentObj.name, i_newLinkToOnlineDocumentObj.keywords, i_newLinkToOnlineDocumentObj.descriptionNotes, "", JSFUNC.now_dateYmd(), o_userID, c_userName, "open", "generic"];
    var newValuesIdsbArray = ["i", "i", "i", "s", "s", "s", "s", "s", "s", "i", "s", "s", "s"];

    //filter field columns provided for this particular fileFolderSystem
    const [filterFieldNamesArray, filterValuesArray] = this.get_filter_field_names_and_values();
    for(let f = 0; f < filterFieldNamesArray.length; f++) {
      tblFieldNamesArray.push(filterFieldNamesArray[f]);
      newValuesArray.push(filterValuesArray[f]);
      newValuesIdsbArray.push("i"); //all filter values are assumed to be ints
    }

    C_CallPhpTblUID.add_insert(p_tblName, tblFieldNamesArray, newValuesArray, newValuesIdsbArray);

    //call perform action function
    if(JSFUNC.is_function(this.props.f_onPerformFFSAction)) {
      const functionOnSuccess = (i_parseResponse) => {
        const actionText = "Create New Link to Online Document";
        const descriptionText = i_newLinkToOnlineDocumentObj.name + " [" + i_newLinkToOnlineDocumentObj.url + "]";
        this.props.f_onPerformFFSAction(actionText, descriptionText);
      }
      C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);
    }

    C_CallPhpTblUID.execute();

    this.setState({s_creatingNewLinkToOnlineDocumentTF:false});
  }

  onclick_cancel_create_new_link_to_online_document = () => {
    this.setState({s_creatingNewLinkToOnlineDocumentTF:false});
  }

  onclick_create_new_folder = () => {
    this.setState({s_creatingNewFolderTF:true});
  }

  onclick_confirm_create_new_folder = (i_newFolderName) => {
    const s_folderIDOpen = this.state.s_folderIDOpen;

    const p_tblName = this.props.p_tblName;

    const o_userID = this.props.UserMobx.o_userID;
    const c_userName = this.props.UserMobx.c_userName;

    //call database update in fileFolderSystem tbl
    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - FileFolderSystem", "onclick_confirm_create_new_folder", ["i_newFolderName"], [i_newFolderName]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    //fields required in the fileFolderSystem db tbl (with values for a new folder)
    var tblFieldNamesArray = ["folder0_file1", "parent_folder_id", "fileupload0_onlinelink1", "file_loc", "display_name", "keywords", "notes", "content_unique_lowercase", "upload_date", "upload_user_id", "upload_user_name", "access", "xml_type"];
    var newValuesArray = [0, s_folderIDOpen, 0, JSFUNC.db_name_from_display_name(i_newFolderName), i_newFolderName, "", "", "", JSFUNC.now_dateYmd(), o_userID, c_userName, "", ""];
    var newValuesIdsbArray = ["i", "i", "i", "s", "s", "s", "s", "s", "s", "i", "s", "s", "s"];

    //filter field columns provided for this particular fileFolderSystem
    const [filterFieldNamesArray, filterValuesArray] = this.get_filter_field_names_and_values();
    for(let f = 0; f < filterFieldNamesArray.length; f++) {
      tblFieldNamesArray.push(filterFieldNamesArray[f]);
      newValuesArray.push(filterValuesArray[f]);
      newValuesIdsbArray.push("i"); //all filter values are assumed to be ints
    }

    C_CallPhpTblUID.add_insert(p_tblName, tblFieldNamesArray, newValuesArray, newValuesIdsbArray);

    //call perform action function
    if(JSFUNC.is_function(this.props.f_onPerformFFSAction)) {
      const functionOnSuccess = (i_parseResponse) => {
        const actionText = "Create New Folder";
        const descriptionText = "'" + i_newFolderName + "'";
        this.props.f_onPerformFFSAction(actionText, descriptionText);
      }
      C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);
    }

    C_CallPhpTblUID.execute();

    this.setState({s_creatingNewFolderTF:false});
  }

  onclick_cancel_create_new_folder = () => {
    this.setState({s_creatingNewFolderTF:false});
  }

  onclick_list_view = () => {
    this.setState({s_notesViewTF:false});
  }

  onclick_notes_view = () => {
    this.setState({s_notesViewTF:true});
  }

  onclick_ffs_table_header = (i_fieldDbName) => {
    const s_currentSortFieldDbName = this.state.s_currentSortFieldDbName;
    const s_currentSortIsAscTF = this.state.s_currentSortIsAscTF;
    
    var updatedSortFieldDbName = i_fieldDbName;
    var updatedSortIsAscTF = true;
    if(i_fieldDbName === s_currentSortFieldDbName) { //reverse sort direction if clicking on column that is already sorted
      updatedSortIsAscTF = (!s_currentSortIsAscTF);
    }

    this.setState({
      s_currentSortFieldDbName: updatedSortFieldDbName,
      s_currentSortIsAscTF: updatedSortIsAscTF
    });
  }

  onclick_folder = (i_folderID) => {
    this.setState({s_folderIDOpen:i_folderID});
  }

  ondelete_folders_and_files = (i_folderIDsToDeleteArray, i_fileIDsToDeleteArray) => {
    const p_tblName = this.props.p_tblName; //tbl name of the filefoldersystem that stores file and folder info together
    const p_tblMapOfMaps = this.props.p_tblMapOfMaps; //local copy of tblName with only the data for these filters

    var foldersArrayOfObjs = [];
    var filesArrayOfObjs = [];
    var folderAndFileIDsToDeleteArray = [];

    for(let folderID of i_folderIDsToDeleteArray) {
      var fileFolderItemMap = p_tblMapOfMaps.get(folderID);
      if(fileFolderItemMap !== undefined) {
        foldersArrayOfObjs.push(JSFUNC.obj_from_map(fileFolderItemMap));
        folderAndFileIDsToDeleteArray.push(folderID);
      }
    }

    for(let fileID of i_fileIDsToDeleteArray) {
      var fileFolderItemMap = p_tblMapOfMaps.get(fileID);
      if(fileFolderItemMap !== undefined) {
        filesArrayOfObjs.push(JSFUNC.obj_from_map(fileFolderItemMap));
        folderAndFileIDsToDeleteArray.push(fileID);
      }
    }

    const numFoldersToDelete = foldersArrayOfObjs.length;
    const numFilesToDelete = filesArrayOfObjs.length;

    if((numFoldersToDelete > 0) || (numFilesToDelete > 0)) { //if anything was deleted
      //construct the tblUID class instance
      const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - FileFolderSystem", "ondelete_folders_and_files", ["i_folderIDsToDeleteArray", "i_fileIDsToDeleteArray"], [i_folderIDsToDeleteArray, i_fileIDsToDeleteArray]);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      //for each file being deleted, get the file loc from the filefoldersystem tbl and call a file_delete to remove it from the server
      for(let fileObj of filesArrayOfObjs) {
        if(fileObj.fileupload0_onlinelink1 === 0) { //only fileupload types have an actual file stored on the server that must be unlinked
          C_CallPhpTblUID.add_file_delete(fileObj.file_loc); //php unlink the file from the server
        }
      }

      //delete all ffs tbl records of files and folders being deleted from the filefoldersystem database tbl and local tbl
      C_CallPhpTblUID.add_delete(p_tblName, folderAndFileIDsToDeleteArray); //no sort column in filefoldersystem tbls

      //call onperform action function
      if(JSFUNC.is_function(this.props.f_onPerformFFSAction)) {
        const functionOnSuccess = (i_parseResponse) => {
          var actionText = "";
          var descriptionText = "";
          if(numFoldersToDelete === 0) { //no folders, only file(s) deleted
            if(numFilesToDelete === 1) { //delete 1 file
              actionText = "Delete File";
              descriptionText = "Delete File '" + filesArrayOfObjs[0].display_name + "'";
            }
            else { //delete multiple files
              actionText = "Delete Files";
              descriptionText = "Deleted " + numFilesToDelete + " Files:";
              for(let fileObj of filesArrayOfObjs) {
                descriptionText += "\n - " + fileObj.display_name;
              }
            }
          }
          else if(numFilesToDelete === 0) { //no files, only folder(s) deleted
            if(numFoldersToDelete === 1) { //delete 1 folder
              actionText = "Delete Folder";
              descriptionText = "Delete Folder '" + foldersArrayOfObjs[0].display_name + "'";
            }
            else { //delete multiple folders
              actionText = "Delete Folders";
              descriptionText = "Deleted " + numFoldersToDelete + " Folders:";
              for(let folderObj of foldersArrayOfObjs) {
                descriptionText += "\n - " + folderObj.display_name;
              }
            }
          }
          else { //deleted at least 1 file and 1 folder
            actionText = "Delete Folders/Files";
            descriptionText = "Deleted " + numFoldersToDelete + " " + JSFUNC.plural(numFoldersToDelete, "Folder", "Folders") + ":";
            for(let folderObj of foldersArrayOfObjs) {
              descriptionText += "\n - " + folderObj.display_name;
            }

            descriptionText += "\n\nDeleted " + numFilesToDelete + " " + JSFUNC.plural(numFilesToDelete, "File", "Files") + ":";
            for(let fileObj of filesArrayOfObjs) {
              descriptionText += "\n - " + fileObj.display_name;
            }
          }

          this.props.f_onPerformFFSAction(actionText, descriptionText);
        }
        C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);
      }

      C_CallPhpTblUID.execute();
    }
  }

  render() {
    const s_currentSortFieldDbName = this.state.s_currentSortFieldDbName;
    const s_currentSortIsAscTF = this.state.s_currentSortIsAscTF;
    const s_folderIDOpen = this.state.s_folderIDOpen;
    const s_creatingNewLinkToOnlineDocumentTF = this.state.s_creatingNewLinkToOnlineDocumentTF;
    const s_creatingNewFolderTF = this.state.s_creatingNewFolderTF;
    const s_notesViewTF = this.state.s_notesViewTF;

    const p_tblName = this.props.p_tblName;
    const p_tblMapOfMaps = this.props.p_tblMapOfMaps;
    const p_tblFilterValuesObj = this.props.p_tblFilterValuesObj;
    const p_title = this.props.p_title;
    const p_defaultXmlType = JSFUNC.prop_value(this.props.p_defaultXmlType, "generic");
    const p_allowedExtsArray = this.props.p_allowedExtsArray;
    const p_disableUploadFilesTF = JSFUNC.prop_value(this.props.p_disableUploadFilesTF, false);
    const p_disableCreateOnlineLinkDocsTF = JSFUNC.prop_value(this.props.p_disableCreateOnlineLinkDocsTF, false);
    const p_disableCreateFoldersTF = JSFUNC.prop_value(this.props.p_disableCreateFoldersTF, false);
    const p_viewWideTrueNarrowFalse = JSFUNC.prop_value(this.props.p_viewWideTrueNarrowFalse, true);

    const c_userCanUploadFilesTF = this.props.UserMobx.c_userCanUploadFilesTF;

    //determine the requested tbl filter columns and values from the p_tblFilterValuesObj input
    const [filterFieldNamesArray, filterValuesArray] = this.get_filter_field_names_and_values();
    const folderAndFileFilterFieldNamesArray = ["folder0_file1"].concat(filterFieldNamesArray); //becomes ["folder0_file1", "capture_id", "teammate_id", "contract_type_id"]
    const folderFilterValuesArray = [0].concat(filterValuesArray); //becomes [0, 22, 4, 2]
    const fileFilterValuesArray = [1].concat(filterValuesArray); //becomes [1, 22, 4, 2]

    //filter and sort the folders
    var foldersArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(p_tblMapOfMaps, folderAndFileFilterFieldNamesArray, folderFilterValuesArray, "display_name", true, true);
    if((s_currentSortFieldDbName === "display_name") && !s_currentSortIsAscTF) { //sorted by name ASC by default, only need to change it when sorting by name DESC (all other sort columns don't affect folders)
      JSFUNC.sort_arrayOfObjs(foldersArrayOfObjs, s_currentSortFieldDbName, s_currentSortIsAscTF);
    }

    //filter and sort the files
    var filesArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(p_tblMapOfMaps, folderAndFileFilterFieldNamesArray, fileFilterValuesArray, "display_name", true, true);
    for(let fileObj of filesArrayOfObjs) {
      //get user name mask from the upload_user_id if it exists, otherwise use the upload_user_name
      var uploadUserNameMaskSortIfoObj = this.props.DatabaseMobx.user_name_mask_sort_ifo_obj_from_user_id(fileObj.upload_user_id);
      var uploadUserNameMaskPlainText = uploadUserNameMaskSortIfoObj.valueMaskPlainText;
      if(!uploadUserNameMaskSortIfoObj.isFilledOutTF) {
        uploadUserNameMaskPlainText = fileObj.upload_user_name;
      }

      fileObj.isOnlineLinkTF = (fileObj.fileupload0_onlinelink1 === 1); //compute TF flag for online link document files
      fileObj.uploadUserNameMaskPlainText = uploadUserNameMaskPlainText;
    }
    JSFUNC.sort_arrayOfObjs(filesArrayOfObjs, s_currentSortFieldDbName, s_currentSortIsAscTF);

    //compute folder trail to currently open folder
    const folderTrailArrayOfObjs = JSFUNC.tree_field_array_from_top_to_node(foldersArrayOfObjs, "parent_folder_id", s_folderIDOpen, "Obj");

    //get full folder path
    const rootFoldersPath = this.get_root_folders_path(); //root path specific to this fileFolderSystem with tblName and filters "tbl_name/capture_id22/teammate_id4/contract_type_id2"

    //determine if the current level is the top home level or in a folder
    const currentLevelIsTopHomeTF = (s_folderIDOpen <= 0);

    //determine if there are any folders or files directly within the currently open folder
    var currentLocationContainsAnyFoldersOrFilesTF = JSFUNC.obj_with_field_matching_value_is_in_arrayOfObjs_tf(foldersArrayOfObjs, "parent_folder_id", s_folderIDOpen);
    if(!currentLocationContainsAnyFoldersOrFilesTF) {
      currentLocationContainsAnyFoldersOrFilesTF = JSFUNC.obj_with_field_matching_value_is_in_arrayOfObjs_tf(filesArrayOfObjs, "parent_folder_id", s_folderIDOpen);
    }

    return(
      <div className="flex11a displayFlexColumn">
        <div className="flex00a bgPanelLightGray borderB1bbb smallTopPad">
          {(JSFUNC.string_is_filled_out_tf(p_title)) &&
            <LibraryReact.DivFont p_class="displayFlexColumnHcVc microBottomMargin lrMargin textCenter" p_fontClass="font11 fontBold fontTextLighter">
              {p_title}
            </LibraryReact.DivFont>
          }
          <div className="displayFlexRow">
            <div className="flex11a displayFlexRowHcVc flexWrap">
              {(c_userCanUploadFilesTF) &&
                <>
                  {(!p_disableUploadFilesTF) &&
                    <div className="flex00a positionRelative lrMargin">
                      <FileFolderSystemUploadFilesButtonDropZone
                        p_tblName={p_tblName}
                        p_subfoldersPath={rootFoldersPath}
                        p_tblFilterFieldNamesArray={filterFieldNamesArray}
                        p_tblFilterValuesArray={filterValuesArray}
                        p_parentFolderID={s_folderIDOpen}
                        p_defaultXmlType={p_defaultXmlType}
                        p_allowedExtsArray={p_allowedExtsArray}
                        f_onPerformFFSAction={this.props.f_onPerformFFSAction}
                      />
                    </div>
                  }
                  {(!p_disableCreateOnlineLinkDocsTF) &&
                    <div
                      className="flex00a displayFlexColumnHcVc lrMargin border bevelBorderColors borderRadius05 bgLightGray hoverLightGrayGradient cursorPointer"
                      style={{width:"3.5em", height:"3.5em"}}
                      title="Create a New Link to an Online Document"
                      onClick={this.onclick_create_new_link_to_online_document}>
                      <CEIconsReact.SvgChain
                        p_widthEm={3}
                        p_heightEm={3}
                        p_xStart0to100={0}
                        p_xEnd0to100={100}
                        p_yStart0to100={30}
                        p_yEnd0to100={70}
                        p_lineWidth="6%"
                        p_lineColor="666"
                        p_plusTF={true}
                      />
                    </div>
                  }
                  {(!p_disableCreateFoldersTF) &&
                    <div
                      className="flex00a displayFlexColumnHcVc lrMargin border bevelBorderColors borderRadius05 bgLightPurple hoverLighterPurpleGradient cursorPointer"
                      style={{width:"3.5em", height:"3.5em"}}
                      title="Create New Folder"
                      onClick={this.onclick_create_new_folder}>
                      <CEIconsReact.SvgFolder
                        p_widthEm={3}
                        p_heightEm={3}
                        p_xStart0to100={5}
                        p_xEnd0to100={95}
                        p_yStart0to100={15}
                        p_yEnd0to100={70}
                        p_lineColor="737"
                        p_plusTF={true}
                      />
                    </div>
                  }
                </>
              }
            </div>
            <div className="flex00a displayFlexColumnHcVc lrMedPad">
              <FileFolderSystemViewButtons
                p_notesViewTF={s_notesViewTF}
                f_onClickListView={this.onclick_list_view}
                f_onClickNotesView={this.onclick_notes_view}
              />
            </div>
          </div>
          <div className="lrPad">
            <FolderTrail
              p_tblName={p_tblName}
              p_folderIDOpen={s_folderIDOpen}
              p_folderTrailArrayOfObjs={folderTrailArrayOfObjs}
              f_onClickFolderTrailLink={this.onclick_folder}
            />
          </div>
        </div>
        <FFSTableHeadersRow
          p_currentSortFieldDbName={s_currentSortFieldDbName}
          p_currentSortIsAscTF={s_currentSortIsAscTF}
          p_viewWideTrueNarrowFalse={p_viewWideTrueNarrowFalse}
          p_notesViewTF={s_notesViewTF}
          f_onClickHeader={this.onclick_ffs_table_header}
        />
        {(!currentLevelIsTopHomeTF) &&
          <ReturnToPreviousFolder
            p_tblName={p_tblName}
            p_folderIDOpen={s_folderIDOpen}
            p_foldersArrayOfObjs={foldersArrayOfObjs}
            f_onClick={this.onclick_folder}
          />
        }
        <div className={"flex11a yScroll bgLightestestGray " + ((currentLocationContainsAnyFoldersOrFilesTF) ? ("displayFlexColumn yScrollBottomPad") : ("displayFlexColumnHcVc"))}>
          {(currentLocationContainsAnyFoldersOrFilesTF) ? (
            <>
              <FoldersList
                p_tblName={p_tblName}
                p_folderIDOpen={s_folderIDOpen}
                p_foldersArrayOfObjs={foldersArrayOfObjs}
                p_filesArrayOfObjs={filesArrayOfObjs}
                f_onClickFolder={this.onclick_folder}
                f_onDeleteFoldersAndFiles={this.ondelete_folders_and_files}
              />
              <FilesList
                p_tblName={p_tblName}
                p_folderIDOpen={s_folderIDOpen}
                p_filesArrayOfObjs={filesArrayOfObjs}
                p_viewWideTrueNarrowFalse={p_viewWideTrueNarrowFalse}
                p_notesViewTF={s_notesViewTF}
                f_onDeleteFoldersAndFiles={this.ondelete_folders_and_files}
              />
            </>
          ) : (
            <font className="font11 fontItalic fontTextLighter">
              {"No files or folders created yet in this location"}
            </font>
          )}
        </div>
        {(s_creatingNewLinkToOnlineDocumentTF) &&
          <CreateNewLinkToOnlineDocumentFloatingBox
            f_onClickConfirm={this.onclick_confirm_create_new_link_to_online_document}
            f_onClickCancel={this.onclick_cancel_create_new_link_to_online_document}
          />
        }
        {(s_creatingNewFolderTF) &&
          <CEGeneralReact.ConfirmBox
            p_type="inputText"
            p_title="Create a New Folder"
            f_onClickConfirm={this.onclick_confirm_create_new_folder}
            f_onClickCancel={this.onclick_cancel_create_new_folder}>
            {"Enter a name for the new folder"}
          </CEGeneralReact.ConfirmBox>
        }
      </div>
    );
  }
}));


function FileFolderSystemViewButtons(props) { //props: p_notesViewTF, f_onClickListView, f_onClickNotesView
  const viewButtonClass = "flex00a displayFlexColumnHcVc border bevelBorderColors borderRadius05";
  const selectedViewClass = "bgLightPurpleGradient";
  const unselectedViewClass = "bgLightGray hoverLightGrayGradient cursorPointer";

  const viewButtonHeightEm = 2.5;
  const viewButtonWidthEm = 1.9;

  return(
    <div className="flex00a displayFlexColumn">
      <div className="flex00a displayFlexColumnHcVc textCenter">
        <LibraryReact.DivFont p_class="" p_fontClass="font09 fontItalic">{"View"}</LibraryReact.DivFont>
      </div>
      <div className="flex00a displayFlexRow" style={{height:viewButtonHeightEm + "em"}}>
        <div
          className={viewButtonClass + " " + ((!props.p_notesViewTF) ? (selectedViewClass) : (unselectedViewClass))}
          style={{width:viewButtonWidthEm + "em", marginRight:"0.3em"}}
          title="'List' View for Uploaded Documents"
          onClick={props.f_onClickListView}>
          {[0, 1, 2, 3, 4].map((lineIndex) =>
            <div key={lineIndex} style={{width:(viewButtonWidthEm * 0.7) + "em", borderTop:"solid 0.1em #666", margin:(viewButtonHeightEm * 0.04) + "em 0"}} />
          )}
        </div>
        <div
          className={viewButtonClass + " " + ((props.p_notesViewTF) ? (selectedViewClass) : (unselectedViewClass))}
          style={{width:viewButtonWidthEm + "em"}}
          title="'Notes' View for Uploaded Documents"
          onClick={props.f_onClickNotesView}>
          <div className="displayFlexRow" style={{width:(viewButtonWidthEm * 0.7) + "em", height:"2em"}}>
            <div className="displayFlexColumnHcVc borderR1ddd" style={{width:"50%"}}>
              {[0, 1, 2].map((lineIndex) =>
                <div key={lineIndex} style={{width:(viewButtonWidthEm * 0.4) + "em", borderTop:"solid 0.1em #666", margin:(viewButtonHeightEm * 0.05) + "em 0"}} />
              )}
            </div>
            <div style={{width:"50%", margin:(viewButtonHeightEm * 0.15) + "em 0", backgroundColor:"#eee"}} />
          </div>
        </div>
      </div>
    </div>
  );
}


function FFSTableHeadersRow(props) { //props: p_currentSortFieldDbName, p_currentSortIsAscTF, p_viewWideTrueNarrowFalse, p_notesViewTF, f_onClickHeader(i_fieldDbName)
  const p_currentSortFieldDbName = props.p_currentSortFieldDbName;
  const p_currentSortIsAscTF = props.p_currentSortIsAscTF;
  const p_viewWideTrueNarrowFalse = props.p_viewWideTrueNarrowFalse;
  const f_onClickHeader = props.f_onClickHeader;

  if(props.p_notesViewTF) {
    return(
      <div className="displayFlexRow">
        <div className="flex11a displayFlexRowHcVc" style={{flexBasis:"50%"}}>
          <FFSTableHeaderWithSort
            p_fieldDbName="display_name"
            p_fieldDisplayName="Document Details"
            p_currentSortFieldDbName={p_currentSortFieldDbName}
            p_currentSortIsAscTF={p_currentSortIsAscTF}
            f_onClick={f_onClickHeader}
          />
        </div>
        <div className="flex11a displayFlexRowHcVc" style={{flexBasis:"50%"}}>
          <FFSTableHeaderWithSort
            p_fieldDbName="notes"
            p_fieldDisplayName="Description/Notes"
            p_currentSortFieldDbName={p_currentSortFieldDbName}
            p_currentSortIsAscTF={p_currentSortIsAscTF}
            f_onClick={f_onClickHeader}
          />
        </div>
      </div>
    );
  }

  return(
    <div className="displayFlexRow">
      <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"300em"}}>
        <FFSTableHeaderWithSort
          p_fieldDbName="display_name"
          p_fieldDisplayName={((p_viewWideTrueNarrowFalse) ? ("Document Name") : ("Name"))}
          p_currentSortFieldDbName={p_currentSortFieldDbName}
          p_currentSortIsAscTF={p_currentSortIsAscTF}
          f_onClick={f_onClickHeader}
        />
      </div>
      {(p_viewWideTrueNarrowFalse) &&
        <>
          <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em"}}>
            <FFSTableHeaderWithSort
              p_fieldDbName="keywords"
              p_fieldDisplayName="Keywords"
              p_currentSortFieldDbName={p_currentSortFieldDbName}
              p_currentSortIsAscTF={p_currentSortIsAscTF}
              f_onClick={f_onClickHeader}
            />
          </div>
          <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em"}}>
            <FFSTableHeaderWithSort
              p_fieldDbName="notes"
              p_fieldDisplayName="Description/Notes"
              p_currentSortFieldDbName={p_currentSortFieldDbName}
              p_currentSortIsAscTF={p_currentSortIsAscTF}
              f_onClick={f_onClickHeader}
            />
          </div>
        </>
      }
      <div className="flex11a displayFlexColumnHcVc" style={{flexBasis:"100em"}}>
        <FFSTableHeaderWithSort
          p_fieldDbName="uploadUserNameMaskPlainText"
          p_fieldDisplayName={((p_viewWideTrueNarrowFalse) ? ("Uploaded By") : ("User"))}
          p_currentSortFieldDbName={p_currentSortFieldDbName}
          p_currentSortIsAscTF={p_currentSortIsAscTF}
          f_onClick={f_onClickHeader}
        />
      </div>
      <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"13em"}}>
        <FFSTableHeaderWithSort
          p_fieldDbName="upload_date"
          p_fieldDisplayName={((p_viewWideTrueNarrowFalse) ? ("Upload Date") : ("Date"))}
          p_currentSortFieldDbName={p_currentSortFieldDbName}
          p_currentSortIsAscTF={p_currentSortIsAscTF}
          f_onClick={f_onClickHeader}
        />
      </div>
    </div>
  );
}


class FFSTableHeaderWithSort extends Component { //props: p_fieldDbName, p_fieldDisplayName, p_currentSortFieldDbName, p_currentSortIsAscTF, f_onClick(i_fieldDbName)
  onclick_header = () => {
    const p_fieldDbName = this.props.p_fieldDbName;
    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick(p_fieldDbName);
    }
  }

  render() {
    const p_fieldDbName = this.props.p_fieldDbName;
    const p_fieldDisplayName = this.props.p_fieldDisplayName;
    const p_currentSortFieldDbName = this.props.p_currentSortFieldDbName;
    const p_currentSortIsAscTF = this.props.p_currentSortIsAscTF;

    const isSortedTF = (p_fieldDbName === p_currentSortFieldDbName);

    return(
      <div
        className="displayFlexRow tbMicroPad lrPad cursorPointer"
        title={"Sort folders and files by " + p_fieldDisplayName}
        onClick={this.onclick_header}>
        <div className="flex00a displayFlexRowVc">
          <font className={"font11 fontBold " + ((isSortedTF) ? ("fontTextLight") : ("fontTextLightest"))}>
            {p_fieldDisplayName}
          </font>
        </div>
        <div className="flex00a displayFlexRowVc lrMargin">
          <CEGeneralReact.HeaderSortArrow p_isSortedTF={isSortedTF} p_sortedAscTF={p_currentSortIsAscTF} />
        </div>
      </div>
    );
  }
}


class CreateNewLinkToOnlineDocumentFloatingBox extends Component { //props: f_onClickConfirm, f_onClickCancel
  constructor(props) {
    super(props);
    this.state = {
      s_newLinkToOnlineDocumentUrl: "",
      s_newLinkToOnlineDocumentName: "",
      s_newLinkToOnlineDocumentKeywords: "",
      s_newLinkToOnlineDocumentDescriptionNotes: "",
      s_triedFirstSaveTF: false
    };
  }

  onchange_new_link_to_online_document_url = (i_newValueString) => { this.setState({s_newLinkToOnlineDocumentUrl:i_newValueString}); }
  onchange_new_link_to_online_document_name = (i_newValueString) => { this.setState({s_newLinkToOnlineDocumentName:i_newValueString}); }
  onchange_new_link_to_online_document_keywords = (i_newValueString) => { this.setState({s_newLinkToOnlineDocumentKeywords:i_newValueString}); }
  onchange_new_link_to_online_document_description_notes = (i_newValueString) => { this.setState({s_newLinkToOnlineDocumentDescriptionNotes:i_newValueString}); }

  onclick_confirm_button = () => {
    const s_newLinkToOnlineDocumentUrl = this.state.s_newLinkToOnlineDocumentUrl;
    const s_newLinkToOnlineDocumentName = this.state.s_newLinkToOnlineDocumentName;
    const s_newLinkToOnlineDocumentKeywords = this.state.s_newLinkToOnlineDocumentKeywords;
    const s_newLinkToOnlineDocumentDescriptionNotes = this.state.s_newLinkToOnlineDocumentDescriptionNotes;

    if(!JSFUNC.text_or_number_is_filled_out_tf(s_newLinkToOnlineDocumentUrl) || !JSFUNC.text_or_number_is_filled_out_tf(s_newLinkToOnlineDocumentName)) {
      this.setState({s_triedFirstSaveTF:true});
    }
    else {
      if(JSFUNC.is_function(this.props.f_onClickConfirm)) {
        this.props.f_onClickConfirm({
          url: s_newLinkToOnlineDocumentUrl,
          name: s_newLinkToOnlineDocumentName,
          keywords: s_newLinkToOnlineDocumentKeywords,
          descriptionNotes: s_newLinkToOnlineDocumentDescriptionNotes
        });
      }
    }
  }

  render() {
    const s_newLinkToOnlineDocumentUrl = this.state.s_newLinkToOnlineDocumentUrl;
    const s_newLinkToOnlineDocumentName = this.state.s_newLinkToOnlineDocumentName;
    const s_newLinkToOnlineDocumentKeywords = this.state.s_newLinkToOnlineDocumentKeywords;
    const s_newLinkToOnlineDocumentDescriptionNotes = this.state.s_newLinkToOnlineDocumentDescriptionNotes;
    const s_triedFirstSaveTF = this.state.s_triedFirstSaveTF;

    const urlBlankErrorTF = (s_triedFirstSaveTF && !JSFUNC.text_or_number_is_filled_out_tf(s_newLinkToOnlineDocumentUrl));
    const nameBlankErrorTF = (s_triedFirstSaveTF && !JSFUNC.text_or_number_is_filled_out_tf(s_newLinkToOnlineDocumentName));

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title="Create a New Link to an Online Document"
        f_onClickCancel={this.props.f_onClickCancel}>
        <div className="flex11a displayFlexColumn yScroll medFullPad">
          <div className="microBottomMargin">
            <font className="">
              {"Enter the hyperlink (full URL) to an online document (Sharepoint, GovWin, etc)"}
            </font>
          </div>
          <LibraryReact.Text
            p_value={s_newLinkToOnlineDocumentUrl}
            p_styleObj={{width:"100%"}}
            p_tabIndex={1}
            p_placeholder="https://www.website.com/online_document.pdf"
            p_errorTF={urlBlankErrorTF}
            f_onChange={this.onchange_new_link_to_online_document_url}
          />
          {(urlBlankErrorTF) &&
            <CEGeneralReact.ErrorText p_class="microTopMargin" p_text="URL cannot be blank for new online document" />
          }
          <div className="bigTopMargin microBottomMargin">
            <font className="">
              {"Enter a name to display for this online document"}
            </font>
          </div>
          <LibraryReact.Text
            p_value={s_newLinkToOnlineDocumentName}
            p_styleObj={{width:"100%"}}
            p_tabIndex={2}
            p_placeholder="Document Name"
            p_errorTF={nameBlankErrorTF}
            f_onChange={this.onchange_new_link_to_online_document_name}
          />
          {(nameBlankErrorTF) &&
            <CEGeneralReact.ErrorText p_class="microTopMargin" p_text="Document Name cannot be blank for new online document" />
          }
          <div className="hugeTopMargin borderB1ddd" />
          <div className="flex00a smallTopMargin">
              <font className="fontItalic fontTextLighter">
                {"(optional)"}
              </font>
            </div>
          <div className="displayFlexRowVc smallTopMargin">
            <div className="flex00a" style={{flexBasis:"8.5em"}}>
              <font className="">
                {"Keywords"}
              </font>
            </div>
            <div className="flex11a">
              <LibraryReact.Text
                p_value={s_newLinkToOnlineDocumentKeywords}
                p_styleObj={{width:"100%"}}
                p_tabIndex={3}
                f_onChange={this.onchange_new_link_to_online_document_keywords}
              />
            </div>
          </div>
          <div className="displayFlexRowVc smallTopMargin">
            <div className="flex00a" style={{flexBasis:"8.5em"}}>
              <font className="">
                {"Description/Notes"}
              </font>
            </div>
            <div className="flex11a">
              <LibraryReact.Textarea
                p_value={s_newLinkToOnlineDocumentDescriptionNotes}
                p_styleObj={{width:"100%", height:"12em"}}
                p_tabIndex={4}
                f_onChange={this.onchange_new_link_to_online_document_description_notes}
              />
            </div>
          </div>
        </div>
        <div className="flex00a displayFlexRowHcVc tbMedPad">
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="blue"
              p_text="Create Online Document"
              p_tabIndex={5}
              f_onClick={this.onclick_confirm_button}
            />
          </div>
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text="Cancel"
              p_tabIndex={6}
              f_onClick={this.props.f_onClickCancel}
            />
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}

class FolderTrail extends Component { //props: p_tblName, p_folderIDOpen, p_folderTrailArrayOfObjs, f_onClickFolderTrailLink
  render() {
    const p_tblName = this.props.p_tblName;
    const p_folderIDOpen = this.props.p_folderIDOpen;
    const p_folderTrailArrayOfObjs = this.props.p_folderTrailArrayOfObjs;

    return(
      <div className="displayFlexRowVc flexWrap">
        <FolderTrailItem
          p_tblName={p_tblName}
          p_folderObj={{id:-1, display_name:"Top Level"}} //display_name is a house used by FolderTrail
          p_isCurrentFolderTF={(p_folderIDOpen === -1)}
          f_onClick={this.props.f_onClickFolderTrailLink}
        />
        {p_folderTrailArrayOfObjs.map((m_folderObj) =>
          <FolderTrailItem
            key={m_folderObj.id}
            p_tblName={p_tblName}
            p_folderObj={m_folderObj}
            p_isCurrentFolderTF={(p_folderIDOpen === m_folderObj.id)}
            f_onClick={this.props.f_onClickFolderTrailLink}
          />
        )}
      </div>
    );
  }
}

class FolderTrailItem extends Component { //props: p_tblName, p_folderObj, p_isCurrentFolderTF, f_onClick
  onclick_folder_link = () => {
    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick(this.props.p_folderObj.id);
    }
  }

  render() {
    const p_tblName = this.props.p_tblName;
    const p_folderObj = this.props.p_folderObj;
    const p_isCurrentFolderTF = this.props.p_isCurrentFolderTF;

    const isTopHomeTF = (p_folderObj.id <= 0);

    return(
      <>
        {(!isTopHomeTF) &&
          <div className="flex00a" style={{marginLeft:"0.3em", marginRight:"0.1em"}}>
            <font className="fontTextLight">
              {"\u25b6"}
            </font>
          </div>
        }
        <FolderDropShellWithClick
          p_tblName={p_tblName}
          p_folderID={p_folderObj.id}
          p_class={"overflowHidden lrPad " + ((p_isCurrentFolderTF) ? ("") : ("cursorPointer"))}
          p_styleObj={{height:"1.5em"}}
          p_title={((p_isCurrentFolderTF) ? ("Currently viewing contents of folder '" + p_folderObj.display_name + "'") : ("Click to view contents of folder '" + p_folderObj.display_name + "'"))}
          p_allowDropTF={(!p_isCurrentFolderTF)}
          p_dragOverBorderColor="bad"
          f_onClick={((p_isCurrentFolderTF) ? (undefined) : (this.onclick_folder_link))}>
          <div style={{lineHeight:"1.6em"}}>
            <font className={"fontItalic " + ((p_isCurrentFolderTF) ? ("fontBold") : ("fontTextLight"))}>
              {p_folderObj.display_name}
            </font>
          </div>
        </FolderDropShellWithClick>
      </>
    );
  }
}

class FoldersList extends Component { //p_tblName, p_folderIDOpen, p_foldersArrayOfObjs, p_filesArrayOfObjs, f_onClickFolder, f_onDeleteFoldersAndFiles
  render() {
    return(
      this.props.p_foldersArrayOfObjs.map((i_folderObj) =>
        (i_folderObj.parent_folder_id === this.props.p_folderIDOpen) &&
        <Folder
          key={i_folderObj.id}
          p_tblName={this.props.p_tblName}
          p_folderObj={i_folderObj}
          p_foldersArrayOfObjs={this.props.p_foldersArrayOfObjs}
          p_filesArrayOfObjs={this.props.p_filesArrayOfObjs}
          f_onClick={this.props.f_onClickFolder}
          f_onDeleteFoldersAndFiles={this.props.f_onDeleteFoldersAndFiles}
        />
      )
    );
  }
}

class ReturnToPreviousFolder extends Component { //props: p_tblName, p_folderIDOpen, p_foldersArrayOfObjs, f_onClick
  onclick_return_to_previous_folder = () => {
    if(JSFUNC.is_function(this.props.f_onClick)) {
      const previousFolderID = this.compute_previous_folder_id();
      this.props.f_onClick(previousFolderID);
    }
  }

  compute_previous_folder_id = () => {
    const folderTrailIDsArray = JSFUNC.tree_field_array_from_top_to_node(this.props.p_foldersArrayOfObjs, "parent_folder_id", this.props.p_folderIDOpen, "id");
    const numTrailFolders = folderTrailIDsArray.length;
    if(numTrailFolders > 1) { //if deeper than 1 level
      return(folderTrailIDsArray[numTrailFolders - 2]); //return to the 2nd to last id
    }
    return(-1); //in 1 level deep, return to top level at -1
  }

  render() {
    const p_tblName = this.props.p_tblName;
    const p_folderIDOpen = this.props.p_folderIDOpen;
    const p_foldersArrayOfObjs = this.props.p_foldersArrayOfObjs;

    const previousFolderID = this.compute_previous_folder_id();
    
    return(
      <FolderDropShellWithClick
        p_tblName={p_tblName}
        p_folderID={previousFolderID}
        p_class="displayFlexRowVc hoverLighterBlueGradient cursorPointer"
        p_styleObj={{height:"3em", backgroundColor:"#f4f4f4", border:"solid 1px", borderColor:"#eee #eee #bbb #eee"}}
        p_title="Click to return to the previous folder"
        p_allowDropTF={true}
        p_dragOverBorderColor="bbb"
        f_onClick={this.onclick_return_to_previous_folder}>
        <div className="flex00a lrMargin">
          <font className="font20">
            {"\u21a9"}
          </font>
        </div>
        <div className="flex11a">
          <LibraryReact.NowrapEllipsis p_fontClass="fontItalic">
            {"Return to Previous Folder"}
          </LibraryReact.NowrapEllipsis>
        </div>
      </FolderDropShellWithClick>
    );
  }
}

const Folder = inject("UserMobx")(observer(
class Folder extends Component { //props: p_tblName, p_folderObj, p_foldersArrayOfObjs, p_filesArrayOfObjs, f_onClick, f_onDeleteFoldersAndFiles
  onclick_folder = () => {
    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick(this.props.p_folderObj.id);
    }
  }

  onsave_rename_folder = (i_updatedFolderName) => {
    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - Folder", "onsave_rename_folder", ["i_updatedFolderName"], [i_updatedFolderName]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update(this.props.p_tblName, this.props.p_folderObj.id, "display_name", i_updatedFolderName, "s");
    C_CallPhpTblUID.execute();
  }

  ondelete_folder = () => {
    if(JSFUNC.is_function(this.props.f_onDeleteFoldersAndFiles)) {
      const [allFolderIDsArray, fileIDsContainedInFoldersArray] = this.compute_delete_folder_contents();
      this.props.f_onDeleteFoldersAndFiles(allFolderIDsArray, fileIDsContainedInFoldersArray);
    }
  }

  compute_delete_folder_contents = () => {
    //recursive call to find all folderIDs within this tree below and including the folder being deleted
    var allFolderIDsArray = JSFUNC.recursive_array_of_ids_under_node_in_tree(this.props.p_foldersArrayOfObjs, "parent_folder_id", this.props.p_folderObj.id);
    allFolderIDsArray = JSFUNC.merge_unique([this.props.p_folderObj.id], allFolderIDsArray);

    //get all fileIDs that are in any of the folders listed
    var fileIDsContainedInFoldersArray = [];
    for(let f = 0; f < this.props.p_filesArrayOfObjs.length; f++) {
      if(JSFUNC.in_array(this.props.p_filesArrayOfObjs[f].parent_folder_id, allFolderIDsArray)) {
        fileIDsContainedInFoldersArray.push(this.props.p_filesArrayOfObjs[f].id);
      }
    }

    return([allFolderIDsArray, fileIDsContainedInFoldersArray]);
  }

  render() {
    const p_tblName = this.props.p_tblName;
    const p_folderObj = this.props.p_folderObj;
    const p_foldersArrayOfObjs = this.props.p_foldersArrayOfObjs;
    const p_filesArrayOfObjs = this.props.p_filesArrayOfObjs;

    const c_userCanDeleteFilesTF = this.props.UserMobx.c_userCanDeleteFilesTF;

    //compute all folders and files that would be deleted if the folder was deleted
    const [allFolderIDsArray, fileIDsContainedInFoldersArray] = this.compute_delete_folder_contents();
    const numFoldersToDelete = allFolderIDsArray.length;
    const numFilesWithinFolderAndSubfolders = fileIDsContainedInFoldersArray.length;
    var deleteMessage = "Are you sure you want to delete folder '" + p_folderObj.display_name + "'?\r\n\r\n";
    deleteMessage += "Contents to be deleted:\r\n";
    deleteMessage += "Folders (" + numFoldersToDelete + "):\r\n";
    for(let folderID of allFolderIDsArray) {
      var folderObj = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(p_foldersArrayOfObjs, "id", folderID);
      var folderName = ((folderObj === undefined) ? ("--Folder Does Not Exist (ID:" + folderID + ")--") : (folderObj.display_name));
      deleteMessage += " - " + folderName + "\r\n";
    }
    deleteMessage += "\r\nFiles (" + numFilesWithinFolderAndSubfolders + "):\r\n";
    for(let fileID of fileIDsContainedInFoldersArray) {
      var fileObj = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(p_filesArrayOfObjs, "id", fileID);
      var fileName = ((fileObj === undefined) ? ("--Folder Does Not Exist (ID:" + fileID + ")--") : (fileObj.display_name));
      deleteMessage += " - " + fileName + "\r\n";
    }

    const folderMenuItemsArrayOfObjs = [
      {
        displayName: "Rename Folder",
        confirmType: "inputText",
        confirmTitle: "Rename Folder",
        confirmTextInitialValue: p_folderObj.display_name,
        confirmButton1Name: "Rename",
        confirmMessage: "Rename",
        functionOnClickConfirmButton: this.onsave_rename_folder
      },
      {
        displayName: "Delete",
        confirmType: "confirmDelete",
        confirmMessage: deleteMessage,
        functionOnClickConfirmButton: this.ondelete_folder
      }
    ];

    return(
      <FolderDropShellWithClick
        p_tblName={p_tblName}
        p_folderID={p_folderObj.id}
        p_class="displayFlexRowVc hoverLighterBlueGradient cursorPointer"
        p_styleObj={{height:"3.4em", backgroundColor:"#f4eef8", border:"solid 1px", borderColor:"#dbe #dbe #bad #dbe"}}
        p_title={"Click to view contents of folder '" + p_folderObj.display_name + "'"}
        p_allowDropTF={true}
        p_dragOverBorderColor="bad"
        f_onClick={this.onclick_folder}>
        <div className="flex00a lrPad">
          <CEIconsReact.SvgFolder p_widthEm={3} p_heightEm={1.8} p_lineColor="777" />
        </div>
        <div className="flex11a lrPad">
          <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold fontTextLighter">
            {p_folderObj.display_name}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex00a lrPad">
          <font className="fontItalic fontTextLighter">
            {numFilesWithinFolderAndSubfolders + " " + JSFUNC.plural(numFilesWithinFolderAndSubfolders, "File", "Files")}
          </font>
        </div>
        <div className="flex00a lrPad">
          {(c_userCanDeleteFilesTF) &&
            <CEGeneralReact.VerticalDotsMenu p_menuItemsArrayOfObjs={folderMenuItemsArrayOfObjs} />
          }
        </div>
      </FolderDropShellWithClick>
    );
  }
}));

class FolderDropShellWithClick extends Component { //props: p_tblName, p_folderID, p_class, p_styleObj, p_title, p_allowDropTF, p_dragOverBorderColor, f_onClick, children
  ondrop_file_onto_folder_shell = (i_droppedFileID, event) => {
    const p_tblName = this.props.p_tblName;
    const p_folderID = this.props.p_folderID;

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - FolderDropShellWithClick", "ondrop_file_onto_folder_shell", ["i_droppedFileID"], [i_droppedFileID]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update(p_tblName, i_droppedFileID, "parent_folder_id", p_folderID, "i");
    C_CallPhpTblUID.execute();
  }

  onclick_folder_shell = (event) => {
    const p_folderID = this.props.p_folderID;

    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick(p_folderID);
    }
  }

  render() {
    const p_tblName = this.props.p_tblName;
    const p_folderID = this.props.p_folderID;
    const p_class = this.props.p_class;
    const p_styleObj = this.props.p_styleObj;
    const p_title = this.props.p_title;
    const p_allowDropTF = JSFUNC.prop_value(this.props.p_allowDropTF, true);
    const p_dragOverBorderColor = this.props.p_dragOverBorderColor;
    
    return(
      <CEGeneralReact.CE3Drag3Drop3Shell3
        p_uniqueString={"ffs_" + p_tblName}
        p_itemID={p_folderID}
        p_draggableTF={false}
        p_droppableTF={p_allowDropTF}
        p_dropZoneIsInvisibleOverlayTF={true}
        p_dropZoneOversizeWidthEm={undefined}
        p_class={p_class}
        p_styleObj={p_styleObj}
        p_title={p_title}
        p_dragOverClass={undefined}
        p_dragOverStyleObj={{border:"solid 2px #" + p_dragOverBorderColor, backgroundColor:"rgba(0,0,0,0.1)"}}
        f_isDragOverTF={undefined}
        f_onDropMatchingItem={this.ondrop_file_onto_folder_shell}
        f_onDropForeignItem={undefined}
        f_onDropFiles={undefined}
        f_onClick={this.onclick_folder_shell}>
        {this.props.children}
      </CEGeneralReact.CE3Drag3Drop3Shell3>
    );
  }
}

class FilesList extends Component { //props: p_tblName, p_folderIDOpen, p_filesArrayOfObjs, p_viewWideTrueNarrowFalse, p_notesViewTF, f_onDeleteFoldersAndFiles
  render() {
    return(
      this.props.p_filesArrayOfObjs.map((m_fileObj) =>
        (m_fileObj.parent_folder_id === this.props.p_folderIDOpen) &&
        <FileItem
          key={m_fileObj.id}
          p_tblName={this.props.p_tblName}
          p_fileObj={m_fileObj}
          p_viewWideTrueNarrowFalse={this.props.p_viewWideTrueNarrowFalse}
          p_notesViewTF={this.props.p_notesViewTF}
          f_onDeleteFoldersAndFiles={this.props.f_onDeleteFoldersAndFiles}
        />
      )
    );
  }
}

const FileItem = inject("DatabaseMobx", "UserMobx")(observer(
class FileItem extends Component { //props: p_tblName, p_fileObj, p_viewWideTrueNarrowFalse, p_notesViewTF, f_onDeleteFoldersAndFiles
  constructor(props) {
    super(props);
    this.state = {
      s_fileInfoEditFloatingBoxIsOpenTF: false
    }
  }

  onclick_edit_file_info = (event) => {
    this.setState({s_fileInfoEditFloatingBoxIsOpenTF:true});
  }

  onclick_close_edit_file_info = () => {
    this.setState({s_fileInfoEditFloatingBoxIsOpenTF:false});
  }

  onclick_online_link_open_in_new_tab = (event) => {
    const p_fileObj = this.props.p_fileObj;

    event.preventDefault();
    event.stopPropagation(); //prevent clicking the file row beneath this icon which opens the edit file info floating box

    window.open(p_fileObj.file_loc, "_blank");
  }

  ondelete_file = () => {
    if(JSFUNC.is_function(this.props.f_onDeleteFoldersAndFiles)) {
      this.props.f_onDeleteFoldersAndFiles([], [this.props.p_fileObj.id]); //delete 0 folders and 1 file
    }
  }

  onsave_file_notes = (i_newValue) => {
    const p_tblName = this.props.p_tblName;
    const p_fileObj = this.props.p_fileObj;

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - FileItem", "onsave_file_notes", ["i_newValue"], [i_newValue]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update(p_tblName, p_fileObj.id, "notes", i_newValue, "s");
    C_CallPhpTblUID.execute();
  }

  render() {
    const s_fileInfoEditFloatingBoxIsOpenTF = this.state.s_fileInfoEditFloatingBoxIsOpenTF;

    const p_tblName = this.props.p_tblName;
    const p_fileObj = this.props.p_fileObj;
    const p_viewWideTrueNarrowFalse = this.props.p_viewWideTrueNarrowFalse;
    const p_notesViewTF = this.props.p_notesViewTF;

    const c_genericDateFieldTypeObj = this.props.DatabaseMobx.c_genericDateFieldTypeObj;
    const c_userCanEditInfoOrMoveFilesTF = this.props.UserMobx.c_userCanEditInfoOrMoveFilesTF;
    const c_userCanDeleteFilesTF = this.props.UserMobx.c_userCanDeleteFilesTF;

    const iconContainerSizeEm = 2.4;
    const sectionDividerClass = "borderR1eee";

    const fileLocFilePartsObj = JSFUNC.file_parts_obj(p_fileObj.file_loc);

    //get file extension for file type hover title info
    var fileIconTitle = undefined;
    if(p_fileObj.isOnlineLinkTF) {
      //for online documents, try to find the file extension on the end of the full web address, if not simply say 'Online Document'
      const fileLocPeriodSplitArray = p_fileObj.file_loc.split(".");
      const fileLocLastPeriodSplitString = fileLocPeriodSplitArray[fileLocPeriodSplitArray.length - 1];
      if(fileLocLastPeriodSplitString.length <= 5) {
        fileIconTitle = "Online '." + fileLocLastPeriodSplitString + "' File Type";
      }
      else {
        fileIconTitle = "Online Document";
      }
    }
    else {
      fileIconTitle = "'." + fileLocFilePartsObj.fileExt + "' File Type";
    }

    //get upload date mask
    const maskUploadDate = this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(p_fileObj.upload_date, c_genericDateFieldTypeObj);

    const fileEditDragTitleLine = "\n[Click to edit name/keywords/notes for this file]\n[Drag/drop file onto a folder, or the 'Return to Previous Folder', to change its location]";
    const displayNameTitle = "File Name: " + p_fileObj.display_name + fileEditDragTitleLine;
    const keywordsTitle = "File Keywords: " + p_fileObj.keywords + fileEditDragTitleLine;
    const notesTitle = "File Description/Notes: " + p_fileObj.notes + fileEditDragTitleLine;
    const uploadUserNameTitle = "File Uploaded By: " + p_fileObj.uploadUserNameMaskPlainText + fileEditDragTitleLine;
    const uploadDateTitle = "File Upload Date: " + maskUploadDate + fileEditDragTitleLine;

    const fileDisplayNameComponent = (
      <LibraryReact.NowrapEllipsis p_fontClass="font11 fontBold fontPurple">
        {p_fileObj.display_name}
      </LibraryReact.NowrapEllipsis>
    );

    const fileKeywordsComponent = (
      <LibraryReact.NowrapEllipsis p_fontClass="fontTextLight">
        {p_fileObj.keywords}
      </LibraryReact.NowrapEllipsis>
    );

    const fileNotesComponent = (
      <LibraryReact.NowrapEllipsis p_fontClass="fontTextLight">
        {p_fileObj.notes}
      </LibraryReact.NowrapEllipsis>
    );

    const fileUploadUserNameComponent = (
      <LibraryReact.NowrapEllipsis p_fontClass="fontItalic">
        {p_fileObj.uploadUserNameMaskPlainText}
      </LibraryReact.NowrapEllipsis>
    );

    const fileUploadDateComponent = (
      <LibraryReact.NowrapEllipsis p_fontClass="fontItalic">
        {maskUploadDate}
      </LibraryReact.NowrapEllipsis>
    );

    const fileTypeIconComponent = (
      <div className="flex00a displayFlexColumnHcVc" style={{width:iconContainerSizeEm + "em", height:iconContainerSizeEm + "em"}} title={fileIconTitle}>
        <CEIconsReact.SvgFile p_fileLoc={p_fileObj.file_loc} p_xmlType={p_fileObj.xml_type} p_sizeEm={2.5} />
      </div>
    );

    const fileDownloadComponent = (
      <div className="flex00a displayFlexColumnHcVc" style={{width:iconContainerSizeEm + "em", height:iconContainerSizeEm + "em"}}>
        {(p_fileObj.isOnlineLinkTF) ? (
          <div
            className="displayFlexColumnHcVc bgLighterGrayGradient hoverLightestGrayGradient border1 bevelBorderLightColors borderRadius05"
            style={{width:"2em", height:"2em"}}
            title={"Click to access/download '" + p_fileObj.display_name + "' from its online source in a new tab"}
            onClick={this.onclick_online_link_open_in_new_tab}>
            <CEIconsReact.SvgChain
              p_widthEm={1.8}
              p_heightEm={1.8}
              p_xStart0to100={0}
              p_xEnd0to100={100}
              p_yStart0to100={30}
              p_yEnd0to100={70}
              p_lineWidth="6%"
              p_lineColor="666"
            />
          </div>
        ) : (
          <SmallDownloadFileButtonForServerFile
            p_fileLocRootUploadsOrWeb="uploads"
            p_fileLocRelativeFromRoot={p_fileObj.file_loc}
            p_downloadSaveAsFileName={p_fileObj.display_name}
            p_sizeEm={1.9}
            p_title={"Click to download '" + p_fileObj.display_name + "'"}
          />
        )}
      </div>
    );

    const filePreviewComponent = (
      <div className="flex00a displayFlexColumnHcVc" style={{width:iconContainerSizeEm + "em", height:iconContainerSizeEm + "em"}}>
        <PreviewServerFileOrWebLinkFileInFloatingBoxButton
          p_isServerFileTrueWebLinkFalse={!p_fileObj.isOnlineLinkTF}
          p_serverFileLocOrWebLinkUrl={p_fileObj.file_loc}
          p_fileDisplayName={p_fileObj.display_name}
          p_buttonSizeEm={2}
          p_buttonClass="border1 bevelBorderLightColors borderRadius05 bgLightesterGrayGradient hoverLightestPurpleGradient"
          p_iconColor="989"
          p_buttonHoverText="View file in preview window"
          p_fileNotes={p_fileObj.notes}
          f_onSaveChangedFileNotes={((c_userCanEditInfoOrMoveFilesTF) ? (this.onsave_file_notes) : (undefined))}
        />
      </div>
    );

    const fileIconsLayout = ((p_notesViewTF) ? (
      <div className="flex00a displayFlexColumnHc borderR1ddd tbPad" style={{flexBasis:"3.5em"}}>
        {fileTypeIconComponent}
        {fileDownloadComponent}
        {filePreviewComponent}
      </div>
    ) : (
      <div className="flex00a displayFlexRowVc">
        {fileTypeIconComponent}
        {fileDownloadComponent}
        {filePreviewComponent}
      </div>
    ));

    var fileRowHeightEm = 1;
    var fileFieldsLayout = null;
    if(p_notesViewTF) { //notes view
      fileRowHeightEm = 10;
      const labelFontClass = "font09 fontBold fontTextLightest";
      fileFieldsLayout = (
        <>
          <div className={"flex11a displayFlexColumn " + sectionDividerClass + " tbPad lrMedPad"} style={{flexBasis:"100em"}}>
            <div className="">{fileDisplayNameComponent}</div>
            <div className="flex00a displayFlexRowVc" title={keywordsTitle}>
              <LibraryReact.DivFont p_class="flex00a" p_fontClass={labelFontClass}>{"Keywords: "}</LibraryReact.DivFont>
              <div className="flex11a">{fileKeywordsComponent}</div>
            </div>
            <div className="flex00a displayFlexRowVc" title={uploadUserNameTitle}>
              <LibraryReact.DivFont p_class="flex00a" p_fontClass={labelFontClass}>{"Uploaded By: "}</LibraryReact.DivFont>
              <div className="flex11a">{fileUploadUserNameComponent}</div>
            </div>
            <div className="flex00a displayFlexRowVc" title={uploadDateTitle}>
              <LibraryReact.DivFont p_class="flex00a" p_fontClass={labelFontClass}>{"Upload Date: "}</LibraryReact.DivFont>
              <div className="flex11a">{fileUploadDateComponent}</div>
            </div>
          </div>
          <div className="flex11a yScroll tbPad lrMedPad" style={{flexBasis:"100em"}} title={notesTitle}>
            {p_fileObj.notes}
          </div>
        </>
      );
    }
    else if(p_viewWideTrueNarrowFalse) { //wide view, all fields in single row
      fileRowHeightEm = 3;
      fileFieldsLayout = (
        <>
          <div className={"flex11a displayFlexRowVc lrMedPad " + sectionDividerClass} style={{flexBasis:"300em"}} title={displayNameTitle}>{fileDisplayNameComponent}</div>
          <div className={"flex11a displayFlexRowVc lrMedPad " + sectionDividerClass} style={{flexBasis:"100em"}} title={keywordsTitle}>{fileKeywordsComponent}</div>
          <div className={"flex11a displayFlexRowVc lrMedPad " + sectionDividerClass} style={{flexBasis:"100em"}} title={notesTitle}>{fileNotesComponent}</div>
          <div className={"flex11a displayFlexRowVc lrMedPad " + sectionDividerClass} style={{flexBasis:"100em"}} title={uploadUserNameTitle}>{fileUploadUserNameComponent}</div>
          <div className="flex00a displayFlexRowVc lrMedPad" style={{flexBasis:"8em"}} title={uploadDateTitle}>{fileUploadDateComponent}</div>
        </>
      );
    }
    else { //narrow view, display file name on top half, keywords/notes/user on bottom half
      fileRowHeightEm = 3.4;
      fileFieldsLayout = (
        <div className="flex11a displayFlexColumnVc">
          <div className="flex00a displayFlexRowVc lrMedPad" title={displayNameTitle}>{fileDisplayNameComponent}</div>
          <div className="flex00a displayFlexRow microTopMargin">
            <div className={"flex11a displayFlexRowVc lrMedPad " + sectionDividerClass} style={{flexBasis:"100em"}} title={keywordsTitle}>{fileKeywordsComponent}</div>
            <div className={"flex11a displayFlexRowVc lrMedPad " + sectionDividerClass} style={{flexBasis:"100em"}} title={notesTitle}>{fileNotesComponent}</div>
            <div className={"flex11a displayFlexRowVc lrMedPad " + sectionDividerClass} style={{flexBasis:"100em"}} title={uploadUserNameTitle}>{fileUploadUserNameComponent}</div>
            <div className="flex00a displayFlexRowVc lrMedPad" style={{flexBasis:"8em"}} title={uploadDateTitle}>{fileUploadDateComponent}</div>
          </div>
        </div>
      );
    }

    return(
      <>
        <CEGeneralReact.CE3Drag3Drop3Shell3
          p_uniqueString={"ffs_" + p_tblName}
          p_itemID={p_fileObj.id}
          p_draggableTF={c_userCanEditInfoOrMoveFilesTF}
          p_droppableTF={false}
          p_dropZoneIsInvisibleOverlayTF={false}
          p_dropZoneOversizeWidthEm={undefined}
          p_class={"displayFlexRow lrMargin border1ddd borderB1bbb bgWhite hoverLighterBlueGradient noSelect " + ((c_userCanEditInfoOrMoveFilesTF) ? ("cursorPointer") : (""))}
          p_styleObj={{height:fileRowHeightEm + "em"}}
          p_title={undefined}
          p_dragOverClass={undefined}
          p_dragOverStyleObj={undefined}
          f_isDragOverTF={undefined}
          f_onDropMatchingItem={undefined}
          f_onDropForeignItem={undefined}
          f_onDropFiles={undefined}
          f_onClick={((c_userCanEditInfoOrMoveFilesTF) ? (this.onclick_edit_file_info) : (undefined))}>
          {fileIconsLayout}
          {fileFieldsLayout}
          {(c_userCanDeleteFilesTF) &&
            <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
              <CEGeneralReact.DeleteMenu
                p_message={"Are you sure you want to delete file '" + p_fileObj.display_name + "'?"}
                f_onDelete={this.ondelete_file}
              />
            </div>
          }
        </CEGeneralReact.CE3Drag3Drop3Shell3>
        {(s_fileInfoEditFloatingBoxIsOpenTF) &&
          <FileEditFileInfoFloatingBox
            p_tblName={p_tblName}
            p_fileObj={p_fileObj}
            p_uploadUserNameMaskPlainText={p_fileObj.uploadUserNameMaskPlainText}
            f_onClickClose={this.onclick_close_edit_file_info}
          />
        }
      </>
    );
  }
}));

export class PreviewServerFileOrWebLinkFileInFloatingBoxButton extends Component { //props: p_isServerFileTrueWebLinkFalse, p_serverFileLocOrWebLinkUrl, p_fileDisplayName, p_buttonSizeEm, p_buttonClass, p_iconColor, p_buttonHoverText, p_fileNotes, f_onSaveChangedFileNotes
  constructor(props) {
    super(props);
    this.state = {
      s_previewFileInWindowStateOrUndefined: undefined, //undefined (closed), "loading", "success", "error"
      s_loadedFileContentUint8ArrayOrErrorMessageOrUndefined: undefined,
      s_editedFileNotes: props.p_fileNotes,
      s_savedFileNotes: props.p_fileNotes,
      s_fileNotesChangesSavedTF: false
    }
  }

  onclick_view_file_preview_in_window = (event) => {
    const p_isServerFileTrueWebLinkFalse = JSFUNC.prop_value(this.props.p_isServerFileTrueWebLinkFalse, true);
    const p_serverFileLocOrWebLinkUrl = this.props.p_serverFileLocOrWebLinkUrl;
    const p_fileDisplayName = JSFUNC.prop_value(this.props.p_fileDisplayName, "");

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - PreviewServerFileOrWebLinkFileInFloatingBoxButton", "onclick_view_file_preview_in_window", ["p_serverFileLocOrWebLinkUrl", "p_fileDisplayName"], [p_serverFileLocOrWebLinkUrl, p_fileDisplayName]);

    event.preventDefault();
    event.stopPropagation(); //prevent clicking the file row beneath this icon which opens the edit file info floating box

    this.setState({
      s_previewFileInWindowStateOrUndefined: "loading",
      s_loadedFileContentUint8ArrayOrErrorMessageOrUndefined: undefined,
      s_editedFileNotes: this.props.p_fileNotes,
      s_savedFileNotes: this.props.p_fileNotes,
      s_fileNotesChangesSavedTF: false
    });

    const functionOnSuccess = (i_fileContentUint8Array) => {
      this.setState({
        s_previewFileInWindowStateOrUndefined: "success",
        s_loadedFileContentUint8ArrayOrErrorMessageOrUndefined: i_fileContentUint8Array
      });
    }
    const functionOnError = (i_errorMessage) => {
      this.setState({
        s_previewFileInWindowStateOrUndefined: "error",
        s_loadedFileContentUint8ArrayOrErrorMessageOrUndefined: i_errorMessage
      });
    }

    if(p_isServerFileTrueWebLinkFalse) {
      
      JSPHP.load_server_file_data_string(p_serverFileLocOrWebLinkUrl, false, functionOnSuccess, functionOnError, jsDescription);
    }
    else {
      const normalizeBackendWebPreviewErrorMessage = (i_rawBackendErrorMessage) => {
        if(!JSFUNC.string_is_filled_out_tf(i_rawBackendErrorMessage)) {
          return("");
        }

        const lower = i_rawBackendErrorMessage.toLowerCase();
        const urlLooksExternalTF = /^https?:\/\//i.test(p_serverFileLocOrWebLinkUrl || "");
        const backendCouldNotResolveRemoteUrlTF = (lower.includes("download.php") && lower.includes("http 404")) || (lower.includes("file could not be found") && lower.includes("download"));

        if(urlLooksExternalTF && backendCouldNotResolveRemoteUrlTF) {
          return("Backend could not retrieve this external download URL for preview (likely requires browser session/cookies or blocks server-side fetch).");
        }

        return(i_rawBackendErrorMessage);
      }

      const functionTryClientFetchFallback = (i_backendErrorMessage) => {
        fetch(p_serverFileLocOrWebLinkUrl)
        .then((response) => {
          if(!response.ok) {
            throw new Error("Error downloading web link file (HTTP " + response.status + ")");
          }
          return(response.arrayBuffer());
        })
        .then((arrayBuffer) => {
          functionOnSuccess(new Uint8Array(arrayBuffer));
        })
        .catch((error) => {
          const defaultErrorMessage = "Error downloading web link file";
          const rawErrorMessage = ((error && error.message) ? (error.message) : (defaultErrorMessage));
          var errorMessage = rawErrorMessage;

          if(JSFUNC.is_string(rawErrorMessage) && rawErrorMessage.toLowerCase().includes("failed to fetch")) {
            errorMessage = "Unable to preview this web link. Backend fetch failed and browser direct-fetch is blocked (CORS/auth) for this URL. Use the regular download/open button for this link.";
          }

          const normalizedBackendErrorMessage = normalizeBackendWebPreviewErrorMessage(i_backendErrorMessage);
          if(JSFUNC.string_is_filled_out_tf(normalizedBackendErrorMessage)) {
            errorMessage += "\n\nBackend fetch error: " + normalizedBackendErrorMessage;
          }

          functionOnError(errorMessage);
        });
      }

      const functionTryLegacyBackendFallback = (i_downloadPhpErrorMessage) => {
        const jsDescriptionLegacyBackend = JSFUNC.js_description_from_action("CEGeneralReact - PreviewServerFileOrWebLinkFileInFloatingBoxButton", "onclick_view_file_preview_in_window_web_legacy_backend_fallback", ["p_serverFileLocOrWebLinkUrl", "p_fileDisplayName"], [p_serverFileLocOrWebLinkUrl, p_fileDisplayName]);

        const functionTryClientFetchFallbackWithDownloadPhpError = (i_legacyBackendErrorMessage) => {
          var combinedBackendErrorMessage = "";

          if(JSFUNC.string_is_filled_out_tf(i_downloadPhpErrorMessage)) {
            combinedBackendErrorMessage = normalizeBackendWebPreviewErrorMessage(i_downloadPhpErrorMessage);
          }
          if(JSFUNC.string_is_filled_out_tf(i_legacyBackendErrorMessage)) {
            const normalizedLegacyBackendErrorMessage = normalizeBackendWebPreviewErrorMessage(i_legacyBackendErrorMessage);
            combinedBackendErrorMessage = (combinedBackendErrorMessage.length > 0 ? (combinedBackendErrorMessage + "\n") : "") + normalizedLegacyBackendErrorMessage;
          }

          functionTryClientFetchFallback(combinedBackendErrorMessage);
        }

        JSPHP.load_web_file_data_string(p_serverFileLocOrWebLinkUrl, false, functionOnSuccess, functionTryClientFetchFallbackWithDownloadPhpError, jsDescriptionLegacyBackend);
      }

      JSPHP.load_server_or_web_file_data_string_via_download_php("web", p_serverFileLocOrWebLinkUrl, false, functionOnSuccess, functionTryLegacyBackendFallback, jsDescription);
    }
  }

  onclick_close_file_preview_floating_box = () => {
    this.setState({
      s_previewFileInWindowStateOrUndefined: undefined,
      s_loadedFileContentUint8ArrayOrErrorMessageOrUndefined: undefined
    });
  }

  onchange_file_notes = (i_newValue) => {
    this.setState({
      s_editedFileNotes: i_newValue,
      s_fileNotesChangesSavedTF: false
    });
  }

  onclick_save_changed_file_notes = () => {
    if(JSFUNC.is_function(this.props.f_onSaveChangedFileNotes)) {
      const s_editedFileNotes = this.state.s_editedFileNotes;
      this.props.f_onSaveChangedFileNotes(s_editedFileNotes);
      this.setState({
        s_savedFileNotes: s_editedFileNotes,
        s_fileNotesChangesSavedTF: true
      });
    }
  }

  web_link_api_download_endpoint_likely_tf = (i_webLinkUrl) => {
    if(!JSFUNC.string_is_filled_out_tf(i_webLinkUrl)) {
      return(false);
    }

    const webLinkUrlLower = i_webLinkUrl.toLowerCase();

    if(webLinkUrlLower.includes("/api/")) { return(true); }
    if(webLinkUrlLower.includes("api.")) { return(true); }
    if(webLinkUrlLower.endsWith("/download")) { return(true); }
    if(webLinkUrlLower.includes("/download?")) { return(true); }
    if(webLinkUrlLower.includes("/download/")) { return(true); }

    return(false);
  }

  render() {
    const s_previewFileInWindowStateOrUndefined = this.state.s_previewFileInWindowStateOrUndefined;
    const s_loadedFileContentUint8ArrayOrErrorMessageOrUndefined = this.state.s_loadedFileContentUint8ArrayOrErrorMessageOrUndefined;
    const s_editedFileNotes = this.state.s_editedFileNotes;
    const s_savedFileNotes = this.state.s_savedFileNotes;
    const s_fileNotesChangesSavedTF = this.state.s_fileNotesChangesSavedTF;

    const p_isServerFileTrueWebLinkFalse = JSFUNC.prop_value(this.props.p_isServerFileTrueWebLinkFalse, true);
    const p_serverFileLocOrWebLinkUrl = this.props.p_serverFileLocOrWebLinkUrl;
    const p_fileDisplayName = JSFUNC.prop_value(this.props.p_fileDisplayName, "");
    const p_buttonSizeEm = JSFUNC.prop_value(this.props.p_buttonSizeEm, 2.4);
    const p_buttonClass = this.props.p_buttonClass;
    const p_iconColor = this.props.p_iconColor;
    const p_buttonHoverText = JSFUNC.prop_value(this.props.p_buttonHoverText, "View file in preview window");
    const p_fileNotes = this.props.p_fileNotes;
    const f_onSaveChangedFileNotes = this.props.f_onSaveChangedFileNotes;

    var previewFileInWindowStateIsLoadingTF = false;
    var previewFileInWindowStateIsSuccessTF = false;
    var previewFileInWindowStateIsErrorTF = false;
    if(s_previewFileInWindowStateOrUndefined === "loading") { previewFileInWindowStateIsLoadingTF = true; }
    if(s_previewFileInWindowStateOrUndefined === "success") { previewFileInWindowStateIsSuccessTF = true; }
    if(s_previewFileInWindowStateOrUndefined === "error") { previewFileInWindowStateIsErrorTF = true; }
    const previewFileInWindowStateFloatingBoxIsOpenTF = (previewFileInWindowStateIsLoadingTF || previewFileInWindowStateIsSuccessTF || previewFileInWindowStateIsErrorTF);
    const fileNotesPanelVisibleTF = (p_fileNotes !== undefined);
    const fileNotesAreEditableTF = JSFUNC.is_function(f_onSaveChangedFileNotes);
    const fileNotesChangedTF = (s_editedFileNotes !== s_savedFileNotes);
    const buttonIconSizeEm = (p_buttonSizeEm * 0.85);

    var fileLocFilePartsObj = JSFUNC.file_parts_obj(p_serverFileLocOrWebLinkUrl);
    if((!JSFUNC.text_or_number_is_filled_out_tf(fileLocFilePartsObj.fileExt)) && JSFUNC.text_or_number_is_filled_out_tf(p_fileDisplayName)) {
      fileLocFilePartsObj = JSFUNC.file_parts_obj(p_fileDisplayName);
    }

    const fileDisplayName = ((JSFUNC.text_or_number_is_filled_out_tf(p_fileDisplayName)) ? (p_fileDisplayName) : (fileLocFilePartsObj.fileNameAndExt));

    const fileExtCanBePreviewedTF = JSFUNC.in_array(fileLocFilePartsObj.fileExt, ["txt", "png", "jpg", "jpeg", "bmp", "gif", "pdf", "docx", "xlsx"]);
    const canPreviewTF = fileExtCanBePreviewedTF;

    var buttonClass = "flex00a displayFlexColumnHcVc cursorPointer";
    if(p_buttonClass !== undefined) {
      buttonClass += " " + p_buttonClass;
    }

    var previewNotAvailableTitle = "Not available for system preview (." + fileLocFilePartsObj.fileExt + ")\n[System preview available for .pdf|.docx|.xlsx|.png|.jpg|.txt files]";

    const filePreviewWindowContent = (
      <>
        {(previewFileInWindowStateIsLoadingTF) &&
          <CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
            {"Loading file '" + fileDisplayName + "' for preview..."}
          </CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
        }
        {(previewFileInWindowStateIsErrorTF) &&
          <CEGeneralReact.EmptyScreenGray>
            {"Error loading file '" + fileDisplayName + "'" + ((p_isServerFileTrueWebLinkFalse) ? ("") : ("\n" + p_serverFileLocOrWebLinkUrl)) + "\n\n" + s_loadedFileContentUint8ArrayOrErrorMessageOrUndefined}
          </CEGeneralReact.EmptyScreenGray>
        }
        {(previewFileInWindowStateIsSuccessTF) &&
          <div className="flex11a displayFlexColumn smallFullMargin border1ddd">
            <LibraryReact.UploadedFileDocumentReaderWindow
              p_fileName={fileLocFilePartsObj.fileNameAndExt}
              p_fileExtension={fileLocFilePartsObj.fileExt}
              p_mimeType={undefined}
              p_fileContent={s_loadedFileContentUint8ArrayOrErrorMessageOrUndefined}
            />
          </div>
        }
      </>
    );

    var saveButtonMessageText = undefined;
    var saveButtonMessageFontClass = undefined;
    if(previewFileInWindowStateFloatingBoxIsOpenTF) {
      if(fileNotesChangedTF) {
        saveButtonMessageText = "Unsaved changes";
        saveButtonMessageFontClass = "font09 fontItalic fontTextLighter";
      }
      if(!fileNotesChangedTF && s_fileNotesChangesSavedTF) {
        saveButtonMessageText = "Changes saved";
        saveButtonMessageFontClass = "font09 fontItalic fontGreen";
      }
    }

    return(
      <>
        {(canPreviewTF) ? (
          <div
            className={buttonClass}
            style={{width:p_buttonSizeEm + "em", height:p_buttonSizeEm + "em"}}
            title={p_buttonHoverText}
            onClick={this.onclick_view_file_preview_in_window}>
            <CEIconsReact.SvgEyeIcon p_sizeEm={buttonIconSizeEm} p_color={p_iconColor} />
          </div>
        ) : (
          <div
            className="flex00a displayFlexColumnHcVc"
            style={{width:p_buttonSizeEm + "em", height:p_buttonSizeEm + "em"}}
            title={previewNotAvailableTitle}>
            <CEIconsReact.SvgEyeWithSlashIcon p_sizeEm={buttonIconSizeEm} p_color="dddddd" />
          </div>
        )}
        {(previewFileInWindowStateFloatingBoxIsOpenTF) &&
          <CEGeneralReact.FloatingBoxWithSaveCancel
            p_trblFlag="large"
            p_title={"Previewing File '" + fileDisplayName + "'"}
            f_onClickCancel={this.onclick_close_file_preview_floating_box}>
            {(fileNotesPanelVisibleTF) ? (
              <div className="flex11a displayFlexRow overflowHidden">
                <div className="flex11a displayFlexColumn overflowHidden" style={{flexBasis:"300em", minWidth:0}}>
                  {filePreviewWindowContent}
                </div>
                <div className="flex11a displayFlexColumn borderL1ddd smallFullPad" style={{flexBasis:"100em", minWidth:0}}>
                  <div className="flex00a displayFlexRow">
                    <div className="flex00a displayFlexColumn">
                      <div className="flex00a displayFlexRowVc" style={{height:"1.2em"}}>
                        {(saveButtonMessageText !== undefined) &&
                          <LibraryReact.DivFont p_class="" p_fontClass={saveButtonMessageFontClass}>{saveButtonMessageText}</LibraryReact.DivFont>
                        }
                      </div>
                      <div className="flex11a" />
                      <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontBold fontTextLighter">{"File Notes"}</LibraryReact.DivFont>
                    </div>
                    <div className="flex11a" />
                    {(fileNotesAreEditableTF) &&
                      <div className="flex00a displayFlexColumn">
                        <CEGeneralReact.CEButton
                          p_type={((fileNotesChangedTF) ? ("blue") : ("blueDisabled"))}
                          p_text="Save Notes Changes"
                          f_onClick={this.onclick_save_changed_file_notes}
                        />
                      </div>
                    }
                  </div>
                  {(fileNotesAreEditableTF) ? (
                    <div className="flex11a displayFlexColumn">
                      <LibraryReact.Textarea
                        p_value={s_editedFileNotes}
                        p_styleObj={{width:"100%", height:"100%"}}
                        f_onChange={this.onchange_file_notes}
                      />
                    </div>
                  ) : (
                    <div className="flex11a yScroll smallFullPad">
                      {p_fileNotes}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              filePreviewWindowContent
            )}
          </CEGeneralReact.FloatingBoxWithSaveCancel>
        }
      </>
    );
  }
}

const FileEditFileInfoFloatingBox = inject("DatabaseMobx")(observer(
class FileEditFileInfoFloatingBox extends Component { //props: p_tblName, p_fileObj, p_uploadUserNameMaskPlainText, f_onClickClose
  onsave_file_display_name = (i_newValue) => { this.update_file_field("display_name", i_newValue, "s"); }
  onsave_file_file_loc = (i_newValue) => { this.update_file_field("file_loc", i_newValue, "s"); }
  onsave_file_keywords = (i_newValue) => { this.update_file_field("keywords", i_newValue, "s"); }
  onsave_file_notes = (i_newValue) => { this.update_file_field("notes", i_newValue, "s"); }
  onsave_parent_folder_id = (i_newValue) => { this.update_file_field("parent_folder_id", i_newValue, "i"); }
  onsave_file_access = (i_newValue) => { this.update_file_field("access", i_newValue, "s"); }
  onsave_file_xml_type = (i_newValue) => { this.update_file_field("xml_type", i_newValue, "s"); }

  update_file_field = (i_fieldDbName, i_newValue, i_idsb) => {
    const p_tblName = this.props.p_tblName;
    const p_fileObj = this.props.p_fileObj;

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - FileEditFileInfoFloatingBox", "update_file_field", ["i_fieldDbName", "i_newValue", "i_idsb"], [i_fieldDbName, i_newValue, i_idsb]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update(p_tblName, p_fileObj.id, i_fieldDbName, i_newValue, i_idsb);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_tblName = this.props.p_tblName;
    const p_fileObj = this.props.p_fileObj;

    const c_selectFileFolderSystemFileAccessFieldTypeObj = this.props.DatabaseMobx.c_selectFileFolderSystemFileAccessFieldTypeObj;
    const c_selectFileFolderSystemXmlTypeFieldTypeObj = this.props.DatabaseMobx.c_selectFileFolderSystemXmlTypeFieldTypeObj;

    const containerClass = "tbMargin";
    const fieldClass = "fontBlue";
    const fieldWidth = "10em";
    const parentFolderColor = "f4eef8";

    //build a selectWithSearchDataObj for selecting a parent folder
    var parentFolderValueArray = [-1];
    var parentFolderDisplayArray = ["<<Top Level>>"];
    var parentFolderTreeIDArray = ["00"];
    var parentFolderColorArray = [parentFolderColor];
    const tblRefMapOfMaps = this.props.DatabaseMobx.tbl_ref_from_tbl_name(p_tblName);
    const allFoldersArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(tblRefMapOfMaps, "folder0_file1", 0, "display_name", true, true);
    const orderedFolderIDsArray = JSFUNC.recursive_array_of_ids_under_node_in_tree(allFoldersArrayOfObjs, "parent_folder_id", -1);
    for(let folderID of orderedFolderIDsArray) {
      var folderNamesFromTopToNodeArray = JSFUNC.tree_field_array_from_top_to_node(allFoldersArrayOfObjs, "parent_folder_id", folderID, "display_name");
      if(JSFUNC.is_array(folderNamesFromTopToNodeArray)) {
        var numFoldersFromTop = folderNamesFromTopToNodeArray.length;
        if(numFoldersFromTop > 0) {
          var folderName = folderNamesFromTopToNodeArray[(numFoldersFromTop - 1)];
          var treeIDString = "00";
          for(let t = 0; t < numFoldersFromTop; t++) {
            treeIDString += "00";
          }
          parentFolderValueArray.push(folderID);
          parentFolderDisplayArray.push(folderName);
          parentFolderTreeIDArray.push(treeIDString);
          parentFolderColorArray.push(parentFolderColor);
        }
      }
    }
    const swsOptionsObj = {treeIDArray:parentFolderTreeIDArray, colorArray:parentFolderColorArray};
    const parentFolderSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Parent Folder", parentFolderValueArray, true, parentFolderDisplayArray, swsOptionsObj);
    const selectParentFolderFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", parentFolderSwsDataObj);

    //if the file extensions is '.xml' display the field 'xml_type' for editing
    const fileLocFilePartsObj = JSFUNC.file_parts_obj(p_fileObj.file_loc);
    const fileExtIsXmlTF = (fileLocFilePartsObj.fileExt === "xml");

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditItem"
        p_title={"Editing Info for File '" + p_fileObj.display_name + "'"}
        f_onClickSave={this.props.f_onClickClose}>
        <div className="flex11a yScroll medFullPad">
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"ffs_" + p_tblName + "fileID" + p_fileObj.id + "_parent_folder_id"}
            p_fieldDisplayName="Parent Folder"
            p_fieldTypeObj={selectParentFolderFieldTypeObj}
            p_valueRaw={p_fileObj.parent_folder_id}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            f_onSaveChanged={this.onsave_parent_folder_id}
          />
          <div className="medTopMargin medBottomMargin borderT1ddd" />
          {(p_fileObj.isOnlineLinkTF) &&
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString={"ffs_" + p_tblName + "fileID" + p_fileObj.id + "_file_loc"}
              p_fieldDisplayName="Online Link URL"
              p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
              p_valueRaw={p_fileObj.file_loc}
              p_valueIsEditableTFU={true}
              p_containerClass={containerClass}
              p_fieldClass={fieldClass}
              p_fieldWidth={fieldWidth}
              f_onSaveChanged={this.onsave_file_file_loc}
            />
          }
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"ffs_" + p_tblName + "fileID" + p_fileObj.id + "_display_name"}
            p_fieldDisplayName="File Name"
            p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
            p_valueRaw={p_fileObj.display_name}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            f_onSaveChanged={this.onsave_file_display_name}
          />
          {(fileExtIsXmlTF) &&
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString={"ffs_" + p_tblName + "fileID" + p_fileObj.id + "_xml_type"}
              p_fieldDisplayName="XML File Type"
              p_fieldTypeObj={c_selectFileFolderSystemXmlTypeFieldTypeObj}
              p_valueRaw={p_fileObj.xml_type}
              p_valueIsEditableTFU={true}
              p_containerClass={containerClass}
              p_fieldClass={fieldClass}
              p_fieldWidth={fieldWidth}
              f_onSaveChanged={this.onsave_file_xml_type}
            />
          }
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"ffs_" + p_tblName + "fileID" + p_fileObj.id + "_keywords"}
            p_fieldDisplayName="Search Keywords"
            p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
            p_valueRaw={p_fileObj.keywords}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            f_onSaveChanged={this.onsave_file_keywords}
          />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"ffs_" + p_tblName + "fileID" + p_fileObj.id + "_notes"}
            p_fieldDisplayName="Description/Notes"
            p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextareaFieldTypeObj}
            p_valueRaw={p_fileObj.notes}
            p_valueIsEditableTFU={true}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
            p_floatingBoxTitle={"Description/Notes for file '" + p_fileObj.display_name + "'"}
            f_onSaveChanged={this.onsave_file_notes}
          />
          {(false) &&
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString={"ffs_" + p_tblName + "fileID" + p_fileObj.id + "_access"}
              p_fieldDisplayName="Access"
              p_fieldTypeObj={c_selectFileFolderSystemFileAccessFieldTypeObj}
              p_valueRaw={"open"}
              p_valueIsEditableTFU={true}
              p_containerClass={containerClass}
              p_fieldClass={fieldClass}
              p_fieldWidth={fieldWidth}
              f_onSaveChanged={this.onsave_file_access}
            />
          }
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"ffs_" + p_tblName + "fileID" + p_fileObj.id + "_upload_date"}
            p_fieldDisplayName="Upload Date"
            p_fieldTypeObj={this.props.DatabaseMobx.c_genericDateFieldTypeObj}
            p_valueRaw={p_fileObj.upload_date}
            p_valueIsEditableTFU={false}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
          />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"ffs_" + p_tblName + "fileID" + p_fileObj.id + "_upload_user_name"}
            p_fieldDisplayName="Uploaded By"
            p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
            p_valueRaw={this.props.p_uploadUserNameMaskPlainText}
            p_valueIsEditableTFU={false}
            p_containerClass={containerClass}
            p_fieldClass={fieldClass}
            p_fieldWidth={fieldWidth}
          />
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));



const FileFolderSystemUploadFilesButtonDropZone = inject("CaptureExecMobx", "UserMobx")(observer(
class FileFolderSystemUploadFilesButtonDropZone extends Component { //props: p_tblName, p_subfoldersPath, p_tblFilterFieldNamesArray, p_tblFilterValuesArray, p_parentFolderID, p_defaultXmlType, p_allowedExtsArray, f_onPerformFFSAction(i_successFilesArrayOfObjs)
  //f_onPerformFFSAction(i_actionText, i_descriptionText)

  constructor(props) {
    super(props);
    this.state = {
      s_uploadState: "initial", //"initial", "uploading", "postUploadFloatingBox"
      s_totalNumFilesToUpload: 0,
      s_currentFileNumberUploading: 0,
      s_currentFileDisplayNameAndExtUploading: "",
      s_successFilesArrayOfObjs: [],
      s_badExtFilesArrayOfObjs: [],
      s_errorFilesArrayOfObjs: []
    };
  }

  ondrop_upload_files = (i_dataTransferFilesArray) => {
    const tblName = this.props.p_tblName;
    const foldersPathFromCompanyUploadsFolder = this.props.p_subfoldersPath;
    const tblFilterFieldNamesArray = this.props.p_tblFilterFieldNamesArray;
    const tblFilterValuesArray = this.props.p_tblFilterValuesArray;
    const parentFolderID = this.props.p_parentFolderID;
    const defaultXmlType = this.props.p_defaultXmlType;
    const p_allowedExtsArray = this.props.p_allowedExtsArray;

    //determine the number of files to upload
    const maxNumFilesUploadLimit = 100; //limit the maximum number of files to be simultaneously uploaded to 100
    const numFilesAttemptingToUpload = i_dataTransferFilesArray.length;

    //initialize inputs to the recursive function call
    const initialTotalNumFilesToUpload = ((numFilesAttemptingToUpload > maxNumFilesUploadLimit) ? (maxNumFilesUploadLimit) : (numFilesAttemptingToUpload));
    const initialCurrentFileNumberUploading = 1;
    const initialCurrentFileDisplayNameAndExtUploading = "";
    const initialSuccessFilesArrayOfObjs = [];
    const initialBadExtFilesArrayOfObjs = [];
    const initialErrorFilesArrayOfObjs = [];

    //set the button to the uploading state where it can't be pushed
    this.setState({
      s_uploadState: "uploading",
      s_totalNumFilesToUpload: initialTotalNumFilesToUpload,
      s_currentFileNumberUploading: initialCurrentFileNumberUploading,
      s_currentFileDisplayNameAndExtUploading: initialCurrentFileDisplayNameAndExtUploading,
      s_successFilesArrayOfObjs: initialSuccessFilesArrayOfObjs,
      s_badExtFilesArrayOfObjs: initialBadExtFilesArrayOfObjs,
      s_errorFilesArrayOfObjs: initialErrorFilesArrayOfObjs
    });

    //get the date/time for this upload
    const uploadDate = JSFUNC.now_dateYmd();
    const uploadDateTimeNumber = JSFUNC.now_datetime_utc_number();

    //begin the recursive call to upload all files
    this.recursive_upload_single_file(i_dataTransferFilesArray, uploadDate, uploadDateTimeNumber, initialTotalNumFilesToUpload, initialCurrentFileNumberUploading, initialSuccessFilesArrayOfObjs, initialBadExtFilesArrayOfObjs, initialErrorFilesArrayOfObjs);
  }

  recursive_upload_single_file = (i_dataTransferFilesArray, i_uploadDate, i_uploadDateTimeNumber, i_totalNumFilesToUpload, i_currentFileNumberUploading, i_successFilesArrayOfObjs, i_badExtFilesArrayOfObjs, i_errorFilesArrayOfObjs) => {
    const tblName = this.props.p_tblName;
    const foldersPathFromCompanyUploadsFolder = this.props.p_subfoldersPath;
    const tblFilterFieldNamesArray = this.props.p_tblFilterFieldNamesArray;
    const tblFilterValuesArray = this.props.p_tblFilterValuesArray;
    const parentFolderID = this.props.p_parentFolderID;
    const defaultXmlType = this.props.p_defaultXmlType;
    const p_allowedExtsArray = this.props.p_allowedExtsArray;

    const uploadUserID = this.props.UserMobx.o_userID;
    const uploadUserName = this.props.UserMobx.c_userName;

    if((i_totalNumFilesToUpload === 0) || (i_currentFileNumberUploading > i_totalNumFilesToUpload)) { //recursive function is finished uploading all files, call the final input function
      this.after_recursive_uploads_change_upload_state_to_post_uploads_floating_box(i_successFilesArrayOfObjs, i_badExtFilesArrayOfObjs, i_errorFilesArrayOfObjs);
    }
    else { //upload this recursive file
      var updatedCurrentFileNumberUploading = (i_currentFileNumberUploading + 1); //increment the file number for the next recursive call of this function (i_currentFileNumberUploading is used throughout this iteration)
      var updatedSuccessFilesArrayOfObjs = i_successFilesArrayOfObjs;
      var updatedBadExtFilesArrayOfObjs = i_badExtFilesArrayOfObjs;
      var updatedErrorFilesArrayOfObjs = i_errorFilesArrayOfObjs;

      //index the fileDataTransferArray to get the file data obj, file count number is 1 ahead of data transfer array file index
      const dataTransferFileObj = i_dataTransferFilesArray[(i_currentFileNumberUploading - 1)];

      if(dataTransferFileObj === undefined) { //if the file transfer data obj does not have a 'name' property, list this file has an error
        this.setState({
          s_currentFileNumberUploading: i_currentFileNumberUploading,
          s_currentFileDisplayNameAndExtUploading: "[Invalid File Transfer Data from Uploaded Files List]"
        });

        updatedErrorFilesArrayOfObjs = updatedErrorFilesArrayOfObjs.concat(["Invalid File Transfer Data from Uploaded Files List [File #" + i_currentFileNumberUploading + "]"]);
        this.recursive_upload_single_file(i_dataTransferFilesArray, i_uploadDate, i_uploadDateTimeNumber, i_totalNumFilesToUpload, updatedCurrentFileNumberUploading, updatedSuccessFilesArrayOfObjs, updatedBadExtFilesArrayOfObjs, updatedErrorFilesArrayOfObjs);
      }
      else { //file data transfer obj is valid
        var currentFileDisplayNameAndExtUploading = dataTransferFileObj.name;

        //mark the state that this next file number is currently being worked on
        this.setState({
          s_currentFileNumberUploading: i_currentFileNumberUploading,
          s_currentFileDisplayNameAndExtUploading: currentFileDisplayNameAndExtUploading
        });

        //break down the file given "File Display Name.ext" into its file parts
        const filePartsObj = JSFUNC.file_parts_obj(currentFileDisplayNameAndExtUploading);
        const fileDisplayName = filePartsObj.fileName; //"File Display Name"
        const fileExt = filePartsObj.fileExt; //"ext"

        const fileExtIsValidTF = (JSFUNC.is_string(fileExt) && (fileExt.length > 0)); //the uploaded file must have an extension with at least 1 letter in it to be uploaded, otherwise an error is recorded for this file
        const fileExtIsAllowedTF = (!JSFUNC.is_array(p_allowedExtsArray) || (JSFUNC.in_array(fileExt, p_allowedExtsArray))); //if p_allowedExtsArray is not provided, all exts are allowed, if it is an array, make sure that this fileExt is within that list

        //when uploading multiple files, each one must have a unique name, if not, the first one is uploaded, but all duplicates are errors
        const alreadyUploadedIdenticalDisplayNameFileObj = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(updatedSuccessFilesArrayOfObjs, "fileDisplayNameAndExt", currentFileDisplayNameAndExtUploading);
        const fileDisplayNameAndExtIsUniqueTF = (alreadyUploadedIdenticalDisplayNameFileObj === undefined);

        if(!fileExtIsValidTF) { //no ext is a bad ext
          updatedBadExtFilesArrayOfObjs.push({fileDisplayNameAndExt:currentFileDisplayNameAndExtUploading, errorMessage:"No File Extension for this file"});
          this.recursive_upload_single_file(i_dataTransferFilesArray, i_uploadDate, i_uploadDateTimeNumber, i_totalNumFilesToUpload, updatedCurrentFileNumberUploading, updatedSuccessFilesArrayOfObjs, updatedBadExtFilesArrayOfObjs, updatedErrorFilesArrayOfObjs);
        }
        else if(!fileExtIsAllowedTF) { //ext not allowed is a bad ext
          updatedBadExtFilesArrayOfObjs.push({fileDisplayNameAndExt:currentFileDisplayNameAndExtUploading, errorMessage:"File Extension '." + fileExt + "' not allowed for upload here"});
          this.recursive_upload_single_file(i_dataTransferFilesArray, i_uploadDate, i_uploadDateTimeNumber, i_totalNumFilesToUpload, updatedCurrentFileNumberUploading, updatedSuccessFilesArrayOfObjs, updatedBadExtFilesArrayOfObjs, updatedErrorFilesArrayOfObjs);
        }
        else if(!fileDisplayNameAndExtIsUniqueTF) { //duplicate file name is a bad ext
          updatedErrorFilesArrayOfObjs.push({fileDisplayNameAndExt:currentFileDisplayNameAndExtUploading, errorMessage:"File Name is not unique within this multi-upload"});
          this.recursive_upload_single_file(i_dataTransferFilesArray, i_uploadDate, i_uploadDateTimeNumber, i_totalNumFilesToUpload, updatedCurrentFileNumberUploading, updatedSuccessFilesArrayOfObjs, updatedBadExtFilesArrayOfObjs, updatedErrorFilesArrayOfObjs);
        }
        else {
          const jsDescription = "CEGeneralReact - FileFolderSystemUploadFilesButtonDropZone - recursive_upload_single_file";
          const C_CallPhpTblUIDFileUpload = new JSPHP.ClassCallPhpTblUID(jsDescription);

          //create the server file name based on the uploaded file name lowercase and underscored (shorten it if it is too long) along with a starting timestamp so that the name is unique in the folder
          const maxServerFileNameNumChars = 64; //arbitrarily make 64 characters the maximum length for the file name part of the file stored on the server (display name stored in the table can be unlimited length)
          const fileDbName = JSFUNC.db_name_from_display_name(fileDisplayName); //"file_display_name"
          const fileDbNameTrim = JSFUNC.trim_string_max_chars(fileDbName, maxServerFileNameNumChars); //"file_display_name"
          const fileDbNameTrimTimeStampExt = i_uploadDateTimeNumber + "_" + fileDbNameTrim + "." + fileExt; //"20180415113259_file_display_name.ext"

          //upload the file to the server through php xhr in tblUID operation
          C_CallPhpTblUIDFileUpload.add_file_upload(dataTransferFileObj, foldersPathFromCompanyUploadsFolder, fileDbNameTrimTimeStampExt);

          //when file successfully uploads, send another db php to insert the ffs tbl record for this file, then call the next recursion
          const functionOnSuccessFileUpload = (i_parseResponse) => {
            if(i_parseResponse.outputObj.fu0 !== "1") { //error uploading file
              updatedErrorFilesArrayOfObjs.push({fileDisplayNameAndExt:currentFileDisplayNameAndExtUploading, errorMessage:"Failed to upload file to server"});
              this.recursive_upload_single_file(i_dataTransferFilesArray, i_uploadDate, i_uploadDateTimeNumber, i_totalNumFilesToUpload, updatedCurrentFileNumberUploading, updatedSuccessFilesArrayOfObjs, updatedBadExtFilesArrayOfObjs, updatedErrorFilesArrayOfObjs);
            }
            else { //successful file upload
              const C_CallPhpTblUIDInsertFfsRecord = new JSPHP.ClassCallPhpTblUID("CEGeneralReact - FileFolderSystemUploadFilesButtonDropZone - recursive_upload_single_file - functionOnSuccess");

              //create the file_loc name for the file path on the server
              const fileLoc = foldersPathFromCompanyUploadsFolder + "/" + fileDbNameTrimTimeStampExt;

              //create the tbl filter values idsb array of all "i" for each filter field
              const tblFilterValuesIdsbArray = JSFUNC.array_fill(tblFilterFieldNamesArray.length, "i");

              //create the insert entry for the filefoldersystem keeping a record of this uploaded file
              const ffsFieldNamesArray = tblFilterFieldNamesArray.concat(["folder0_file1", "parent_folder_id", "fileupload0_onlinelink1", "file_loc", "display_name", "keywords", "notes", "content_unique_lowercase", "upload_date", "upload_user_id", "upload_user_name", "access", "xml_type"]);
              const ffsValuesArray = tblFilterValuesArray.concat([1, parentFolderID, 0, fileLoc, currentFileDisplayNameAndExtUploading, "", "", "", i_uploadDate, uploadUserID, uploadUserName, "open", defaultXmlType]);
              const ffsValueIdsbArray = tblFilterValuesIdsbArray.concat(["i", "i", "i", "s", "s", "s", "s", "s", "s", "i", "s", "s", "s"]);
              C_CallPhpTblUIDInsertFfsRecord.add_insert(tblName, ffsFieldNamesArray, ffsValuesArray, ffsValueIdsbArray);

              //when the ffs record is successfully inserted, record this file name as a successful upload in the state of this component
              const functionOnSuccessInsertFfsRecord = (i_parseResponse) => {
                const ffsTblRowID = i_parseResponse.outputObj.i0;
                if(!(ffsTblRowID > 0)) { //error inserting ffs record in database
                  updatedErrorFilesArrayOfObjs.push({fileDisplayNameAndExt:currentFileDisplayNameAndExtUploading, errorMessage:"Failed to record file upload record"});
                }
                else {
                  updatedSuccessFilesArrayOfObjs.push({
                    fileDisplayNameAndExt: currentFileDisplayNameAndExtUploading,
                    ffsTblRowID: ffsTblRowID,
                    fileLoc: fileDbNameTrimTimeStampExt,
                    fileExt: fileExt,
                    isXmlTF: (fileExt === "xml"),
                    xmlType: defaultXmlType
                  });
                }
                this.recursive_upload_single_file(i_dataTransferFilesArray, i_uploadDate, i_uploadDateTimeNumber, i_totalNumFilesToUpload, updatedCurrentFileNumberUploading, updatedSuccessFilesArrayOfObjs, updatedBadExtFilesArrayOfObjs, updatedErrorFilesArrayOfObjs);
              }
              C_CallPhpTblUIDInsertFfsRecord.add_function("onSuccess", functionOnSuccessInsertFfsRecord);

              //if there is an error recording the ffs data row, mark this upload as an error (leave the file abandoned on the server if this happens)
              const functionOnErrorInsertFfsRecord = () => {
                updatedErrorFilesArrayOfObjs.push({fileDisplayNameAndExt:currentFileDisplayNameAndExtUploading, errorMessage:"Failed to record file upload record"});
                this.recursive_upload_single_file(i_dataTransferFilesArray, i_uploadDate, i_uploadDateTimeNumber, i_totalNumFilesToUpload, updatedCurrentFileNumberUploading, updatedSuccessFilesArrayOfObjs, updatedBadExtFilesArrayOfObjs, updatedErrorFilesArrayOfObjs);
              }
              C_CallPhpTblUIDInsertFfsRecord.add_function("onError", functionOnErrorInsertFfsRecord);

              C_CallPhpTblUIDInsertFfsRecord.execute();
            }
          }
          C_CallPhpTblUIDFileUpload.add_function("onSuccess", functionOnSuccessFileUpload);

          const functionOnErrorFileUpload = () => {
            updatedErrorFilesArrayOfObjs.push({fileDisplayNameAndExt:currentFileDisplayNameAndExtUploading, errorMessage:"Failed to upload file to server"});
            this.recursive_upload_single_file(i_dataTransferFilesArray, i_uploadDate, i_uploadDateTimeNumber, i_totalNumFilesToUpload, updatedCurrentFileNumberUploading, updatedSuccessFilesArrayOfObjs, updatedBadExtFilesArrayOfObjs, updatedErrorFilesArrayOfObjs);
          }
          C_CallPhpTblUIDFileUpload.add_function("onError", functionOnErrorFileUpload);

          C_CallPhpTblUIDFileUpload.execute();
        }
      }
    }
  }

  after_recursive_uploads_change_upload_state_to_post_uploads_floating_box = (i_successFilesArrayOfObjs, i_badExtFilesArrayOfObjs, i_errorFilesArrayOfObjs) => {
    const p_tblName = this.props.p_tblName;
    const p_tblFilterFieldNamesArray = this.props.p_tblFilterFieldNamesArray;
    const p_tblFilterValuesArray = this.props.p_tblFilterValuesArray;

    const numSuccessFiles = i_successFilesArrayOfObjs.length;
    const numBadExtFiles = i_badExtFilesArrayOfObjs.length;
    const numErrorFiles = i_errorFilesArrayOfObjs.length;

    if(numSuccessFiles > 0) { //at the very end of uploading, if at least 1 file was successfully uploaded, call the input function f_onPerformFFSAction
      if(JSFUNC.is_function(this.props.f_onPerformFFSAction)) {
        //create successful file(s) upload text string
        var actionText = "";
        var descriptionText = "";
        if(numSuccessFiles === 1) {
          actionText = "Upload File";
          descriptionText = "Uploaded File '" + i_successFilesArrayOfObjs[0].fileDisplayNameAndExt + "'";
        }
        else {
          actionText = "Upload Files";
          descriptionText = "Uploaded " + numSuccessFiles + " " + JSFUNC.plural(numSuccessFiles, "File", "Files");
          for(let successFileObj of i_successFilesArrayOfObjs) {
            descriptionText += "\n - " + successFileObj.fileDisplayNameAndExt;
          }
        }
        this.props.f_onPerformFFSAction(actionText, descriptionText);
      }
    }

    //send BIT an error message when files have errors
    if(numBadExtFiles || numErrorFiles) {

      var errorMessage = "FFS tblName: " + p_tblName;
      errorMessage += "\ntblFilterFieldNamesArray: " + JSFUNC.print_array(p_tblFilterFieldNamesArray);
      errorMessage += "\ntblFilterValuesArray: " + JSFUNC.print_array(p_tblFilterValuesArray);
      for(let badExtFileObj of i_badExtFilesArrayOfObjs) {
        errorMessage += "\nBadExt File: '" + badExtFileObj.fileDisplayNameAndExt + "' [" + badExtFileObj.errorMessage + "]";
      }
      for(let errorFileObj of i_errorFilesArrayOfObjs) {
        errorMessage += "\nError File: '" + errorFileObj.fileDisplayNameAndExt + "' [" + errorFileObj.errorMessage + "]";
      }
      JSPHP.record_z_error(undefined, errorMessage);
    }

    this.setState({
      s_uploadState: "postUploadFloatingBox",
      s_successFilesArrayOfObjs: i_successFilesArrayOfObjs,
      s_badExtFilesArrayOfObjs: i_badExtFilesArrayOfObjs,
      s_errorFilesArrayOfObjs: i_errorFilesArrayOfObjs
    });
  }

  reset_upload_state_to_initial = () => {
    this.setState({
      s_uploadState: "initial",
      s_totalNumFilesToUpload: 0,
      s_currentFileNumberUploading: 0,
      s_currentFileDisplayNameAndExtUploading: "",
      s_successFilesArrayOfObjs: [],
      s_badExtFilesArrayOfObjs: [],
      s_errorFilesArrayOfObjs: []
    });
  }

  render() {
    const uploadState = this.state.s_uploadState;
    const totalNumFilesToUpload = this.state.s_totalNumFilesToUpload;
    const currentFileNumberUploading = this.state.s_currentFileNumberUploading;
    const currentFileDisplayNameAndExtUploading = this.state.s_currentFileDisplayNameAndExtUploading;
    const successFilesArrayOfObjs = this.state.s_successFilesArrayOfObjs;
    const badExtFilesArrayOfObjs = this.state.s_badExtFilesArrayOfObjs;
    const errorFilesArrayOfObjs = this.state.s_errorFilesArrayOfObjs;

    const tblName = this.props.p_tblName;
    const foldersPathFromCompanyUploadsFolder = this.props.p_subfoldersPath;
    const tblFilterFieldNamesArray = this.props.p_tblFilterFieldNamesArray;
    const tblFilterValuesArray = this.props.p_tblFilterValuesArray;
    const parentFolderID = this.props.p_parentFolderID;
    const defaultXmlType = this.props.p_defaultXmlType;
    const p_allowedExtsArray = this.props.p_allowedExtsArray;

    const isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;

    var isWorkingTF = false; //uploader becomes busy while uploading, preventing drops or uploads until it is finished
    var displayText = undefined;
    if(uploadState === "uploading") {
      isWorkingTF = true;
      displayText = "Uploading File " + currentFileNumberUploading + " of " + totalNumFilesToUpload + "\n" + currentFileDisplayNameAndExtUploading;
    }
    else { //"initial"
      displayText = ((isMobileOrTabletTF) ? ("Tap to\nUpload Files") : ("Click or Drag\nFiles to Upload"));
    }

    return(
      <>
        <CEGeneralReact.CEDropZone
          p_width="17em"
          p_heightEm={3.8}
          p_allowDropTF={true}
          p_uniqueString="ffsDropZone"
          p_fileUploadIsProcessingTF={isWorkingTF}
          p_message={displayText}
          p_dragOverMatchingItemMessage="Drop File(s) to Upload"
          f_onDropFiles={this.ondrop_upload_files}
        />
        {(uploadState === "postUploadFloatingBox") &&
          <FileFolderSystemUploadFilesPostUploadFloatingBox
            p_tblName={tblName}
            p_allowedExtsArray={p_allowedExtsArray}
            p_successFilesArrayOfObjs={successFilesArrayOfObjs}
            p_badExtFilesArrayOfObjs={badExtFilesArrayOfObjs}
            p_errorFilesArrayOfObjs={errorFilesArrayOfObjs}
            f_onClickClose={this.reset_upload_state_to_initial}
          />
        }
      </>
    );
  }
}));


const FileFolderSystemUploadFilesPostUploadFloatingBox = inject("DatabaseMobx")(observer(
class FileFolderSystemUploadFilesPostUploadFloatingBox extends Component { //props: p_tblName, p_allowedExtsArray, p_successFilesArrayOfObjs, p_badExtFilesArrayOfObjs, p_errorFilesArrayOfObjs, f_onClickClose
  constructor(props) {
    super(props);

    const successFilesArrayOfObjs = this.props.p_successFilesArrayOfObjs;
    const numSuccessFiles = successFilesArrayOfObjs.length;

    const initialSameKeywordsTab = ((numSuccessFiles > 1) ? ("same") : ("unique")); //default is use same keywords for multiple files, but manual entry for just one file

    this.state = {
      s_sameKeywordsTab: initialSameKeywordsTab,
      s_sameKeywordsText: "",
      s_successFilesDisplayNamesArray: JSFUNC.get_column_vector_from_arrayOfObjs(successFilesArrayOfObjs, "fileDisplayNameAndExt"),
      s_successFilesKeywordsArray: JSFUNC.array_fill(numSuccessFiles, ""),
      s_successFilesDescriptionsArray: JSFUNC.array_fill(numSuccessFiles, "")
    };
  }

  onselect_same_keywords_tab = (i_selectedTabDbName) => {
    const successFilesArrayOfObjs = this.props.p_successFilesArrayOfObjs;

    const allFilesKeywords = ((i_selectedTabDbName === "unique") ? (this.state.s_sameKeywordsText) : ("")); //copy the top keywords to every individual file if switching to the unique tab
    const updatedSuccessFilesKeywordsArray = JSFUNC.array_fill(successFilesArrayOfObjs.length, allFilesKeywords)
    this.setState({
      s_sameKeywordsTab: i_selectedTabDbName,
      s_sameKeywordsText: "",
      s_successFilesKeywordsArray: updatedSuccessFilesKeywordsArray
    });
  }

  onchange_same_keywords_text = (i_newValue) => {
    this.setState({s_sameKeywordsText:i_newValue});
  }

  onchange_file_local_display_name = (i_fileIndex, i_newValue) => {
    var updatedSuccessFilesDisplayNamesArray = this.state.s_successFilesDisplayNamesArray;
    updatedSuccessFilesDisplayNamesArray[i_fileIndex] = i_newValue;
    this.setState({s_successFilesDisplayNamesArray:updatedSuccessFilesDisplayNamesArray});
  }

  onchange_file_local_keywords = (i_fileIndex, i_newValue) => {
    var updatedSuccessFilesKeywordsArray = this.state.s_successFilesKeywordsArray;
    updatedSuccessFilesKeywordsArray[i_fileIndex] = i_newValue;
    this.setState({s_successFilesKeywordsArray:updatedSuccessFilesKeywordsArray});
  }

  onchange_file_local_description = (i_fileIndex, i_newValue) => {
    var updatedSuccessFilesDescriptionsArray = this.state.s_successFilesDescriptionsArray;
    updatedSuccessFilesDescriptionsArray[i_fileIndex] = i_newValue;
    this.setState({s_successFilesDescriptionsArray:updatedSuccessFilesDescriptionsArray});
  }

  onclick_save_keywords_and_descriptions = () => {
    const sameKeywordsTab = this.state.s_sameKeywordsTab;
    const sameKeywordsText = this.state.s_sameKeywordsText;
    const successFilesDisplayNamesArray = this.state.s_successFilesDisplayNamesArray;
    const successFilesKeywordsArray = this.state.s_successFilesKeywordsArray;
    const successFilesDescriptionsArray = this.state.s_successFilesDescriptionsArray;

    const tblName = this.props.p_tblName;
    const successFilesArrayOfObjs = this.props.p_successFilesArrayOfObjs;

    const filesUseUniqueKeywordsTF = (sameKeywordsTab === "unique");
    const numSuccessFiles = successFilesArrayOfObjs.length;

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - FileFolderSystemUploadFilesPostUploadFloatingBox", "onclick_save_keywords_and_descriptions", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    for(let s = 0; s < numSuccessFiles; s++) {
      var successFileObj = successFilesArrayOfObjs[s];

      var fileKeywords = ((filesUseUniqueKeywordsTF) ? (successFilesKeywordsArray[s]) : (sameKeywordsText));

      var fieldNamesArray = ["display_name", "keywords", "notes"];
      var valuesArray = [successFilesDisplayNamesArray[s], fileKeywords, successFilesDescriptionsArray[s]];
      var idsbArray = ["s", "s", "s"];
      C_CallPhpTblUID.add_update(tblName, successFileObj.ffsTblRowID, fieldNamesArray, valuesArray, idsbArray);
    }
    C_CallPhpTblUID.execute();

    if(JSFUNC.is_function(this.props.f_onClickClose)) {
      this.props.f_onClickClose();
    }
  }

  render() {
    const sameKeywordsTab = this.state.s_sameKeywordsTab;
    const sameKeywordsText = this.state.s_sameKeywordsText;
    const successFilesDisplayNamesArray = this.state.s_successFilesDisplayNamesArray;
    const successFilesKeywordsArray = this.state.s_successFilesKeywordsArray;
    const successFilesDescriptionsArray = this.state.s_successFilesDescriptionsArray;

    const tblName = this.props.p_tblName;
    const p_allowedExtsArray = this.props.p_allowedExtsArray;
    const successFilesArrayOfObjs = this.props.p_successFilesArrayOfObjs;
    const badExtFilesArrayOfObjs = this.props.p_badExtFilesArrayOfObjs;
    const errorFilesArrayOfObjs = this.props.p_errorFilesArrayOfObjs;

    const numSuccessFiles = successFilesArrayOfObjs.length;
    const numBadExtFiles = badExtFilesArrayOfObjs.length;
    const numErrorFiles = errorFilesArrayOfObjs.length;

    const filesUseUniqueKeywordsTF = (sameKeywordsTab === "unique");

    var successMessage = "";
    if((numSuccessFiles === 0) && (numBadExtFiles === 0) && (numErrorFiles === 0)) {
      successMessage = "No Files Uploaded";
    }
    else {
      successMessage = "Successfully Uploaded " + numSuccessFiles + " " + JSFUNC.plural(numSuccessFiles, "File", "Files");
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="medium"
        p_title="Uploaded File(s) Keywords/Descriptions"
        f_onClickSave={this.onclick_save_keywords_and_descriptions}>
        <div className="flex11a yScroll medFullPad">
          {(numErrorFiles > 0) &&
            <div className="hugeBottomMargin lrMedMargin medFullPad border borderColorRed">
              <div className="smallBottomMargin">
                <font className="font11 fontBold fontRed">
                  {numErrorFiles + " " + JSFUNC.plural(numErrorFiles, "File was", "Files were") + " unsuccessful uploading to the server. Please note there is a 75MB size limit per file, otherwise note the file " + JSFUNC.plural(numErrorFiles, "name", "names") + " listed below and try reuploading:"}
                </font>
              </div>
              {errorFilesArrayOfObjs.map((m_errorFileObj) =>
                <div className="smallBottomMargin lrMedPad">
                  <font className="font11 fontRed">
                    {" - " + m_errorFileObj.fileDisplayNameAndExt + " [" + m_errorFileObj.errorMessage + "]"}
                  </font>
                </div>
              )}
            </div>
          }
          {(numBadExtFiles > 0) &&
            <div className="hugeBottomMargin lrMedMargin medFullPad border1bbb">
              <div className="smallBottomMargin">
                <font className="font11 fontBold fontDarkOrange">
                  {numBadExtFiles + " " + JSFUNC.plural(numBadExtFiles, "File was not uploaded because of an issue with its file name or extension:", "Files were not uploaded because of issues with their file names or extensions:")}
                </font>
              </div>
              {badExtFilesArrayOfObjs.map((m_badExtFileObj) =>
                <div className="smallBottomMargin lrMedPad">
                  <font className="font11 fontDarkOrange">
                    {" - " + m_badExtFileObj.fileDisplayNameAndExt + " [" + m_badExtFileObj.errorMessage + "]"}
                  </font>
                </div>
              )}
              {(JSFUNC.is_array(p_allowedExtsArray)) &&
                <div className="smallBottomMargin">
                  <font className="font11 fontBold fontDarkOrange">
                    {"Allowed Extensions: [" + JSFUNC.convert_array_to_display_comma_list_different_left_right(p_allowedExtsArray, "'.", "'") + "]"}
                  </font>
                </div>
              }
            </div>
          }
          <div className="medBottomMargin textCenter">
            <font className="font18 fontBold fontTextLight">
              {successMessage}
            </font>
          </div>
          {(numSuccessFiles > 1) &&
            <div className="displayFlexColumnHcVc medBottomMargin">
              <div className="flex00a medFullPad border bgLightGray" style={{width:"70%", borderColor:"#999"}}>
                <div className="displayFlexColumnHcVc smallFullPad">
                  <CEGeneralReact.TabsList
                    p_tabDbNamesArray={["same", "unique"]}
                    p_tabDisplayNamesArray={["Use Same Keywords for all Files", "Enter Unique Keywords"]}
                    p_selectedTabDbName={sameKeywordsTab}
                    p_tabHeight="2.7em"
                    p_textMaxHeight="2.4em"
                    p_tabWidth="17em"
                    p_selectedBgClass="bgGoldGradient"
                    p_selectedFontClass=""
                    p_unselectedBgClass="bgLighterGray"
                    p_unselectedFontClass="fontTextLighter"
                    p_rowFlexWrapTF={true}
                    f_onSelect={this.onselect_same_keywords_tab}
                  />
                </div>
                {(sameKeywordsTab === "same") &&
                  <div className="displayFlexRowVc smallTopMargin">
                    <div className="flex00a" style={{flexBasis:"8em"}}>
                      <font className="">
                        {"Keywords applied to every file"}
                      </font>
                    </div>
                    <div className="flex11a displayFlexColumn lrMedPad">
                      <LibraryReact.Text
                        p_value={sameKeywordsText}
                        p_style={{width:"100%"}}
                        p_tabIndex={1}
                        f_onChange={this.onchange_same_keywords_text}
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          {successFilesArrayOfObjs.map((m_successFileObj, m_index) =>
            <>
              {(m_index > 0) &&
                <div className="bigTopMargin bigBottomMargin lrMedMargin borderT1ddd" />
              }
              <FileFolderSystemUploadFilesPostUploadFloatingBoxSuccessFileRow
                p_fileIndex={m_index}
                p_successFileObj={m_successFileObj}
                p_localDisplayName={successFilesDisplayNamesArray[m_index]}
                p_localKeywords={successFilesKeywordsArray[m_index]}
                p_localDescription={successFilesDescriptionsArray[m_index]}
                p_tblName={tblName}
                p_filesUseUniqueKeywordsTF={filesUseUniqueKeywordsTF}
                f_onChangeLocalDisplayName={this.onchange_file_local_display_name}
                f_onChangeLocalKeywords={this.onchange_file_local_keywords}
                f_onChangeLocalDescription={this.onchange_file_local_description}
              />
            </>
          )}
          <div className="displayFlexColumnHcVc hugeTopMargin hugeBottomMargin">
            <CEGeneralReact.CEButton
              p_type={((numSuccessFiles > 0) ? ("blue") : ("gray"))}
              p_text={((numSuccessFiles > 0) ? ("Save File Data") : ("Close"))}
              p_tabIndex={((numSuccessFiles + 3) * 3)}
              f_onClick={this.onclick_save_keywords_and_descriptions}
            />
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

const FileFolderSystemUploadFilesPostUploadFloatingBoxSuccessFileRow = inject("DatabaseMobx")(observer(
class FileFolderSystemUploadFilesPostUploadFloatingBoxSuccessFileRow extends Component { //props: p_fileIndex, p_successFileObj, p_localDisplayName, p_localKeywords, p_localDescription, p_tblName, p_filesUseUniqueKeywordsTF, f_onChangeLocalDisplayName, f_onChangeLocalKeywords, f_onChangeLocalDescription
  constructor(props) {
    super(props);
    this.state = {
      s_fileLocalXmlType: this.props.p_successFileObj.xmlType
    };
  }

  onchange_local_display_name = (i_newValue) => {
    this.props.f_onChangeLocalDisplayName(this.props.p_fileIndex, i_newValue);
  }

  onchange_local_keywords = (i_newValue) => {
    this.props.f_onChangeLocalKeywords(this.props.p_fileIndex, i_newValue);
  }

  onchange_local_description = (i_newValue) => {
    this.props.f_onChangeLocalDescription(this.props.p_fileIndex, i_newValue);
  }

  onclick_xml_type_icon = (i_selectedXmlTypeString) => {
    const tblName = this.props.p_tblName;
    const successFileObj = this.props.p_successFileObj;

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - FileFolderSystemUploadFilesPostUploadFloatingBoxSuccessFileRow", "onclick_xml_type_icon", ["i_selectedXmlTypeString"], [i_selectedXmlTypeString]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update(tblName, successFileObj.ffsTblRowID, "xml_type", i_selectedXmlTypeString, "s");
    C_CallPhpTblUID.execute();

    this.setState({s_fileLocalXmlType:i_selectedXmlTypeString});
  }

  render() {
    const fileLocalXmlType = this.state.s_fileLocalXmlType;

    const fileIndex = this.props.p_fileIndex;
    const successFileObj = this.props.p_successFileObj;
    const localDisplayName = this.props.p_localDisplayName;
    const localKeywords = this.props.p_localKeywords;
    const localDescription = this.props.p_localDescription;
    const tblName = this.props.p_tblName;
    const filesUseUniqueKeywordsTF = this.props.p_filesUseUniqueKeywordsTF;

    return(
      <div className="displayFlexRow">
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"4.4em"}}>
          <font className="font20 fontTextLight">
            {(fileIndex + 1)}
          </font>
        </div>
        <div className="flex11a">
          <div className="displayFlexRowVc" style={{height:"2em"}}>
            <div className="flex00a" style={{flexBasis:"6em"}}>
              {"File Name"}
            </div>
            <div className="flex11a displayFlexColumn">
              <LibraryReact.Text
                p_value={localDisplayName}
                p_style={{width:"100%"}}
                p_tabIndex={(((fileIndex + 1) * 3) + 0)}
                f_onChange={this.onchange_local_display_name}
              />
            </div>
            <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"3em"}} title={"File Type: ." + successFileObj.fileExt}>
              <CEIconsReact.SvgFile p_fileLoc={successFileObj.fileLoc} p_sizeEm={1.8} />
            </div>
          </div>
          {(filesUseUniqueKeywordsTF) &&
            <div className="displayFlexRowVc" style={{height:"2em"}}>
              <div className="flex00a" style={{flexBasis:"9em"}}>
                {"Keywords"}
              </div>
              <div className="flex11a displayFlexColumn">
                <LibraryReact.Text
                  p_value={localKeywords}
                  p_style={{width:"100%"}}
                  p_tabIndex={(((fileIndex + 1) * 3) + 1)}
                  f_onChange={this.onchange_local_keywords}
                />
              </div>
            </div>
          }
          <div className="displayFlexRowVc" style={{height:"2em"}}>
            <div className="flex00a" style={{flexBasis:"9em"}}>
              {"Description/Notes"}
            </div>
            <div className="flex11a displayFlexColumn">
              <LibraryReact.Text
                p_value={localDescription}
                p_style={{width:"100%"}}
                p_tabIndex={(((fileIndex + 1) * 3) + 2)}
                f_onChange={this.onchange_local_description}
              />
            </div>
          </div>
          {(successFileObj.isXmlTF) &&
            <div className="displayFlexRowVc flexWrap medTopMargin smallFullPad border1bbb bgLighterGray">
              <div className="flex00a smallFullPad" style={{flexBasis:"10em"}}>
                <font className="fontItalic">
                  {"Select the XML Template Type"}
                </font>
              </div>
              <FFSSelectXmlTypeIcon p_xmlType="word" p_isSelectedTF={(fileLocalXmlType === "word")} f_onClick={this.onclick_xml_type_icon} />
              <FFSSelectXmlTypeIcon p_xmlType="excel" p_isSelectedTF={(fileLocalXmlType === "excel")} f_onClick={this.onclick_xml_type_icon} />
              <FFSSelectXmlTypeIcon p_xmlType="ppt" p_isSelectedTF={(fileLocalXmlType === "ppt")} f_onClick={this.onclick_xml_type_icon} />
              <FFSSelectXmlTypeIcon p_xmlType="generic" p_isSelectedTF={(fileLocalXmlType === "generic")} f_onClick={this.onclick_xml_type_icon} />
            </div>
          }
        </div>
      </div>
    );
  }
}));

class FFSSelectXmlTypeIcon extends Component { //props: p_xmlType, p_isSelectedTF, f_onClick
  onclick_xml_type_icon = () => {
    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick(this.props.p_xmlType);
    }
  }

  render() {
    const xmlType = this.props.p_xmlType;
    const isSelectedTF = this.props.p_isSelectedTF;

    var label = "Other";
    if(xmlType === "word") { label = "Word"; }
    else if(xmlType === "excel") { label = "Excel"; }
    else if(xmlType === "ppt") { label = "PowerPoint"; }

    return(
      <div
        className={"displayFlexColumnHcVc lrMargin border bevelBorderColors " + ((isSelectedTF) ? ("bgLightBlueGradient") : ("bgWhite hoverLighterBlueGradient cursorPointer"))}
        style={{height:"6em", width:"6em"}}
        onClick={((isSelectedTF) ? (undefined) : (this.onclick_xml_type_icon))}>
        <div className="flex00a smallBottomMargin textCenter">
          <font className={"fontBold " + ((isSelectedTF) ? ("") : ("fontTextLighter"))}>
            {label}
          </font>
        </div>
        <div className="flex00a">
          <CEIconsReact.SvgFile p_fileLoc=".xml" p_xmlType={xmlType} p_sizeEm={3.5} />
        </div>
      </div>
    );
  }
}















//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//Upload single .csv file to read data columns into local variables
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export class ImportDataFromCsvFileButtonWithFloatingBoxInterface extends Component {
  //props: p_buttonLabel, p_trblFlag, p_importTitle, p_instructionsHtmlOrUndefined, p_existingValuesArray, p_maxNumColumnsInCsvOrUndefined, p_maxNumColumnsToShow, p_combineAll2DDataInto1DTF, p_markAndPreventDuplicateEntriesTF, p_includeBlankColumn1EntriesTF,
  //f_onClickImportCsvData(i_csvDataArrayOrArrayOfArrays, i_runThisFunctionUponSuccess, i_runThisFunctionUponError)
  //f_onOpenCloseFloatingBoxTF(i_openTrueClosedFalse)
  constructor(props) {
    super(props);

    if(JSFUNC.is_function(this.props.f_onOpenCloseFloatingBoxTF)) {
      this.props.f_onOpenCloseFloatingBoxTF(false);
    }

    this.state = {
      s_importCsvFloatingBoxIsOpenTF: false
    }
  }

  onclick_open_import_csv_floating_box = () => {
    this.setState({s_importCsvFloatingBoxIsOpenTF:true});

    if(JSFUNC.is_function(this.props.f_onOpenCloseFloatingBoxTF)) {
      this.props.f_onOpenCloseFloatingBoxTF(true);
    }
  }

  onclick_close_import_csv_floating_box = () => {
    this.setState({s_importCsvFloatingBoxIsOpenTF:false});

    if(JSFUNC.is_function(this.props.f_onOpenCloseFloatingBoxTF)) {
      this.props.f_onOpenCloseFloatingBoxTF(false);
    }
  }

  render() {
    const s_importCsvFloatingBoxIsOpenTF = this.state.s_importCsvFloatingBoxIsOpenTF;

    const p_buttonLabel = this.props.p_buttonLabel;
    const p_trblFlag = this.props.p_trblFlag;
    const p_importTitle = this.props.p_importTitle;
    const p_instructionsHtmlOrUndefined = this.props.p_instructionsHtmlOrUndefined;
    const p_existingValuesArray = this.props.p_existingValuesArray;
    const p_maxNumColumnsInCsvOrUndefined = this.props.p_maxNumColumnsInCsvOrUndefined;
    const p_maxNumColumnsToShow = this.props.p_maxNumColumnsToShow;
    const p_combineAll2DDataInto1DTF = this.props.p_combineAll2DDataInto1DTF;
    const p_markAndPreventDuplicateEntriesTF = this.props.p_markAndPreventDuplicateEntriesTF;
    const p_includeBlankColumn1EntriesTF = this.props.p_includeBlankColumn1EntriesTF;

    return(
      <>
        <CEGeneralReact.CEButton
          p_type="add"
          p_text={p_buttonLabel}
          f_onClick={this.onclick_open_import_csv_floating_box}
        />
        {(s_importCsvFloatingBoxIsOpenTF) &&
          <ImportDataFromCsvFileFloatingBox
            p_trblFlag={p_trblFlag}
            p_importTitle={p_importTitle}
            p_instructionsHtmlOrUndefined={p_instructionsHtmlOrUndefined}
            p_existingValuesArray={p_existingValuesArray}
            p_maxNumColumnsInCsvOrUndefined={p_maxNumColumnsInCsvOrUndefined}
            p_maxNumColumnsToShow={p_maxNumColumnsToShow}
            p_combineAll2DDataInto1DTF={p_combineAll2DDataInto1DTF}
            p_markAndPreventDuplicateEntriesTF={p_markAndPreventDuplicateEntriesTF}
            p_includeBlankColumn1EntriesTF={p_includeBlankColumn1EntriesTF}
            f_onClickImportCsvData={this.props.f_onClickImportCsvData}
            f_onClickClose={this.onclick_close_import_csv_floating_box}
          />
        }
      </>
    );
  }
}

export class ImportDataFromCsvFileFloatingBox extends Component {
  //props: p_trblFlag, p_importTitle, p_instructionsHtmlOrUndefined, p_existingValuesArray, p_maxNumColumnsInCsvOrUndefined, p_maxNumColumnsToShow, p_combineAll2DDataInto1DTF, p_markAndPreventDuplicateEntriesTF, p_includeBlankColumn1EntriesTF, 
  //f_onClickImportCsvData(i_csvDataArrayOrArrayOfArrays, i_runThisFunctionUponSuccess, i_runThisFunctionUponError), f_onClickClose
  constructor(props) {
    super(props);
    this.state = {
      s_fileImportingState: "notLoaded", //"notLoaded", "loading", "loaded", "importing", "finishedSuccess", "finishedError"
      s_uploadErrorMessage: "",
      s_uploadedFileNameAndExt: "",
      s_csvDataWithDuplicateFlagsArrayOfObjs: [],
      s_numNonDuplicateEntries: 0,
      s_numDuplicateEntries: 0
    }
  }

  onclick_import_a_different_csv = () => {
    this.setState({
      s_fileImportingState: "notLoaded",
      s_uploadErrorMessage: "",
      s_uploadedFileNameAndExt: "",
      s_csvDataWithDuplicateFlagsArrayOfObjs: [],
      s_numNonDuplicateEntries: 0,
      s_numDuplicateEntries: 0
    });
  }

  upload_csv_files = (i_dataTransferFilesArray) => {
    const p_existingValuesArray = this.props.p_existingValuesArray;
    const p_maxNumColumnsInCsvOrUndefined = this.props.p_maxNumColumnsInCsvOrUndefined
    const p_combineAll2DDataInto1DTF = JSFUNC.prop_value(this.props.p_combineAll2DDataInto1DTF, true);
    const p_markAndPreventDuplicateEntriesTF = JSFUNC.prop_value(this.props.p_markAndPreventDuplicateEntriesTF, true);
    const p_includeBlankColumn1EntriesTF = JSFUNC.prop_value(this.props.p_includeBlankColumn1EntriesTF, false);

    if(i_dataTransferFilesArray.length !== 1) {
      this.setState({s_uploadErrorMessage:"Can only import 1 .csv file at a time"});
    }
    else {
      const dataTransferFileObj = i_dataTransferFilesArray[0];
      const uploadedFileNameAndExt = dataTransferFileObj.name;

      const filePartsObj = JSFUNC.file_parts_obj(uploadedFileNameAndExt);
      if(filePartsObj.fileExt !== "csv") {
        this.setState({s_uploadErrorMessage:"Uploaded file must have a '.csv' extension (Attempted to import '" + uploadedFileNameAndExt + "')"});
      }
      else {
        this.setState({
          s_fileImportingState: "loading",
          s_uploadErrorMessage: ""
        });

        const functionOnSuccess = (i_fileDataString) => {
          //initialize output arrayOfObjs
          var csvDataWithDuplicateFlagsArrayOfObjs = [];
          var numNonDuplicateEntries = 0;
          var numDuplicateEntries = 0;

          //read csv data file 1D or 2D and convert to 2D format
          var csvDataArrayOfArrays = [];
          if(p_combineAll2DDataInto1DTF) {
            //gather csv data from all columns into a single array
            const allCsvStringsArray = JSFUNC.read_csv_file_data_string_into_single_array_of_all_values(i_fileDataString);

            //put data into 2D format
            for(let csvString of allCsvStringsArray) {
              csvDataArrayOfArrays.push([csvString]);
            }
          }
          else {
            csvDataArrayOfArrays = JSFUNC.read_csv_file_data_string_into_arrayOfArrays(i_fileDataString);
          }

          //only proceed if there are any rows of data to import
          if(JSFUNC.is_array(csvDataArrayOfArrays) && (csvDataArrayOfArrays.length > 0)) {
            //get all input existing values in lowercase
            var existingValuesLowercaseArray = [];
            if(p_markAndPreventDuplicateEntriesTF) {
              existingValuesLowercaseArray = JSFUNC.convert_array_to_lowercase_array(p_existingValuesArray);
            }

            //transfer imported csv strings into arrayOfObjs with flags for duplicates
            var uniqueCsvStringsLowerArray = [];
            for(let csvDataRowArray of csvDataArrayOfArrays) {
              if(JSFUNC.is_array(csvDataRowArray)) {
                var numColumnsInDataRow = csvDataRowArray.length;
                if(numColumnsInDataRow > 0) {
                  var csvDataRowFirstColumnString = csvDataRowArray[0];
                  if(csvDataRowFirstColumnString !== undefined) {
                    if((csvDataRowFirstColumnString !== "") || p_includeBlankColumn1EntriesTF) { //don't include rows that have a blank value in column 1, unless p_includeBlankColumn1EntriesTF is true
                      var csvStringLowercase = csvDataRowFirstColumnString.toLowerCase();

                      var duplicateExistingTF = false;
                      var duplicateInCsvTF = false;
                      if(p_markAndPreventDuplicateEntriesTF) {
                        var duplicateExistingTF = JSFUNC.in_array(csvStringLowercase, existingValuesLowercaseArray);
                        var duplicateInCsvTF = JSFUNC.in_array(csvStringLowercase, uniqueCsvStringsLowerArray);
                      }

                      //reduce the number of columns 2-N using the input p_maxNumColumnsInCsvOrUndefined
                      var column2ToNValuesArray = [];
                      var maxNumColumns = ((JSFUNC.is_number_not_nan_gt_0(p_maxNumColumnsInCsvOrUndefined)) ? (p_maxNumColumnsInCsvOrUndefined) : (numColumnsInDataRow));
                      for(let c = 1; c < maxNumColumns; c++) {
                        var column2ToNValue = csvDataRowArray[c];
                        if(column2ToNValue === undefined) { //beyond length of this row
                          column2ToNValue = "";
                        }
                        column2ToNValuesArray.push(column2ToNValue);
                      }

                      csvDataWithDuplicateFlagsArrayOfObjs.push({
                        csvString: csvDataRowFirstColumnString,
                        duplicateExistingTF: duplicateExistingTF,
                        duplicateInCsvTF: duplicateInCsvTF,
                        column2ToNValuesArray: column2ToNValuesArray
                      });

                      if(duplicateExistingTF || duplicateInCsvTF) {
                        numDuplicateEntries++;
                      }
                      else {
                        numNonDuplicateEntries++;
                      }

                      //if this value is unique in the csv, add it to the unique csv strings array for the next loop
                      if(!duplicateInCsvTF) {
                        uniqueCsvStringsLowerArray.push(csvStringLowercase);
                      }
                    }
                  }
                }
              }
            }
          }

          this.setState({
            s_fileImportingState: "loaded",
            s_uploadErrorMessage: "",
            s_uploadedFileNameAndExt: uploadedFileNameAndExt,
            s_csvDataWithDuplicateFlagsArrayOfObjs: csvDataWithDuplicateFlagsArrayOfObjs,
            s_numNonDuplicateEntries: numNonDuplicateEntries,
            s_numDuplicateEntries: numDuplicateEntries
          });
        };

        const functionOnError = () => {
          this.setState({
            s_fileImportingState: "notLoaded",
            s_uploadErrorMessage: "Error reading the uploaded file ('" + uploadedFileNameAndExt + "')"
          });
        };

        JSFUNC.read_file_data_string_from_uploaded_data_transfer_file_obj(dataTransferFileObj, functionOnSuccess, functionOnError);
      }
    }
  }

  onclick_import_loaded_items = () => {
    const s_csvDataWithDuplicateFlagsArrayOfObjs = this.state.s_csvDataWithDuplicateFlagsArrayOfObjs;

    const p_combineAll2DDataInto1DTF = this.props.p_combineAll2DDataInto1DTF;

    if(!JSFUNC.is_function(this.props.f_onClickImportCsvData)) {
      this.setState({s_fileImportingState:"notLoaded"});
    }
    else {
      this.setState({s_fileImportingState:"importing"});

      var csvDataArrayOrArrayOfArrays = [];
      for(let csvDataWithDuplicateFlagsObj of s_csvDataWithDuplicateFlagsArrayOfObjs) {
        if(!csvDataWithDuplicateFlagsObj.duplicateExistingTF && !csvDataWithDuplicateFlagsObj.duplicateInCsvTF) {
          if(p_combineAll2DDataInto1DTF) { //combining all data into 1D outputs an array of new strings to import
            csvDataArrayOrArrayOfArrays.push(csvDataWithDuplicateFlagsObj.csvString);
          }
          else { //2D output producess and arrayOfArrays (array containing all rows, each containing an array of strings for each column)
            var rowArray = [csvDataWithDuplicateFlagsObj.csvString];
            for(let column2ToNValue of csvDataWithDuplicateFlagsObj.column2ToNValuesArray) {
              rowArray.push(column2ToNValue);
            }
            csvDataArrayOrArrayOfArrays.push(rowArray);
          }
        }
      }

      const functionOnSuccess = () => {
        this.setState({s_fileImportingState:"finishedSuccess"});
      };

      const functionOnError = () => {
        this.setState({s_fileImportingState:"finishedError"});
      };

      this.props.f_onClickImportCsvData(csvDataArrayOrArrayOfArrays, functionOnSuccess, functionOnError);
    }
  }

  render() {
    const s_fileImportingState = this.state.s_fileImportingState;
    const s_uploadErrorMessage = this.state.s_uploadErrorMessage;
    const s_uploadedFileNameAndExt = this.state.s_uploadedFileNameAndExt;
    const s_csvDataWithDuplicateFlagsArrayOfObjs = this.state.s_csvDataWithDuplicateFlagsArrayOfObjs;
    const s_numNonDuplicateEntries = this.state.s_numNonDuplicateEntries;
    const s_numDuplicateEntries = this.state.s_numDuplicateEntries;

    const p_trblFlag = JSFUNC.prop_value(this.props.p_trblFlag, "addEditDeleteTableEditItem");
    const p_importTitle = this.props.p_importTitle;
    const p_instructionsHtmlOrUndefined = this.props.p_instructionsHtmlOrUndefined;
    const p_existingValuesArray = JSFUNC.prop_value(this.props.p_existingValuesArray, []);
    const p_maxNumColumnsInCsvOrUndefined = this.props.p_maxNumColumnsInCsvOrUndefined;
    const p_maxNumColumnsToShow = JSFUNC.prop_value(this.props.p_maxNumColumnsToShow, 1);
    const p_combineAll2DDataInto1DTF = JSFUNC.prop_value(this.props.p_combineAll2DDataInto1DTF, true);
    const p_markAndPreventDuplicateEntriesTF = JSFUNC.prop_value(this.props.p_markAndPreventDuplicateEntriesTF, true);
    const p_includeBlankColumn1EntriesTF = JSFUNC.prop_value(this.props.p_includeBlankColumn1EntriesTF, false);

    var topComponent = null;
    if(s_fileImportingState === "notLoaded") {
      topComponent = (
        <>
          <CEGeneralReact.CEDropZone
            p_width="15em"
            p_heightEm={3}
            p_allowDropTF={true}
            p_uniqueString="aedTableCsvFileImport"
            p_fileUploadIsProcessingTF={false}
            p_message="Click or Drag a .csv File to Begin Import..."
            p_dragOverMatchingItemMessage="Drop .csv File to Begin Import"
            f_onDropFiles={this.upload_csv_files}
          />
          {(s_uploadErrorMessage !== "") &&
            <CEGeneralReact.ErrorText p_class="smallTopMargin" p_text={s_uploadErrorMessage} />
          }
        </>
      );
    }
    else if(s_fileImportingState === "loading") {
      topComponent = (
        <>
          <div className="smallBottomMargin">
            <font className="fontItalic fontTextLight">
              {"Uploading file '" + s_uploadedFileNameAndExt + "'"}
            </font>
          </div>
          <CEGeneralReact.LoadingAnimation />
        </>
      );
    }
    else if((s_fileImportingState === "loaded") || (s_fileImportingState === "importing")) {
      var topLabel = "Found " + s_numNonDuplicateEntries + " " + JSFUNC.plural(s_numNonDuplicateEntries, "entry", "entries") + " ready to import from file '" + s_uploadedFileNameAndExt + "'";
      if(s_numDuplicateEntries > 0) {
        topLabel += " (" + s_numDuplicateEntries + " duplicate " + JSFUNC.plural(s_numDuplicateEntries, "entry", "entries") + " are marked in red and will not be imported)";
      }
      topComponent = (
        <font className="fontItalic fontTextLight">
          {topLabel}
        </font>
      );
    }
    else if(s_fileImportingState === "finishedSuccess") {
      topComponent = (
        <font className="fontDarkGreen">
          {"Successfully imported " + s_numNonDuplicateEntries + " " + JSFUNC.plural(s_numNonDuplicateEntries, "entry", "entries") + " into CaptureExec"}
        </font>
      );
    }
    else if(s_fileImportingState === "finishedError") {
      topComponent = (
        <font className="fontRed">
          {"Import of these items was not successful. Please retry this import."}
        </font>
      );
    }

    var middleComponent = null;
    if((s_fileImportingState === "notLoaded") && (p_instructionsHtmlOrUndefined !== undefined)) {
      middleComponent = p_instructionsHtmlOrUndefined;
    }
    else if((s_fileImportingState === "loaded") || (s_fileImportingState === "importing")) {
      middleComponent = (
        s_csvDataWithDuplicateFlagsArrayOfObjs.map((m_csvDataWithDuplicateFlagsObj, m_index) =>
          <ImportDataFromCsvFileEntryRow
            p_csvDataWithDuplicateFlagsObj={m_csvDataWithDuplicateFlagsObj}
            p_rowIndex={m_index}
            p_maxNumColumnsToShow={p_maxNumColumnsToShow}
          />
        )
      );
    }

    var bottomComponent = null;
    if((s_fileImportingState === "notLoaded") || (s_fileImportingState === "loading")) {
      bottomComponent = (
        <div className="flex11a displayFlexColumnHcVc">
          <font className="fontItalic fontTextLight">
            {"Upload a .csv file above to preview its contents before importing"}
          </font>
        </div>
      );
    }
    else if(s_fileImportingState === "loaded") {
      bottomComponent = (
        <div className="flex11a displayFlexRowHcVc flexWrap">
          {(s_numNonDuplicateEntries > 0) &&
            <div className="flex00a lrMedMargin">
              <CEGeneralReact.CEButton
                p_type="blue"
                p_text={"Import " + s_numNonDuplicateEntries + " " + JSFUNC.plural(s_numNonDuplicateEntries, "Item", "Items") + " and Close"}
                f_onClick={this.onclick_import_loaded_items}
              />
            </div>
          }
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text="Restart with Different .csv"
              f_onClick={this.onclick_import_a_different_csv}
            />
          </div>
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text="Cancel"
              f_onClick={this.props.f_onClickClose}
            />
          </div>
        </div>
      );
    }
    else if(s_fileImportingState === "importing") {
      bottomComponent = (
        <div className="flex11a displayFlexColumnHcVc">
          <div className="smallBottomMargin">
            <font className="fontItalic fontTextLight">
              {"Importing new values into CaptureExec..."}
            </font>
          </div>
          <CEGeneralReact.LoadingAnimation />
        </div>
      );
    }
    else if((s_fileImportingState === "finishedSuccess") || (s_fileImportingState === "finishedError")) {
      bottomComponent = (
        <div className="flex11a displayFlexRowHcVc flexWrap">
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text="Import Another .csv"
              f_onClick={this.onclick_import_a_different_csv}
            />
          </div>
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text="Close"
              f_onClick={this.props.f_onClickClose}
            />
          </div>
        </div>
      );
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag={p_trblFlag}
        p_title="Importing Items from .csv File"
        f_onClickCancel={this.props.f_onClickClose}>
        <div className="flex00a tbPad lrMedPad borderB1ddd">
          <font className="fontBold fontBlue">
            {p_importTitle}
          </font>
        </div>
        <div className="flex00a displayFlexColumnHcVc tbPad lrMedPad borderB1ddd">
          {topComponent}
        </div>
        <div className="flex11a yScroll medFullPad">
          {middleComponent}
        </div>
        <div className="flex00a displayFlexColumn tbPad lrMedPad borderT1ddd">
          {bottomComponent}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}

function ImportDataFromCsvFileEntryRow(props) { //props: p_csvDataWithDuplicateFlagsObj, p_rowIndex, p_maxNumColumnsToShow
  const csvDataWithDuplicateFlagsObj = props.p_csvDataWithDuplicateFlagsObj;
  const rowIndex = props.p_rowIndex;
  const p_maxNumColumnsToShow = props.p_maxNumColumnsToShow;

  const csvString = csvDataWithDuplicateFlagsObj.csvString;
  const duplicateExistingTF = csvDataWithDuplicateFlagsObj.duplicateExistingTF;
  const duplicateInCsvTF = csvDataWithDuplicateFlagsObj.duplicateInCsvTF;
  const column2ToNValuesArray = csvDataWithDuplicateFlagsObj.column2ToNValuesArray;

  var bgClass = "";
  var fontClass = "";
  if(duplicateExistingTF || duplicateInCsvTF) {
    bgClass = "bgLightRed";
    fontClass = "fontItalic fontTextLighter";
  }
  else if((rowIndex % 2) === 1) {
    bgClass = "bgLightesterGray";
  }
  else {
    bgClass = "bgWhite";
  }

  return(
    <div className={"displayFlexRow borderB1ddd tbMicroPad " + bgClass}>
      <div className="flex11a lrPad" style={{flexBasis:"200em"}}>
        <font className={fontClass}>
          {csvString}
        </font>
      </div>
      {column2ToNValuesArray.map((m_column2toNValue, m_index) =>
        ((m_index + 1) < p_maxNumColumnsToShow) && 
        <div className="flex11a borderL1ddd lrPad" style={{flexBasis:"100em"}}>
          <font className={fontClass}>
            {m_column2toNValue}
          </font>
        </div>
      )}
    </div>
  );
}








//========================================================================================================================================================================================================================================
//Generate Capture Templates, Teammate Contract Templates, Excel Report Templates
//========================================================================================================================================================================================================================================
export const GenerateAndDownloadSingleCaptureTemplateButtonProcess = inject("OpenCaptureMobx", "DatabaseMobx")(observer(
class GenerateAndDownloadSingleCaptureTemplateButtonProcess extends Component { //p_fromOpenCaptureTrueAdminFalse, p_captureID, p_singleCaptureTemplateID, p_buttonText, p_buttonTitle, p_tabIndex, p_canClickButtonTF, f_onClick
  constructor(props) {
    super(props);
    this.state = {
      s_buttonState: "init", //"init", "error", "working", "success"
      s_buttonText: this.props.p_buttonText
    }
  }

  set_button_text_error_and_wait_for_reset = (i_buttonText) => {
    this.setState({s_buttonState:"error", s_buttonText:i_buttonText});
    this.timeoutID = setTimeout(() => this.reset_button_to_initial_state_and_clear_timeout(), 5000);
  }

  set_button_text_working = (i_buttonText) => {
    this.setState({s_buttonState:"working", s_buttonText:i_buttonText});
  }

  set_button_text_success_and_wait_for_reset = (i_buttonText) => {
    this.setState({s_buttonState:"success", s_buttonText:i_buttonText});
    this.timeoutID = setTimeout(() => this.reset_button_to_initial_state_and_clear_timeout(), 5000);
  }

  reset_button_to_initial_state_and_clear_timeout = () => {
    this.setState({s_buttonState:"init", s_buttonText:this.props.p_buttonText});
    clearTimeout(this.timeoutID);
  }

  onclick_generate_single_capture_template = () => {
    const p_fromOpenCaptureTrueAdminFalse = this.props.p_fromOpenCaptureTrueAdminFalse;
    const p_captureID = this.props.p_captureID;
    const p_singleCaptureTemplateID = this.props.p_singleCaptureTemplateID;

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - GenerateAndDownloadSingleCaptureTemplateButtonProcess", "onclick_generate_single_capture_template", ["p_fromOpenCaptureTrueAdminFalse", "p_captureID", "p_singleCaptureTemplateID"], [p_fromOpenCaptureTrueAdminFalse, p_captureID, p_singleCaptureTemplateID]);

    //all codewords in this single capture template will be fetch from the single capture tbl Maps in memory (like o_tbl_c_competitors, etc) which contain only data rows for this captureID when the single capture was opened
    const supplementalDataSingleCaptureTrueMultiCapturesFalse = true;

    //get capture map from p_captureID
    const captureMap = this.props.DatabaseMobx.o_tbl_captures.get(p_captureID);
    if(captureMap === undefined) {
      this.set_button_text_error_and_wait_for_reset("Capture Does Not Exist (ID: " + p_captureID + ")");
      return;
    }
    const captureName = this.props.DatabaseMobx.capture_name_plaintext_from_capture_map(captureMap);

    //get single capture template map from p_singleCaptureTemplateID
    const singleCaptureTemplateMap = this.props.DatabaseMobx.o_tbl_a_single_capture_templates_filefoldersystem.get(p_singleCaptureTemplateID);
    if(singleCaptureTemplateMap === undefined) {
      this.set_button_text_error_and_wait_for_reset("Template Does Not Exist (ID: " + p_singleCaptureTemplateID + ")");
      return;
    }
    const templateXmlFileLoc = singleCaptureTemplateMap.get("file_loc");
    const templateDisplayName = singleCaptureTemplateMap.get("display_name");

    //setup the save as download file name
    const templateDisplayNameFilePartsObj = JSFUNC.file_parts_obj(templateDisplayName); //remove any extension on the display name for this template file
    const downloadSaveAsFileNameAndExt = JSFUNC.trim_string_max_chars(templateDisplayNameFilePartsObj.fileName + " " + JSFUNC.now_dateYmd() + " - " + captureName, 100) + ".xml"; //add the capture name after the file display name, trim the save as file name to 100 chars and add .xml

    if(p_fromOpenCaptureTrueAdminFalse) { //template requested from inside an open capture
      this.set_button_text_working("Fetching Template File..."); //set button into a yellow working state for loading file from server
      const functionOnSuccessfulLoadTemplateFromServer = (i_fileDataString) => {
        this.set_button_text_working("Replacing Codewords..."); //set button into a yellow working state for loading file from server
        const replacedFileDataString = JSPHP.replace_all_codewords_in_xml_data_string(supplementalDataSingleCaptureTrueMultiCapturesFalse, i_fileDataString, captureMap); //replace all codewords in the string
        this.set_button_text_success_and_wait_for_reset("Successfully Created New File for Download"); //set button into a green complete state for loading file from server
        JSFUNC.browser_offer_file_download_from_file_data_string(replacedFileDataString, downloadSaveAsFileNameAndExt); //turn the string into a local memory file and offer it for download
      }

      const functionOnErrorLoadTemplateFromServer = (i_errorMessage) => {
        this.set_button_text_error_and_wait_for_reset(i_errorMessage);
      }

      JSPHP.load_server_file_data_string(templateXmlFileLoc, true, functionOnSuccessfulLoadTemplateFromServer, functionOnErrorLoadTemplateFromServer, jsDescription);
    }
    else { //template requsted from outside like Admin (need to load supplemental single capture data into memory, then clear it)
      this.set_button_text_working("Loading Capture Data..."); //set button into a yellow working state for loading the single capture data into memory (teammates, competitors, shaping answers, risks, etc)
      const functionOnSuccessfulCaptureSupplementaryDataLoad = () => {
        this.set_button_text_working("Fetching Template File..."); //set button into a yellow working state for loading file from server
        const functionOnSuccessfulLoadTemplateFromServer = (i_fileDataString) => {
          this.set_button_text_working("Replacing Codewords..."); //set button into a yellow working state for loading file from server
          const replacedFileDataString = JSPHP.replace_all_codewords_in_xml_data_string(supplementalDataSingleCaptureTrueMultiCapturesFalse, i_fileDataString, captureMap); //replace all codewords in the string
          this.props.OpenCaptureMobx.a_clear_single_capture_from_local_memory(); //clear single capture supplemental data mostly so the full textarea data does not interfere with the capture table cells displaying slim textarea data from tbl_captures columns
          this.set_button_text_success_and_wait_for_reset("Successfully Created New File for Download"); //set button into a green complete state for loading file from server
          JSFUNC.browser_offer_file_download_from_file_data_string(replacedFileDataString, downloadSaveAsFileNameAndExt); //turn the string into a local memory file and offer it for download
        }

        const functionOnErrorLoadTemplateFromServer = (i_errorMessage) => {
          this.set_button_text_error_and_wait_for_reset(i_errorMessage);
          this.props.OpenCaptureMobx.a_clear_single_capture_from_local_memory(); //clear single capture supplemental data from memory
        }

        JSPHP.load_server_file_data_string(templateXmlFileLoc, true, functionOnSuccessfulLoadTemplateFromServer, functionOnErrorLoadTemplateFromServer, jsDescription);
      }

      JSPHP.single_capture_load_supplementary_data(p_captureID, "", functionOnSuccessfulCaptureSupplementaryDataLoad);
    }
  }

  render() {
    const s_buttonState = this.state.s_buttonState;
    const s_buttonText = this.state.s_buttonText;

    return(
      <CEDownloadFileButton
        p_buttonState={s_buttonState}
        p_buttonText={s_buttonText}
        p_buttonWidth="15em"
        p_title={this.props.p_buttonTitle}
        p_tabIndex={this.props.p_tabIndex}
        p_canClickButtonTF={this.props.p_canClickButtonTF}
        f_onClickGenerate={this.onclick_generate_single_capture_template}
        f_onClickReset={this.reset_button_to_initial_state_and_clear_timeout}
        f_onClick={this.props.f_onClick}
      />
    );
  }
}));



export const GenerateAndDownloadExcelReportButtonProcess = inject("DatabaseMobx")(observer(
class GenerateAndDownloadExcelReportButtonProcess extends Component { //p_excelReportTemplateID, p_buttonText, p_buttonTitle, p_tabIndex, p_canClickButtonTF, f_onClick
  constructor(props) {
    super(props);
    this.state = {
      s_buttonState: "init", //"init", "error", "working", "success"
      s_buttonText: this.props.p_buttonText
    }
  }

  set_button_text_error_and_wait_for_reset = (i_buttonText) => {
    this.setState({s_buttonState:"error", s_buttonText:i_buttonText});
    this.timeoutID = setTimeout(() => this.reset_button_to_initial_state_and_clear_timeout(), 5000);
  }

  set_button_text_working = (i_buttonText) => {
    this.setState({s_buttonState:"working", s_buttonText:i_buttonText});
  }

  set_button_text_success_and_wait_for_reset = (i_buttonText) => {
    this.setState({s_buttonState:"success", s_buttonText:i_buttonText});
    this.timeoutID = setTimeout(() => this.reset_button_to_initial_state_and_clear_timeout(), 5000);
  }

  reset_button_to_initial_state_and_clear_timeout = () => {
    this.setState({s_buttonState:"init", s_buttonText:this.props.p_buttonText});
    clearTimeout(this.timeoutID);
  }

  onclick_generate_excel_report_from_template = () => {
    const excelReportTemplateID = this.props.p_excelReportTemplateID;

    //get single capture template map from excelReportTemplateID
    const excelReportTemplateMap = this.props.DatabaseMobx.o_tbl_a_excel_report_templates_filefoldersystem.get(excelReportTemplateID);
    if(excelReportTemplateMap === undefined) {
      this.set_button_text_error_and_wait_for_reset("Template Does Not Exist (ID: " + excelReportTemplateID + ")");
      return;
    }
    const templateXmlFileLoc = excelReportTemplateMap.get("file_loc");
    const templateDisplayName = excelReportTemplateMap.get("display_name");

    //set button into a yellow working state for loading file from server
    this.set_button_text_working("Writing Report..."); //Fetching Template File

    const functionOnSuccessfulLoadTemplateFromServer = (i_fileDataString) => {
      this.set_button_text_working("Writing Report..."); //set button into a yellow working state for loading file from server

      const functionOnFinishWritingExcelReport = (i_finishedExcelReportXmlString) => {
        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
        this.set_button_text_success_and_wait_for_reset("Successfully Created New File for Download"); //set button into a green complete state for loading file from server

        //setup the save as download file name
        const templateDisplayNameFilePartsObj = JSFUNC.file_parts_obj(templateDisplayName); //remove any extension on the display name for this template file
        var downloadSaveAsFileNameAndExt = templateDisplayNameFilePartsObj.fileName + " " + JSFUNC.now_dateYmd();
        if(downloadSaveAsFileNameAndExt.length > 100) { //trim the save as file name to 100 chars
          downloadSaveAsFileNameAndExt = downloadSaveAsFileNameAndExt.substring(0, 100);
        }
        downloadSaveAsFileNameAndExt += ".xml";

        //turn the string into a local memory file and offer it for download
        JSFUNC.browser_offer_file_download_from_file_data_string(i_finishedExcelReportXmlString, downloadSaveAsFileNameAndExt);
        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
      }
      JSPHP.write_excel_report_xml_from_template_xml_data_string(i_fileDataString, functionOnFinishWritingExcelReport); //fill in entire excel report with all captures matching various specified filters on different sheets in the template
    }

    const functionOnErrorLoadTemplateFromServer = (i_errorMessage) => {
      this.set_button_text_error_and_wait_for_reset(i_errorMessage);
    }

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - GenerateAndDownloadExcelReportButtonProcess", "onclick_generate_excel_report_from_template", ["p_excelReportTemplateID"], [excelReportTemplateID]);
    JSPHP.load_server_file_data_string(templateXmlFileLoc, true, functionOnSuccessfulLoadTemplateFromServer, functionOnErrorLoadTemplateFromServer, jsDescription);
  }

  render() {
    const s_buttonState = this.state.s_buttonState;
    const s_buttonText = this.state.s_buttonText;

    return(
      <CEDownloadFileButton
        p_buttonState={s_buttonState}
        p_buttonText={s_buttonText}
        p_buttonWidth="15em"
        p_title={this.props.p_buttonTitle}
        p_tabIndex={this.props.p_tabIndex}
        p_canClickButtonTF={this.props.p_canClickButtonTF}
        f_onClickGenerate={this.onclick_generate_excel_report_from_template}
        f_onClickReset={this.reset_button_to_initial_state_and_clear_timeout}
        f_onClick={this.props.f_onClick}
      />
    );
  }
}));



export const GenerateAndUploadTeammateContractTemplateButtonProcess = inject("ContactsMobx", "OpenCaptureMobx", "DatabaseMobx", "UserMobx")(observer(
class GenerateAndUploadTeammateContractTemplateButtonProcess extends Component { //p_captureID, p_teammateContractID, p_teammateContractTemplateID, p_buttonText, p_buttonTitle, p_tabIndex, p_canClickButtonTF, p_adminDownloadNoUploadTF, f_onClick, f_onUploadSuccess
  constructor(props) {
    super(props);
    this.state = {
      s_buttonState: "init", //"init", "error", "working", "success"
      s_buttonText: this.props.p_buttonText
    }
  }

  set_button_text_error_and_wait_for_reset = (i_buttonText) => {
    this.setState({s_buttonState:"error", s_buttonText:i_buttonText});
    this.timeoutID = setTimeout(() => this.reset_button_to_initial_state_and_clear_timeout(), 5000);
  }

  set_button_text_working = (i_buttonText) => {
    this.setState({s_buttonState:"working", s_buttonText:i_buttonText});
  }

  set_button_text_success_and_wait_for_reset = (i_buttonText) => {
    this.setState({s_buttonState:"success", s_buttonText:i_buttonText});
    this.timeoutID = setTimeout(() => this.reset_button_to_initial_state_and_clear_timeout(), 5000);
  }

  reset_button_to_initial_state_and_clear_timeout = () => {
    this.setState({s_buttonState:"init", s_buttonText:this.props.p_buttonText});
    clearTimeout(this.timeoutID);
  }

  //1. Load teammate contract template file on the server, read the data into a string
  //2. replace all codewords in local js file data string
  //3. send replaced file data string to server to create a new file
  //4. insert a new record in the teammate contracts file folder system for this new replaced codewords file created from the template/capture/teammate/contract together
  onclick_generate_teammate_contract_template = () => {
    const p_captureID = this.props.p_captureID; //tbl_captures
    const p_teammateContractID = this.props.p_teammateContractID;
    const p_teammateContractTemplateID = this.props.p_teammateContractTemplateID; //tbl_a_teammates_contract_templates_filefoldersystem, accesses tbl_c_teammates_contracts (accesses tbl_c_teammates from teammate_id) (accesses tbl_g_contacts_companies from teammate contact_company_id) (accesses tbl_a_teammates_contract_types from teammate_contract_type_id)
    const p_adminDownloadNoUploadTF = JSFUNC.prop_value(this.props.p_adminDownloadNoUploadTF, false);

    const o_userID = this.props.UserMobx.o_userID;
    const c_userName = this.props.UserMobx.c_userName;
    const k_cardIDTeammates = this.props.DatabaseMobx.k_cardIDTeammates;

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - GenerateAndUploadTeammateContractTemplateButtonProcess", "onclick_generate_teammate_contract_template", ["p_captureID", "p_teammateContractID", "p_teammateContractTemplateID"], [p_captureID, p_teammateContractID, p_teammateContractTemplateID]);

    //flag indicating that all codewords in this single capture template will be fetched from the single capture tbl Maps in memory (like o_tbl_c_competitors, etc) which contain only data rows for this captureID when the single capture was opened
    const supplementalDataSingleCaptureTrueMultiCapturesFalse = true;

    //get capture map from p_captureID
    const captureMap = this.props.DatabaseMobx.o_tbl_captures.get(p_captureID);
    if(captureMap === undefined) {
      this.set_button_text_error_and_wait_for_reset("Capture Does Not Exist (ID: " + p_captureID + ")");
      return;
    }

    //set button into a yellow working state for loading single capture data
    this.set_button_text_working("Loading Single Capture Data...");

    const functionOnSuccessfulCaptureSupplementaryDataLoad = () => {
      //get teammate contract map from p_teammateContractID
      const teammateContractMap = this.props.DatabaseMobx.o_tbl_c_teammates_contracts.get(p_teammateContractID);
      if(teammateContractMap === undefined) {
        this.set_button_text_error_and_wait_for_reset("Teammate Contract Does Not Exist (ID: " + p_teammateContractID + ")");
        return;
      }
      const teammateID = teammateContractMap.get("teammate_id");
      const teammateContractTypeID = teammateContractMap.get("teammate_contract_type_id");

      //get teammate map from teammateID
      const teammateMap = this.props.DatabaseMobx.o_tbl_c_teammates.get(teammateID);
      if(teammateMap === undefined) {
        this.set_button_text_error_and_wait_for_reset("Teammate Does Not Exist (ID: " + teammateID + ")");
        return;
      }
      const teammateContactCompanyID = teammateMap.get("contact_company_id");

      //get teammate contract template map from p_teammateContractTemplateID
      const teammateContractTemplateMap = this.props.DatabaseMobx.o_tbl_a_teammates_contract_templates_filefoldersystem.get(p_teammateContractTemplateID);
      if(teammateContractTemplateMap === undefined) {
        this.set_button_text_error_and_wait_for_reset("Contract Template Does Not Exist (ID: " + p_teammateContractTemplateID + ")");
        return;
      }
      const templateXmlFileLoc = teammateContractTemplateMap.get("file_loc");
      const templateDisplayName = teammateContractTemplateMap.get("display_name");
      const templateXmlType = teammateContractTemplateMap.get("xml_type");

      //set button into a yellow working state for loading file from server
      this.set_button_text_working("Fetching Template File...");

      const functionOnSuccessfulLoadTemplateFromServer = (i_fileDataString) => {
        this.set_button_text_working("Replacing Codewords..."); //set button into a yellow working state for loading file from server
        const replacedFileDataString = JSPHP.replace_all_codewords_in_xml_data_string(supplementalDataSingleCaptureTrueMultiCapturesFalse, i_fileDataString, captureMap, p_teammateContractID); //replace all codewords in the string

        //clear single capture supplemental data mostly so the full textarea data does not interfere with the capture table cells displaying slim textarea data from tbl_captures columns
        this.props.OpenCaptureMobx.a_clear_single_capture_from_local_memory();

        if(p_adminDownloadNoUploadTF) { //in admin teammate contract templates, file is downloaded
          //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
          this.set_button_text_success_and_wait_for_reset("Successfully Created New File for Download"); //set button into a green complete state for loading file from server

          //setup the save as download file name
          const templateDisplayNameFilePartsObj = JSFUNC.file_parts_obj(templateDisplayName); //remove any extension on the display name for this template file
          const captureName = this.props.DatabaseMobx.capture_name_plaintext_from_capture_map(captureMap);
          var downloadSaveAsFileNameAndExt = templateDisplayNameFilePartsObj.fileName + " - " + captureName; //add the capture name after the file display name
          if(downloadSaveAsFileNameAndExt.length > 100) { //trim the save as file name to 100 chars
            downloadSaveAsFileNameAndExt = downloadSaveAsFileNameAndExt.substring(0, 100);
          }
          downloadSaveAsFileNameAndExt += ".xml";

          //turn the string into a local memory file and offer it for download
          JSFUNC.browser_offer_file_download_from_file_data_string(replacedFileDataString, downloadSaveAsFileNameAndExt);
          //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
        }
        else { //in contracts floating box process, file is generated, then reuploaded to a place on the server
          //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
          this.set_button_text_working("Uploading Completed File..."); //set button into a yellow working state for uploding the replaced new file data string to the server

          //setup the save as download file name
          const templateXmlFileLocFilePartsObj = JSFUNC.file_parts_obj(templateXmlFileLoc);
          const templateDisplayNameFilePartsObj = JSFUNC.file_parts_obj(templateDisplayName); //remove any extension on the display name for this template file
          const teammateName = this.props.ContactsMobx.contact_name_from_id(false, teammateContactCompanyID);
          const captureName = this.props.DatabaseMobx.capture_name_plaintext_from_capture_map(captureMap);
          var uploadFileDisplayNameAndExt = JSFUNC.now_datetime_filenames() + "-" + templateDisplayNameFilePartsObj.fileName + " - " + teammateName + " - " + captureName; //add the capture name after the file display name
          if(uploadFileDisplayNameAndExt.length > 100) { //trim the save as file name to 100 chars
            uploadFileDisplayNameAndExt = uploadFileDisplayNameAndExt.substring(0, 100);
          }
          var uploadFileDbNameAndExt = JSFUNC.db_name_from_display_name(uploadFileDisplayNameAndExt);
          uploadFileDisplayNameAndExt += "." + templateXmlFileLocFilePartsObj.fileExt;
          uploadFileDbNameAndExt += "." + templateXmlFileLocFilePartsObj.fileExt;
          const uploadFileLoc = "tbl_c_teammates_contracts_filefoldersystem/capture_id" + p_captureID + "/teammate_id" + teammateID + "/contract_type_id" + teammateContractTypeID + "/" + uploadFileDbNameAndExt;

          //call the php function to write a new file onto the server with the replaced codewords
          const C_CallPhpScriptCreateFileOnServer = new JSPHP.ClassCallPhpScript("createNewServerFileFromStringData", jsDescription);

          C_CallPhpScriptCreateFileOnServer.add_post_var("i_fileLocRootUploadsOrWeb", "uploads");
          C_CallPhpScriptCreateFileOnServer.add_post_var("i_fileLocRelativeFromRoot", uploadFileLoc);
          C_CallPhpScriptCreateFileOnServer.add_post_var("i_dataString", replacedFileDataString);

          C_CallPhpScriptCreateFileOnServer.add_return_vars("success01String");

          //php success, file either was written successfully or not
          const functionOnSuccessfulNewServerFileCreation = (i_parseResponse) => {
            if(i_parseResponse.success01String === "1") {
              this.set_button_text_working("Inserting Record of New File...");
              //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
              //make a db entry for the new file in the teammate contracts filefoldersystem
              const C_CallPhpTblUIDInsertFfsRecord = new JSPHP.ClassCallPhpTblUID(jsDescription);

              const parentFolderID = -1; //TODO would need to know how deep the fileFolderSystem component is open to in its internal state
              const fieldNamesArray = ["capture_id", "teammate_id", "contract_type_id", "folder0_file1", "parent_folder_id", "fileupload0_onlinelink1", "file_loc", "display_name", "keywords", "notes", "content_unique_lowercase", "upload_date", "upload_user_id", "upload_user_name", "access", "xml_type"];
              const valuesArray = [p_captureID, teammateID, teammateContractTypeID, 1, parentFolderID, 0, uploadFileLoc, uploadFileDisplayNameAndExt, "", "", "", JSFUNC.now_dateYmd(), o_userID, c_userName, "open", templateXmlType];
              const valuesIdsbArray = ["i", "i", "i", "i", "i", "i", "s", "s", "s", "s", "s", "s", "i", "s", "s", "s"];
              C_CallPhpTblUIDInsertFfsRecord.add_insert("tbl_c_teammates_contracts_filefoldersystem", fieldNamesArray, valuesArray, valuesIdsbArray);

              const changeLogField = "Template Generated";
              const teammateContractTypeMap = this.props.DatabaseMobx.tbl_row_map_from_id("tbl_a_teammates_contract_types", teammateContractTypeID);
              const changeLogValue = "Teammate: " + teammateName + ", Contract: " + teammateContractTypeMap.get("name") + ", Template File: " + templateDisplayName;
              C_CallPhpTblUIDInsertFfsRecord.add_changelog_details(p_captureID, k_cardIDTeammates, "tcgt", changeLogField, changeLogValue);

              const functionOnSuccessfulInsertOfUploadedFileRecord = (i_parseResponse) => {
                if(i_parseResponse.outputObj.i0 > 0) {
                  this.set_button_text_success_and_wait_for_reset("Successfully Created and Uploaded New File"); //set button into a green complete state

                  if(JSFUNC.is_function(this.props.f_onUploadSuccess)) {
                    this.props.f_onUploadSuccess("Generated and uploaded Contract file from template: '" + uploadFileDisplayNameAndExt + "' (" + changeLogValue + ")");
                  }
                }
                else {
                  this.set_button_text_error_and_wait_for_reset("Error Inserting File Record");
                }
              }
              C_CallPhpTblUIDInsertFfsRecord.add_function("onSuccess", functionOnSuccessfulInsertOfUploadedFileRecord);

              const functionOnErrorInsertOfUploadedFileRecord = () => {
                this.set_button_text_error_and_wait_for_reset("Error Inserting File Record");
              }
              C_CallPhpTblUIDInsertFfsRecord.add_function("onError", functionOnErrorInsertOfUploadedFileRecord);

              C_CallPhpTblUIDInsertFfsRecord.execute();
              //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
            }
            else {
              this.set_button_text_error_and_wait_for_reset("Upload of New File Unsuccessful");
            }
          }
          C_CallPhpScriptCreateFileOnServer.add_function("onSuccess", functionOnSuccessfulNewServerFileCreation);

          const functionOnErrorNewServerFileCreation = (i_errorMessage) => {
            this.set_button_text_error_and_wait_for_reset(i_errorMessage);
          }
          C_CallPhpScriptCreateFileOnServer.add_function("onError", functionOnErrorNewServerFileCreation);

          C_CallPhpScriptCreateFileOnServer.execute();
          //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
        }
      }

      const functionOnErrorLoadTemplateFromServer = (i_errorMessage) => {
        this.set_button_text_error_and_wait_for_reset(i_errorMessage);
        this.props.OpenCaptureMobx.a_clear_single_capture_from_local_memory();
      }

      JSPHP.load_server_file_data_string(templateXmlFileLoc, true, functionOnSuccessfulLoadTemplateFromServer, functionOnErrorLoadTemplateFromServer, jsDescription);
    }

    JSPHP.single_capture_load_supplementary_data(p_captureID, "", functionOnSuccessfulCaptureSupplementaryDataLoad);
  }

  render() {
    const s_buttonState = this.state.s_buttonState;
    const s_buttonText = this.state.s_buttonText;

    return(
      <CEDownloadFileButton
        p_buttonState={s_buttonState}
        p_buttonText={s_buttonText}
        p_buttonWidth="16em"
        p_title={this.props.p_buttonTitle}
        p_tabIndex={this.props.p_tabIndex}
        p_canClickButtonTF={this.props.p_canClickButtonTF}
        f_onClickGenerate={this.onclick_generate_teammate_contract_template}
        f_onClickReset={this.reset_button_to_initial_state_and_clear_timeout}
        f_onClick={this.props.f_onClick}
      />
    );
  }
}));


export class SmallDownloadFileButtonForServerFile extends Component { //props: p_fileLocRootUploadsOrWeb, p_fileLocRelativeFromRoot, p_downloadSaveAsFileName, p_sizeEm, p_title
  constructor(props) {
    super(props);
    this.state = {
      s_downloadState: "init"
    }
  }

  onclick_file_download = () => {
    const p_fileLocRootUploadsOrWeb = this.props.p_fileLocRootUploadsOrWeb;
    const p_fileLocRelativeFromRoot = this.props.p_fileLocRelativeFromRoot;
    const p_downloadSaveAsFileName = this.props.p_downloadSaveAsFileName;

    const functionDownloadState = (i_downloadState) => {
      var updatedLocalFileDownloadState = i_downloadState;
      if(i_downloadState === "error") {
        alert("'" + p_downloadSaveAsFileName + "' was unsuccessful downloading from the server, please try redownloading the file");
      }
      else if(i_downloadState === "fileDoesNotExist") {
        updatedLocalFileDownloadState = "error";
        alert("'" + p_downloadSaveAsFileName + "' could not be downloaded from the server");
      }
      this.setState({s_downloadState:updatedLocalFileDownloadState});

      //download icon indicator stays in red 'error' or green 'success' state for 5 seconds, then returns back to white 'initial' state
      if(i_downloadState !== "working") {
        this.timeoutID = setTimeout(() => this.reset_button_to_initial_state_and_clear_timeout(), 5000);
      }
    }

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - SmallDownloadFileButtonForServerFile", "onclick_file_download", ["p_fileLocRootUploadsOrWeb", "p_fileLocRelativeFromRoot", "p_downloadSaveAsFileName"], [p_fileLocRootUploadsOrWeb, p_fileLocRelativeFromRoot, p_downloadSaveAsFileName]);

    JSPHP.check_file_exists_on_server_call_download_php_and_offer_download(p_fileLocRootUploadsOrWeb, p_fileLocRelativeFromRoot, p_downloadSaveAsFileName, functionDownloadState, jsDescription);
  }

  reset_button_to_initial_state_and_clear_timeout = () => {
    this.setState({s_downloadState:"init"});
    clearTimeout(this.timeoutID);
  }

  render() {
    const s_downloadState = this.state.s_downloadState;
    
    const p_fileLocRootUploadsOrWeb = this.props.p_fileLocRootUploadsOrWeb;
    const p_fileLocRelativeFromRoot = this.props.p_fileLocRelativeFromRoot;
    const p_downloadSaveAsFileName = this.props.p_downloadSaveAsFileName;
    const p_sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 2.4);
    const p_title = this.props.p_title;

    return(
      <CEDownloadFileButton
        p_buttonState={s_downloadState}
        p_buttonText={undefined}
        p_buttonHeight={p_sizeEm + "em"}
        p_buttonWidth={p_sizeEm + "em"}
        p_iconSizeEm={p_sizeEm * 0.54}
        p_title={p_title}
        p_canClickButtonTF={true}
        f_onClick={this.onclick_file_download}
      />
    );
  }
}



class CEDownloadFileButton extends Component { //props: p_buttonState, p_buttonText, p_buttonHeight, p_buttonWidth, p_iconSizeEm, p_title, p_tabIndex, p_canClickButtonTF, f_onClickGenerate, f_onClickReset, f_onClick
  onclick_button = () => {
    const p_buttonState = this.props.p_buttonState;

    if((p_buttonState === "init") && JSFUNC.is_function(this.props.f_onClickGenerate)) {
      this.props.f_onClickGenerate();
    }
    else if((p_buttonState === "success") && JSFUNC.is_function(this.props.f_onClickReset)) {
      this.props.f_onClickReset();
    }

    this.call_input_onclick();
  }

  call_input_onclick = () => {
    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick();
    }
  }

  render() {
    const p_buttonState = this.props.p_buttonState; //"init", "error", "working", "success"
    const p_buttonText = this.props.p_buttonText;
    const p_buttonHeight = JSFUNC.prop_value(this.props.p_buttonHeight, "3.3em");
    const p_buttonWidth = JSFUNC.prop_value(this.props.p_buttonWidth, "13em");
    const p_iconSizeEm = JSFUNC.prop_value(this.props.p_iconSizeEm, 1.8);
    const p_canClickButtonTF = JSFUNC.prop_value(this.props.p_canClickButtonTF, true);

    var arrowColor = "fff";
    var textItalicTF = true;
    if(p_buttonState === "init") {
      textItalicTF = false;
    }
    else if(p_buttonState === "error") {
      arrowColor = "f33";
    }
    else if(p_buttonState === "working") {
      arrowColor = "ff5";
    }
    else if(p_buttonState === "success") {
      arrowColor = "3f3";
    }

    return(
      <LibraryReact.InteractiveDiv
        p_class="displayFlexRow generateTemplateButtonBgBorderAndHover textCenter cursorPointer"
        p_styleObj={{height:p_buttonHeight, width:p_buttonWidth}}
        p_tabIndex={this.props.p_tabIndex}
        p_title={this.props.p_title}
        f_onClick={((p_canClickButtonTF) ? (this.onclick_button) : (this.call_input_onclick))}
        f_onKeyDownEnter={((this.props.p_tabIndex > 0) ? (this.onclick_button) : (undefined))}>
        <div className={((p_buttonText !== undefined) ? ("flex00a") : ("flex11a")) + " displayFlexColumnHcVc"} style={{flexBasis:"3em"}}>
          <CEIconsReact.SvgDownloadIcon p_sizeEm={p_iconSizeEm} p_color={arrowColor} />
        </div>
        {(p_buttonText !== undefined) &&
          <div className="flex11a displayFlexRowVc lrPad">
            <LibraryReact.MaxHeightWrap p_maxHeight="2.7em" p_fontClass={"fontWhite " + ((textItalicTF) ? ("fontItalic") : (""))}>
              {p_buttonText}
            </LibraryReact.MaxHeightWrap>
          </div>
        }
      </LibraryReact.InteractiveDiv>
    );
  }
}













































//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//Admin Add/Edit/Delete Tables
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
export class AddEditDeleteTable extends Component { //props: p_dataArrayOfObjs, p_aedTableObj, f_onClickAddItem
  //p_aedTableObj:
  //  - tblName
  //  - canAddNewItemsTF
  //  - canHighlightAlreadyAddedItemsTF             [optional: default false] show a "View ->" button for rows already present in idsAlreadyAddedArray
  //  - highlightedItemID                           [optional: default undefined] ID of the item to be highlighted in the table
  //  - functionOnClickViewItemToHighlight          [optional: default undefined] function to call when the "View ->" button is clicked for rows already present in idsAlreadyAddedArray
  //  - canDeleteItemsTF
  //  - dragToResortFieldDbName
  //  - maskResortFieldDbName                       [optional: default undefined] will mask the dragToResortFieldDbName value from each data row with the value from the field maskResortFieldDbName instead of the dragToResortFieldDbName for each row in the AED table, this does not affect the resorting operation as the drag/drop works only on id numbers
  //  - canAlwaysDragResortTF                       [optional: default false] normal dragToResort behavior is to prevent drag when there is only 1 item, this will override that rule to allow dragging (to drop zones in different receiving zones) even when there is only 1 item
  //  - initialSortedFieldDbName
  //  - initialSortedFieldIsAscTF
  //  - tableWidth
  //  - itemName
  //  - deleteItemNameFieldDbName
  //  - searchFieldDbName
  //  - canAddItemsFromAddColumnTF
  //  - idsAlreadyAddedArray
  //  - newItemConstantFieldNamesArray
  //  - newItemConstantValuesArray
  //  - newItemConstantIdsbArray
  //  - newItemAddDbNameColumnFromDisplayNameTF     [optional: default false]
  //  - addNewItemInlineTextInputFieldDbName        [optional: default undefined] default opens a Create New Item extra floating box containing all field columns to input, specifying this fieldDbName will replace the Add Item button at the top of the table with a text input to type a new entry, saving this text creates a new entry filling the text into the specified field dbName
  //  - editItemFieldWidth                          [optional: default "15em"]
  //  - itemInsertFunctionsArray
  //  - itemInsertFunctionOnSuccess
  //  - insertDeleteResortFilterFieldNamesArray     
  //  - insertDeleteResortFilterValuesArray
  //  - itemDeleteFunctionsArray                    [optional] array of funcions, each with inputs functionOnDeleteItem(i_C_CallPhpTblUID, i_dataRowObj), called in-line with the delete function for individual items (or on all items if deleting whole table), useful for 'ALTER TABLE' column adjustments to tbls so that the operation happens on the same php call as the delete to save roundtrips to the database
  //  - itemDeleteOnSuccessFunction                 [optional] single function with input functionOnSuccessDeleteItems(i_successfullyDeletedRowIDsArray), called after the delete operation was confirmed successful with only the successfully deleted rowIDs provided as input
  //  - unassignedMatchingCapturesObj               prints at the bottom of the table within the AED box if there are more than 0 unassigned captures specified in this obj, used to complement each fieldObj having matchingCapturesObjTF as a column
  //  - importFromCsvLabel                          [optional] prints a bold line of the provided text in the .csv import floating box below the floating box title to tell users where this import data is going
  //  - importFromCsvIntoFieldDbName                [optional: default undefined] if set, this puts a button at the bottom of the table offering an interface to import many rows for a single field from a .csv file
  //  - includeUniqueIDColumnTF                     [optional: default false] if set, this puts a column 6em wide as the last column in the tbl showing the database unique id number in a light gray italic font
  //  - fieldsArrayOfObjs
  //      - width
  //      - fixedWidthTF                              [optional: default false] if true, uses fixed flex00a for column widths instead of standard flexing flex11a
  //      - dbName
  //      - displayName
  //      - fieldTypeObj
  //      - valuesToNotIncludeArray
  //      - initialValue
  //      - cellHoverTF                               [optional: default false] shows hover text of contents of cell
  //      - cellCenterTF                              [optional: default false] centers cell text
  //      - cellDisplayBlankIfNotFilledOutTF          [optional: default false] if the field is not filled out, "" is displayed in the cell instead of the not filled out valueMask
  //      - rawValueFalseDisplaysNAAndNoEditTF        [optional: default false] used for field num_decimals where it is N/A depending on the input_type field, and can only be edited on the edit form if it's not N/A
  //      - rawValueDisplayedFieldNotOnFormTF         [optional: default false] used for calculated table column like # Answers, displays the value for each item in the table, but does not show up at all on the new/edit forms
  //      - rawValueDisplayedFieldIsReadOnlyOnFormTF  [optional: default false] used for values that cannot be edited (like Details Fields Input Type) where the raw value (actually the mask) is precalculated, and displayed, but can't be edited in the form
  //      - onlyEditableDuringCreateUneditableOnEditTF[optional: default false] used for values like setting a Capture Field, which has other field dependent on the choice made, can be edited during creation, but make it uneditable (but shown) on edit form after creating the row
  //      - onlyEditableInEditNotShownOnCreateNewTF   [optional: default false] field completely hidden on 'Create New' floating box, shown normally when editing a field already created (used in cases where e.g. a SumRow field is only applicable to certain choices from the select of an above field)
  //      - requiredNotEmptyTF                        creating a new row, this particular field cannot be left blank, displays a red error message and cannot save if it's blank
  //      - requiredUniqueDbNameArray                 creating a new row, this display_name field (when converted to a db_name string format) must not exist in this provided array, error message if it does
  //      - inputMaxChars                             if set with a number, any text input will limit max number of characters that can be typed
  //      - matchingCapturesObjTF                     when set to true, this will use the matchingCapturesObj attached to the dataRowObj and ignore dbName and fieldTypeObj, this count of captures will not show up on the edit form
  //      - onkeydownenterAddsNewItemTF               [optional: default false] when adding a new item, when this field is focused, pushing the enter key performs the same action as clicking the blue button at the bottom of the floating box to add this new item

  constructor(props) {
    super(props);
    this.state = {
      s_isAddingNewItemTF: false,
      s_searchText: ""
    };
  }

  onclick_open_add_new_item_floating_box = () => {
    this.setState({s_isAddingNewItemTF:true});
  }

  onclick_close_add_new_item_floating_box = () => {
    this.setState({s_isAddingNewItemTF:false});
  }

  onchange_search_text = (i_newValue) => {
    if(JSFUNC.is_function(this.props.f_onChangeSearchText)) {
      this.props.f_onChangeSearchText(i_newValue);
    }
    else {
      this.setState({s_searchText:i_newValue});
    }
  }

  ondelete_all_table_items = () => {
    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_aedTableObj = this.props.p_aedTableObj;
    
    //get all or filtered dataArrayOfObjs to delete (filtering is computed using both insertDeleteResortFilterFieldNamesArray and insertDeleteResortFilterValuesArray arrays, when provided they are the filter on the tbl for this particular AEDTable)
    var dataToDeleteArrayOfObjs = p_dataArrayOfObjs;
    if(JSFUNC.is_array(p_aedTableObj.insertDeleteResortFilterFieldNamesArray) && JSFUNC.is_array(p_aedTableObj.insertDeleteResortFilterValuesArray) && (p_aedTableObj.insertDeleteResortFilterFieldNamesArray.length === p_aedTableObj.insertDeleteResortFilterValuesArray.length)) {
      dataToDeleteArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_arrayOfObjs_matching_multiple_fields_and_values(p_dataArrayOfObjs, p_aedTableObj.insertDeleteResortFilterFieldNamesArray, p_aedTableObj.insertDeleteResortFilterValuesArray);
    }
    
    if(dataToDeleteArrayOfObjs.length > 0) {
      const jsDescription = JSFUNC.js_description_from_action("AdminReact - AddEditDeleteTable", "ondelete_all_table_items", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      //single tbl delete on all rowIDs
      const dataRowIDsToDeleteArray = JSFUNC.get_column_vector_from_arrayOfObjs(dataToDeleteArrayOfObjs, "id");
      C_CallPhpTblUID.add_delete(p_aedTableObj.tblName, dataRowIDsToDeleteArray);

      //add any custom in-line delete functions that happen within the same php call if specified by the p_aedTableObj input "itemDeleteFunctionsArray"
      if(JSFUNC.is_array(p_aedTableObj.itemDeleteFunctionsArray)) {
        for(let dataRowObj of dataToDeleteArrayOfObjs) {
          for(let itemDeleteFunction of p_aedTableObj.itemDeleteFunctionsArray) {
            if(JSFUNC.is_function(itemDeleteFunction)) {
              itemDeleteFunction(C_CallPhpTblUID, dataRowObj); //apply each delete function per rowID deleted
            }
          }
        }
      }

      //add a post-success item delete function if specified by the p_aedTableObj input "itemDeleteOnSuccessFunction"
      if(JSFUNC.is_function(p_aedTableObj.itemDeleteOnSuccessFunction)) {
        const functionOnSuccessDeleteAllTableItems = (i_parseResponse) => {
          if(i_parseResponse.outputObj.d0 === "1") { //single delete operation "d0" that deleted every input rowID in dataRowIDsToDeleteArray
            p_aedTableObj.itemDeleteOnSuccessFunction(dataRowIDsToDeleteArray);
          }
        }
        C_CallPhpTblUID.add_function("onSuccess", functionOnSuccessDeleteAllTableItems);
      }

      C_CallPhpTblUID.execute();
    }
  }

  render() {
    const s_isAddingNewItemTF = this.state.s_isAddingNewItemTF;
    const s_searchText = ((this.props.p_searchText !== undefined) ? (this.props.p_searchText) : (this.state.s_searchText));

    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_aedTableObj = this.props.p_aedTableObj;

    //set default values for adding/deleting fields input flags
    const canAddNewItemsTF = JSFUNC.prop_value(p_aedTableObj.canAddNewItemsTF, true);
    const canDeleteItemsTF = JSFUNC.prop_value(p_aedTableObj.canDeleteItemsTF, true);
    const includeUniqueIDColumnTF = JSFUNC.prop_value(p_aedTableObj.includeUniqueIDColumnTF, false);

    const numTableRows = p_dataArrayOfObjs.length;

    //precompute more aedTable information based on the input p_aedTableObj used by both the header and the body, precompute which columns match the defined 'sort' column to avoid drawing it as the leftmost drag/drop column and as a body column (precompute to avoid string comparisons on every row/cell when rendering the table), also get the sort column width if provided
    var computedFieldsArrayOfObjs = [];
    var sortColumnWidth = "4em"; //default width of sort column is 4em until overridden by the sort column fieldObj.width
    for(let fieldObj of p_aedTableObj.fieldsArrayOfObjs) {
      var columnIsSortColumnTF = (fieldObj.dbName === p_aedTableObj.dragToResortFieldDbName);
      if(columnIsSortColumnTF) {
        sortColumnWidth = fieldObj.width;
      }

      computedFieldsArrayOfObjs.push({
        drawColumnTF: (!columnIsSortColumnTF && (fieldObj.width !== undefined)),
      });
    }

    const computedAedTableObj = {
      computedFieldsArrayOfObjs: computedFieldsArrayOfObjs,
      sortColumnWidth: sortColumnWidth,
      hasAddButtonColumnTF: ((p_aedTableObj.canAddItemsFromAddColumnTF !== undefined) && JSFUNC.is_array(p_aedTableObj.idsAlreadyAddedArray) && JSFUNC.is_function(this.props.f_onClickAddItem)),
      addButtonColumnWidth: "6em",
      canDeleteItemsTF: canDeleteItemsTF,
      includeUniqueIDColumnTF: includeUniqueIDColumnTF
    };

    //determine if the provided input searchFieldDbName matches one of the provided column fieldDbNames, then get that field's displayName
    var usingSearchTF = false;
    var searchFieldDisplayName = "";
    if(p_aedTableObj.searchFieldDbName !== undefined) {
      for(let fieldObj of p_aedTableObj.fieldsArrayOfObjs) {
        if(fieldObj.dbName === p_aedTableObj.searchFieldDbName) {
          usingSearchTF = true;
          searchFieldDisplayName = fieldObj.displayName;
        }
      }
    }
    const searchTextLower = s_searchText.toLowerCase();

    return(
      <div className="lrMedPad medTopPad smallBottomPad border bevelBorderColors borderRadius10 bgAddEditDeleteTable" style={{width:p_aedTableObj.tableWidth}}>
        <div className="displayFlexRow" style={{minHeight:((canAddNewItemsTF) ? ("3.3em") : (undefined))}}>
          {(canAddNewItemsTF) ? (
            (s_isAddingNewItemTF) ? (
              <div className="flex11a">
                <EditDeleteTableAddNewEntryButtonProcess
                  p_dataArrayOfObjs={p_dataArrayOfObjs}
                  p_aedTableObj={p_aedTableObj}
                  f_onClose={this.onclick_close_add_new_item_floating_box}
                />
              </div>
            ) : (
              <>
                {(usingSearchTF) &&
                  <div className="flex00a displayFlexColumnVc lrMargin" style={{flexBasis:"25em"}}>
                    <CEGeneralReact.SearchInputTextWithClearX
                      p_inputText={s_searchText}
                      p_placeholderText={"Filter rows matching '" + searchFieldDisplayName + "' column..."}
                      p_includeSearchIconTF={false}
                      p_tabIndex={1}
                      f_onChange={this.onchange_search_text}
                    />
                  </div>
                }
                <div className="flex11a displayFlexColumnHcVc">
                  <CEGeneralReact.CEButton
                    p_type="add"
                    p_text={"Add New " + p_aedTableObj.itemName}
                    f_onClick={this.onclick_open_add_new_item_floating_box}
                  />
                </div>
              </>
            )
          ) : (
            <div className="flex11a" />
          )}
          <div className="flex00a displayFlexColumnHcVc lrMedPad textCenter">
            <font className="fontItalic fontTextLighter">
              {(canAddNewItemsTF) ? (
                <>
                  <div><font className="font13">{numTableRows}</font></div>
                  <div>{JSFUNC.plural(numTableRows, "Item", "Items")}</div>
                </>
              ) : (
                <div className="smallBottomMargin">
                  {numTableRows + " " + JSFUNC.plural(numTableRows, "Item", "Items")}
                </div>
              )}
            </font>
          </div>
          {(canDeleteItemsTF) &&
            <div className="flex00a displayFlexColumnHcVc">
              <CEGeneralReact.DeleteMenu
                p_message={"Are you sure you want to delete all " + p_aedTableObj.itemName + " items (" + numTableRows + ") in this table?"}
                p_menuItemText="Delete All Table Items"
                f_onDelete={this.ondelete_all_table_items}
              />
            </div>
          }
        </div>
        <EditDeleteTable
          p_dataArrayOfObjs={p_dataArrayOfObjs}
          p_aedTableObj={p_aedTableObj}
          p_computedAedTableObj={computedAedTableObj}
          p_searchTextLower={searchTextLower}
          f_onClickAddItem={this.props.f_onClickAddItem}
        />
        {(p_aedTableObj.unassignedMatchingCapturesObj !== undefined) &&
          <div className="smallTopMargin">
            <UnassignedMatchingCapturesBoxAndCountButton
              p_unassignedMatchingCapturesObj={p_aedTableObj.unassignedMatchingCapturesObj}
              p_fieldDisplayName={p_aedTableObj.itemName}
            />
          </div>
        }
        {(p_aedTableObj.importFromCsvIntoFieldDbName !== undefined) &&
          <div className="smallTopMargin medBottomMargin">
            <AEDTableImportItemsFromCsvFile
              p_dataArrayOfObjs={p_dataArrayOfObjs}
              p_aedTableObj={p_aedTableObj}
            />
          </div>
        }
      </div>
    );
  }
}

function EditDeleteTableAddNewEntryButtonProcess(props) { //props: p_dataArrayOfObjs, p_aedTableObj, f_onClose
  const p_dataArrayOfObjs = props.p_dataArrayOfObjs;
  const p_aedTableObj = props.p_aedTableObj;

  if(p_aedTableObj.addNewItemInlineTextInputFieldDbName !== undefined) { //Add Item button turns into inline text edit to add single field instead of a floating box
    return(
      <AddEditDeleteTableAddNewItemInlineTextSingleField
        p_dataArrayOfObjs={p_dataArrayOfObjs}
        p_aedTableObj={p_aedTableObj}
        f_onClickCancel={props.f_onClose}
      />
    );
  }
  else if(p_aedTableObj.tblName === "tbl_captures_fields") {
    return(
      <AddEditDeleteTableAddNewCaptureFieldFloatingBox
        p_aedTableObj={p_aedTableObj}
        f_onClickClose={props.f_onClose}
      />
    );
  }
  else if(p_aedTableObj.tblName === "tbl_a_shaping_questions_pool") {
    return(
      <AddEditDeleteTableAddNewDealShapingQuestionFloatingBox
        p_dataArrayOfObjs={p_dataArrayOfObjs}
        p_aedTableObj={p_aedTableObj}
        f_onClickClose={props.f_onClose}
      />
    );
  }

  return(
    <AddEditDeleteTableAddNewItemFloatingBox
      p_dataArrayOfObjs={p_dataArrayOfObjs}
      p_aedTableObj={p_aedTableObj}
      f_onClickClose={props.f_onClose}
    />
  );
}


class AddEditDeleteTableAddNewItemInlineTextSingleField extends Component { //props: p_dataArrayOfObjs, p_aedTableObj, f_onClickCancel
  constructor(props) {
    super(props);
    this.state = {
      s_newSingleFieldValue: "",
      s_showErrorsTF: false
    }
  }

  onchange_new_single_field_value = (i_newValue) => {
    this.setState({s_newSingleFieldValue:i_newValue});
  }

  onclick_add_new_item_from_inline_text = () => {
    const s_newSingleFieldValue = this.state.s_newSingleFieldValue;
    if(s_newSingleFieldValue === "") { //new value to add cannot be blank
      this.setState({s_showErrorsTF:true});
    }
    else {
      const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
      const p_aedTableObj = this.props.p_aedTableObj;

      const tblName = p_aedTableObj.tblName;
      const dragToResortFieldDbName = p_aedTableObj.dragToResortFieldDbName;
      const addNewItemInlineTextInputFieldDbName = p_aedTableObj.addNewItemInlineTextInputFieldDbName;

      const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - AddEditDeleteTableAddNewItemInlineTextSingleField", "onclick_add_new_item_from_inline_text", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      //insert the new row with the new field value (and sort at the bottom if there is a dragtoresort column)
      var fieldNamesArray = [addNewItemInlineTextInputFieldDbName];
      var valuesArray = [s_newSingleFieldValue];
      var idsbArray = ["s"];
      if(dragToResortFieldDbName !== undefined) {
        fieldNamesArray.push(dragToResortFieldDbName);
        valuesArray.push(p_dataArrayOfObjs.length + 1); //insert the new item at the bottom of the existing items
        idsbArray.push("i");
      }
      C_CallPhpTblUID.add_insert(tblName, fieldNamesArray, valuesArray, idsbArray);

      C_CallPhpTblUID.execute();

      if(JSFUNC.is_function(this.props.f_onClickCancel)) {
        this.props.f_onClickCancel();
      }
    }
  }

  render() {
    const s_newSingleFieldValue = this.state.s_newSingleFieldValue;
    const s_showErrorsTF = this.state.s_showErrorsTF;

    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_aedTableObj = this.props.p_aedTableObj;

    const itemName = p_aedTableObj.itemName;
    const newSingleFieldValueErrorTF = (s_showErrorsTF && (s_newSingleFieldValue === ""));

    return(
      <div className="tbPad lrMedPad smallBottomMargin bgCaptureItemEditing">
        <div className="microBottomMargin">
          <font className="fontItalic fontTextLight">
            {"Add New " + itemName}
          </font>
        </div>
        <LibraryReact.Text
          p_value={s_newSingleFieldValue}
          p_styleObj={{width:"100%"}}
          p_tabIndex={1}
          p_errorTF={newSingleFieldValueErrorTF}
          f_onChange={this.onchange_new_single_field_value}
          f_onKeyDownEnter={this.onclick_add_new_item_from_inline_text}
        />
        {(newSingleFieldValueErrorTF) &&
          <CEGeneralReact.ErrorText p_text={"New " + itemName + " cannot be blank"} />
        }
        <div className="displayFlexRowVc smallTopMargin">
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="blue"
              p_text="Add"
              f_onClick={this.onclick_add_new_item_from_inline_text}
            />
          </div>
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text="Cancel"
              f_onClick={this.props.f_onClickCancel}
            />
          </div>
        </div>
      </div>
    );
  }
}

const AddEditDeleteTableAddNewItemFloatingBox = inject("DatabaseMobx")(observer(
class AddEditDeleteTableAddNewItemFloatingBox extends Component { //props: p_dataArrayOfObjs, p_aedTableObj, f_onClickClose
  constructor(props) {
    super(props);
    
    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_aedTableObj = this.props.p_aedTableObj;

    var initialDataObj = {};
    for(let fieldObj of p_aedTableObj.fieldsArrayOfObjs) {
      var fieldInitializedValue = fieldObj.initialValue;

      //for the drag to resort sort column initialization, set the sort number to the number of items currently in the table +1 (N+1) to put the new item on the bottom by default
      if(fieldObj.dbName === p_aedTableObj.dragToResortFieldDbName) {
        fieldInitializedValue = p_dataArrayOfObjs.length + 1;
      }

      initialDataObj[fieldObj.dbName] = fieldInitializedValue;
    }

    this.state = {
      s_dataObj: initialDataObj,
      s_showErrorsTF: false //set to true the first time the create new button is pushed at the bottom and stays true, this enables any errors preventing creation to be displayed
    }
  }

  onchange_input_value_update_data = (i_fieldDbName, i_newValue) => {
    var s_dataObj = this.state.s_dataObj;

    var updatedDataObj = s_dataObj;
    updatedDataObj[i_fieldDbName] = i_newValue;
    this.setState({s_dataObj:updatedDataObj});
  }

  compute_error_message_obj() {
    var s_dataObj = this.state.s_dataObj;

    const p_aedTableObj = this.props.p_aedTableObj;

    var errorMessageObj = {numErrors:0}; //if a field is detected to have an error while trying to create the new row, fill this obj with "fieldDbName: errorMessage" for each field

    for(let fieldObj of p_aedTableObj.fieldsArrayOfObjs) {
      if(fieldObj.requiredNotEmptyTF) {
        //use the field input type and state stored new value to determine if the field is 'filled out'
        var valueRaw = s_dataObj[fieldObj.dbName];
        var valueIsFilledOutTF = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(valueRaw, fieldObj.fieldTypeObj);
        if(!valueIsFilledOutTF) {
          errorMessageObj[fieldObj.dbName] = "'" + fieldObj.displayName + "' cannot be be blank.";
          errorMessageObj.numErrors++;
        }
      }

      if(JSFUNC.is_array(fieldObj.requiredUniqueDbNameArray)) {
        var s_dataObj = this.state.s_dataObj;

        //determine if the new value (when converted from "New Name" to "new_name") already exists in the provided array
        var fieldValue = s_dataObj[fieldObj.dbName];
        var fieldValueConvertedToDbName = JSFUNC.db_name_from_display_name(fieldValue);
        if(JSFUNC.in_array(fieldValueConvertedToDbName, fieldObj.requiredUniqueDbNameArray)) {
          errorMessageObj[fieldObj.dbName] = "'" + fieldValue + "' already exists. Please enter a unique name for this new item.";
          errorMessageObj.numErrors++;
        }
      }

      if(JSFUNC.is_number_not_nan_gte_0(fieldObj.inputMaxChars)) {
        var s_dataObj = this.state.s_dataObj;
        var fieldValue = s_dataObj[fieldObj.dbName];
        if(JSFUNC.is_string(fieldValue)) {
          var fieldValueCurrentNumChars = fieldValue.length;
          if(fieldValueCurrentNumChars > fieldObj.inputMaxChars) {
            errorMessageObj[fieldObj.dbName] = "Limit of " + fieldObj.inputMaxChars + " characters exceeded (" + fieldValueCurrentNumChars + " characters entered).";
            errorMessageObj.numErrors++;
          }
        }
      }
    }

    return(errorMessageObj);
  }

  onclick_add_new_item = () => {
    const p_aedTableObj = this.props.p_aedTableObj;

    //check if any of the fields are required to not be blank before creating the new row
    const errorMessageObj = this.compute_error_message_obj();

    //if all fields have no errors, proceed to insert the new row into the database and local memory (input fields and "constant value" fields combined)
    if(errorMessageObj.numErrors > 0) {
      this.setState({s_showErrorsTF:true});
    }
    else {
      const s_dataObj = this.state.s_dataObj;

      //inject the constant values if any were provided as input
      var fieldNamesArray = [];
      var valuesArray = [];
      var idsbArray = [];
      if(JSFUNC.is_array(p_aedTableObj.newItemConstantFieldNamesArray) && JSFUNC.is_array(p_aedTableObj.newItemConstantValuesArray) && JSFUNC.is_array(p_aedTableObj.newItemConstantIdsbArray)) {
        fieldNamesArray = p_aedTableObj.newItemConstantFieldNamesArray;
        valuesArray = p_aedTableObj.newItemConstantValuesArray;
        idsbArray = p_aedTableObj.newItemConstantIdsbArray;
      }

      //add the user edited field values from the form
      for(let fieldObj of p_aedTableObj.fieldsArrayOfObjs) {
        if(fieldObj.fieldTypeObj !== undefined) {
          var newValue = s_dataObj[fieldObj.dbName];

          //when specifying the sort for the new entry, if it was changed from the default last entry N+1 sort number, use the value-1 so that it sorts above the existing row that already has the sort value in the table
          if(fieldObj.dbName === p_aedTableObj.dragToResortFieldDbName) {
            newValue = newValue - 1;
          }

          fieldNamesArray.push(fieldObj.dbName);
          valuesArray.push(newValue);
          idsbArray.push(fieldObj.fieldTypeObj.idsb);
        }
      }

      //add a column "db_name" converted from the display_name column if specified by the flag newItemAddDbNameColumnFromDisplayNameTF (used for contacts/teammates/competitors extra field tables)
      if(p_aedTableObj.newItemAddDbNameColumnFromDisplayNameTF) {
        fieldNamesArray.push("db_name");
        valuesArray.push(JSFUNC.db_name_from_display_name(s_dataObj.display_name));
        idsbArray.push("s");
      }

      //handle resorting the list of items after the new insert if a sort column was provided
      var resortSortColumnName = undefined;
      var resortFilterFieldNamesArray = undefined;
      var resortFilterValuesArray = undefined;
      if(p_aedTableObj.dragToResortFieldDbName !== undefined) { //if a sort column was provided, resort the tbl by that column after insert
        resortSortColumnName = p_aedTableObj.dragToResortFieldDbName;
        if(JSFUNC.is_array(p_aedTableObj.insertDeleteResortFilterFieldNamesArray) && JSFUNC.is_array(p_aedTableObj.insertDeleteResortFilterValuesArray) && (p_aedTableObj.insertDeleteResortFilterFieldNamesArray.length === p_aedTableObj.insertDeleteResortFilterValuesArray.length)) {
          resortFilterFieldNamesArray = p_aedTableObj.insertDeleteResortFilterFieldNamesArray; //if resort filter fields/valuse were provided, use those as well when inserting/resorting
          resortFilterValuesArray = p_aedTableObj.insertDeleteResortFilterValuesArray;
        }
        else { //if not, simply resort entire table on sort column without filtering
          resortFilterFieldNamesArray = [];
          resortFilterValuesArray = [];
        }
      }

      const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - AddEditDeleteTableAddNewItemFloatingBox", "onclick_add_new_item", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      //insert the new row with all entered field values
      C_CallPhpTblUID.add_insert(p_aedTableObj.tblName, fieldNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNamesArray, resortFilterValuesArray);

      //add any custom insert operations that follow the main item being inserted if specified by the p_aedTableObj input "itemInsertFunctionsArray"
      if(JSFUNC.is_array(p_aedTableObj.itemInsertFunctionsArray)) {
        for(let itemInsertFunction of p_aedTableObj.itemInsertFunctionsArray) {
          if(JSFUNC.is_function(itemInsertFunction)) {
            itemInsertFunction(C_CallPhpTblUID, s_dataObj);
          }
        }
      }

      //add any custom insert operations that happen after the successful insert of this new item row (the passed input data object contains the unique database id number of the newly inserted row)
      if(JSFUNC.is_function(p_aedTableObj.itemInsertFunctionOnSuccess)) {
        C_CallPhpTblUID.add_function("onSuccess", p_aedTableObj.itemInsertFunctionOnSuccess);
      }

      C_CallPhpTblUID.execute();

      if(JSFUNC.is_function(this.props.f_onClickClose)) {
        this.props.f_onClickClose();
      }
    }
  }

  render() {
    const s_dataObj = this.state.s_dataObj;
    const s_showErrorsTF = this.state.s_showErrorsTF;

    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_aedTableObj = this.props.p_aedTableObj;

    //set p_tabIndex for each open item in this create form to count [1, 11, 21, 31, ...] so that inputs in edit mode that have multiple sub pieces to tab to (like Styling) have 10 incremental tab slots to themselves [21,22,23,24,...]
    const tabSkipInterval = 10;

    //only need to compute the errors if the create new button has been pushed at least once where it's possible for the errors to be shown
    var errorMessageObj = {};
    if(s_showErrorsTF) {
      errorMessageObj = this.compute_error_message_obj();
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditItem"
        p_title={"Adding a New " + p_aedTableObj.itemName}
        f_onClickCancel={this.props.f_onClickClose}>
        <div className="flex11a yScroll medFullPad">
          {p_aedTableObj.fieldsArrayOfObjs.map((m_fieldObj, m_index) =>
            <AddEditDeleteTableAddNewItemFieldInput
              key={m_fieldObj.dbName}
              p_fieldObj={m_fieldObj}
              p_valueRaw={s_dataObj[m_fieldObj.dbName]}
              p_tabIndex={((m_index * tabSkipInterval) + 1)}
              p_errorMessage={errorMessageObj[m_fieldObj.dbName]}
              f_onChange={this.onchange_input_value_update_data}
              f_onKeyDownEnter={this.onclick_add_new_item}
            />
          )}
        </div>
        <div className="flex00a displayFlexColumnHcVc tbPad borderT1ddd">
          <CEGeneralReact.CEButton
            p_type="blue"
            p_text={"Add New " + p_aedTableObj.itemName}
            p_tabIndex={((p_aedTableObj.fieldsArrayOfObjs.length + 1) * tabSkipInterval)}
            f_onClick={this.onclick_add_new_item}
          />
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

class AddEditDeleteTableAddNewItemFieldInput extends Component { //props: p_fieldObj, p_valueRaw, p_tabIndex, p_errorMessage, f_onChange, f_onKeyDownEnter
  onchange_input_value = (i_newValue) => {
    const fieldObj = this.props.p_fieldObj;
    const valueRaw = this.props.p_valueRaw;

    if(JSFUNC.is_function(this.props.f_onChange) && (i_newValue !== valueRaw)) {
      this.props.f_onChange(fieldObj.dbName, i_newValue);
    }
  }

  onkeydownenter_add_new_item = () => {
    if(JSFUNC.is_function(this.props.f_onKeyDownEnter)) {
      this.props.f_onKeyDownEnter();
    }
  }

  render() {
    const fieldObj = this.props.p_fieldObj;
    const valueRaw = this.props.p_valueRaw;
    const tabIndex = this.props.p_tabIndex;
    const errorMessage = this.props.p_errorMessage;

    if(fieldObj.fieldTypeObj === undefined) {
      return(null);
    }

    //if the property for this field onlyEditableInEditNotShownOnCreateNewTF is set to true, do not show this field on the create new form
    if(fieldObj.onlyEditableInEditNotShownOnCreateNewTF) {
      return(null);
    }

    return(
      <div className="displayFlexRowVc">
        <div className="flex00a displayFlexRowVc" style={{flexBasis:"17em"}}>
          <div className="flex11a">
            <font className="fontBlue">
              {fieldObj.displayName}
            </font>
          </div>
        </div>
        <div className="flex11a tbMargin" style={{height:((fieldObj.fieldTypeObj.textareaTF) ? ("10em") : (undefined))}}>
          <CEGeneralReact.GenericInputOrSelectFromInputType
            p_fieldTypeObj={fieldObj.fieldTypeObj}
            p_valueRaw={valueRaw}
            p_valuesToNotIncludeArray={fieldObj.valuesToNotIncludeArray}
            p_selectInitOptionsBoxOpenTF={false}
            p_tabIndex={tabIndex}
            p_title={undefined}
            p_errorTF={(errorMessage !== undefined)}
            f_onChangeOrOnSelect={this.onchange_input_value}
            f_onKeyDownEnter={((fieldObj.onkeydownenterAddsNewItemTF) ? (this.onkeydownenter_add_new_item) : (undefined))}
          />
          {(errorMessage !== undefined) &&
            <CEGeneralReact.ErrorText p_class="microTopMargin microBottomMargin" p_text={errorMessage} />
          }
        </div>
      </div>
    );
  }
}

class EditDeleteTable extends Component { //props: p_dataArrayOfObjs, p_aedTableObj, p_computedAedTableObj, p_searchTextLower, f_onClickAddItem
  constructor(props) {
    super(props);

    const p_aedTableObj = this.props.p_aedTableObj;

    var initialSortIsAscTF = JSFUNC.prop_value(p_aedTableObj.initialSortedFieldIsAscTF, true); //default column to sort by is the leftmost "sort" column ASC (if it exists)

    var initialHeaderSortObj = undefined;
    if(p_aedTableObj.initialSortedFieldDbName !== undefined) { //if this input is not defined, no sorting is applied (whole headerSortObj is undefined as a flag)
      if(JSFUNC.is_array(p_aedTableObj.initialSortedFieldDbName) && !JSFUNC.is_array(initialSortIsAscTF)) {
        initialSortIsAscTF = JSFUNC.array_fill(p_aedTableObj.initialSortedFieldDbName.length, true); //if an array of sort fieldDbNames was provided, but only a single sort value (or no sort value, which defaults to true), make an array the same length with the same value replicated
      }

      initialHeaderSortObj = {
        fieldDbNamesArray: JSFUNC.convert_single_or_array_to_array(p_aedTableObj.initialSortedFieldDbName),
        isAscTFArray: JSFUNC.convert_single_or_array_to_array(initialSortIsAscTF)
      }
    }

    this.state = {
      s_headerSortObj: initialHeaderSortObj
    };
  }

  onclick_header = (i_fieldDbName) => {
    const s_headerSortObj = this.state.s_headerSortObj;

    var newHeaderSortFieldDbNamesArray = [i_fieldDbName];
    var newHeaderSortIsAscTFArray = [true];
    if(s_headerSortObj !== undefined) {
      const oldHeaderSortFieldDbNamesArray = s_headerSortObj.fieldDbNamesArray;
      const oldHeaderSortIsAscTFArray = s_headerSortObj.isAscTFArray;
      if(JSFUNC.is_array(oldHeaderSortFieldDbNamesArray) && JSFUNC.is_array(oldHeaderSortIsAscTFArray)) {
        if((oldHeaderSortFieldDbNamesArray.length === 1) && (oldHeaderSortIsAscTFArray.length === 1)) { //only 1 column is currently sorted, can do the comparison to see if the same column was just clicked to flip the sort direction
          const oldHeaderSortFieldDbName = oldHeaderSortFieldDbNamesArray[0];
          const oldHeaderSortIsAscTF = oldHeaderSortIsAscTFArray[0];
          const newHeaderSortFieldDbName = i_fieldDbName;
          const newHeaderSortIsAscTF = ((i_fieldDbName === oldHeaderSortFieldDbName) ? (!oldHeaderSortIsAscTF) : (true)); //flip the sort when clicking on the same column, otherwise the sort on the new column is ASC
          newHeaderSortFieldDbNamesArray = [newHeaderSortFieldDbName];
          newHeaderSortIsAscTFArray = [newHeaderSortIsAscTF];
        }
      }
    }

    const updatedHeaderSortObj = {fieldDbNamesArray:newHeaderSortFieldDbNamesArray, isAscTFArray:newHeaderSortIsAscTFArray};
    this.setState({s_headerSortObj:updatedHeaderSortObj});
  }

  render() {
    const s_headerSortObj = this.state.s_headerSortObj;

    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_aedTableObj = this.props.p_aedTableObj;
    const p_computedAedTableObj = this.props.p_computedAedTableObj;
    const p_searchTextLower = this.props.p_searchTextLower;

    //sort the items based on the currently sorted column and sort direction (both kept in the local state s_headerSortObj)
    if(s_headerSortObj !== undefined) {
      JSFUNC.sort_arrayOfObjs(p_dataArrayOfObjs, s_headerSortObj.fieldDbNamesArray, s_headerSortObj.isAscTFArray, true);
    }

    return(
      <>
        <AddEditDeleteTableHeaderRow
          p_aedTableObj={p_aedTableObj}
          p_computedAedTableObj={p_computedAedTableObj}
          p_headerSortObj={s_headerSortObj}
          f_onClickHeader={this.onclick_header}
        />
        <AddEditDeleteTableBody
          p_sortedDataArrayOfObjs={p_dataArrayOfObjs}
          p_aedTableObj={p_aedTableObj}
          p_computedAedTableObj={p_computedAedTableObj}
          p_searchTextLower={p_searchTextLower}
          f_onClickAddItem={this.props.f_onClickAddItem}
        />
      </>
    );
  }
}

function AddEditDeleteTableHeaderRow(props) { //props: p_aedTableObj, p_computedAedTableObj, p_headerSortObj, f_onClickHeader
  const p_aedTableObj = props.p_aedTableObj;
  const p_computedAedTableObj = props.p_computedAedTableObj;
  const p_headerSortObj = props.p_headerSortObj;

  return(
    <div className="displayFlexRow bgBlueGradient borderB1ddd" style={{height:"3em"}}>
      {(p_aedTableObj.dragToResortFieldDbName !== undefined) &&
        <div className="flex00a displayFlexRow" style={{flexBasis:p_computedAedTableObj.sortColumnWidth}}>
          <AddEditDeleteTableHeaderCell
            p_fieldObj={{width:p_computedAedTableObj.sortColumnWidth, dbName:p_aedTableObj.dragToResortFieldDbName, displayName:""}}
            p_headerSortObj={p_headerSortObj}
            f_onClickHeader={props.f_onClickHeader}
          />
        </div>
      }
      {p_aedTableObj.fieldsArrayOfObjs.map((m_fieldObj, m_index) =>
        (p_computedAedTableObj.computedFieldsArrayOfObjs[m_index].drawColumnTF) &&
        <AddEditDeleteTableHeaderCell
          key={m_fieldObj.dbName}
          p_fieldObj={m_fieldObj}
          p_headerSortObj={p_headerSortObj}
          f_onClickHeader={props.f_onClickHeader}
        />
      )}
      {(p_computedAedTableObj.includeUniqueIDColumnTF) &&
        <div className="flex00a displayFlexRow" style={{flexBasis:"6em"}}>
          <AddEditDeleteTableHeaderCell
            p_fieldObj={{width:"1em", dbName:"id", displayName:"Unique ID"}}
            p_headerSortObj={p_headerSortObj}
            f_onClickHeader={props.f_onClickHeader}
          />
        </div>
      }
      {(p_computedAedTableObj.hasAddButtonColumnTF) &&
        <div className="flex00a displayFlexRow" style={{flexBasis:p_computedAedTableObj.addButtonColumnWidth}}>
          <AddEditDeleteTableHeaderCell
            p_fieldObj={{width:"1em", dbName:"add->", displayName:"Add Item"}}
            p_headerSortObj={p_headerSortObj}
          />
        </div>
      }
      {(p_computedAedTableObj.canDeleteItemsTF) &&
        <div className="flex00a displayFlexRow" style={{flexBasis:"2em"}}>
          <AddEditDeleteTableHeaderCell />
        </div>
      }
    </div>
  );
}

class AddEditDeleteTableHeaderCell extends Component { //props: p_fieldObj, p_headerSortObj, f_onClickHeader
  onclick_header_cell = () => {
    const p_fieldObj = this.props.p_fieldObj;

    if(JSFUNC.is_function(this.props.f_onClickHeader)) {
      this.props.f_onClickHeader(p_fieldObj.dbName);
    }
  }

  render() {
    const p_fieldObj = this.props.p_fieldObj;
    const p_headerSortObj = this.props.p_headerSortObj;

    const fieldObjExistsTF = (p_fieldObj !== undefined);
    const headerSortableTF = JSFUNC.is_function(this.props.f_onClickHeader);

    var headerFlexClass = "flex11a";
    var headerFlexBasis = "1em";
    if(fieldObjExistsTF) {
      if(p_fieldObj.fixedWidthTF) {
        headerFlexClass = "flex00a";
      }
      headerFlexBasis = p_fieldObj.width;
    }

    var isSortedTF = false;
    var sortedAscTF = true;
    if(p_headerSortObj !== undefined) {
      const matchIndex = p_headerSortObj.fieldDbNamesArray.indexOf(p_fieldObj.dbName);
      if(matchIndex >= 0) {
        isSortedTF = true;
        sortedAscTF = p_headerSortObj.isAscTFArray[matchIndex];
      }
    }

    return(
      <div
        className={headerFlexClass + " displayFlexRowVc lrPad borderR1ddd " + ((headerSortableTF) ? ("hoverLightBlueGradient cursorPointer") : (""))}
        style={{flexBasis:headerFlexBasis}}
        onClick={this.onclick_header_cell}>
        {(fieldObjExistsTF) &&
          <>
            {(headerSortableTF) &&
              <div className="flex00a textCenter" style={{flexBasis:"1em"}}>
                <CEGeneralReact.HeaderSortArrow p_isSortedTF={isSortedTF} p_sortedAscTF={sortedAscTF} />
              </div>
            }
            <div className="flex11a lrPad textCenter" title={p_fieldObj.displayName + " [Click to sort by this column]"}>
              <LibraryReact.MaxHeightWrap p_maxHeight="2.4em" p_fontClass="fontWhite">
                {p_fieldObj.displayName}
              </LibraryReact.MaxHeightWrap>
            </div>
          </>
        }
      </div>
    );
  }
}

function AddEditDeleteTableBody(props) { //props: p_sortedDataArrayOfObjs, p_aedTableObj, p_computedAedTableObj, p_searchTextLower, f_onClickAddItem
  const p_sortedDataArrayOfObjs = props.p_sortedDataArrayOfObjs;
  const p_aedTableObj = props.p_aedTableObj;
  const p_computedAedTableObj = props.p_computedAedTableObj;
  const p_searchTextLower = props.p_searchTextLower;

  const numItems = p_sortedDataArrayOfObjs.length;
  const lastItemIndex = (numItems - 1);
  const isOnlyItemTF = (numItems === 1);

  if((p_aedTableObj.searchFieldDbName === undefined) || (p_searchTextLower === "")) {
    return(
      p_sortedDataArrayOfObjs.map((m_dataRowObj, m_index) =>
        <AddEditDeleteTableBodyRow
          key={m_dataRowObj.id}
          p_dataRowObj={m_dataRowObj}
          p_aedTableObj={p_aedTableObj}
          p_computedAedTableObj={p_computedAedTableObj}
          p_isOnlyItemTF={isOnlyItemTF}
          p_isLastItemTF={(m_index === lastItemIndex)}
          f_onClickAddItem={props.f_onClickAddItem}
        />
      )
    );
  }

  //filter the rows matching the search text to the specified field column
  return(
    p_sortedDataArrayOfObjs.map((m_dataRowObj, m_index) =>
      (m_dataRowObj[p_aedTableObj.searchFieldDbName].toLowerCase().indexOf(p_searchTextLower) >= 0) &&
      <AddEditDeleteTableBodyRow
        key={m_dataRowObj.id}
        p_dataRowObj={m_dataRowObj}
        p_aedTableObj={p_aedTableObj}
        p_computedAedTableObj={p_computedAedTableObj}
        p_isOnlyItemTF={isOnlyItemTF}
        p_isLastItemTF={(m_index === lastItemIndex)}
        f_onClickAddItem={props.f_onClickAddItem}
      />
    )
  );
}

class AddEditDeleteTableBodyRow extends Component { //props: p_dataRowObj, p_aedTableObj, p_computedAedTableObj, p_isOnlyItemTF, p_isLastItemTF, f_onClickAddItem
  constructor(props) {
    super(props);
    this.state = {
      s_aedTableEditItemFloatingBoxIsOpenTF: false
    };
  }

  onclick_open_edit_item_floating_box = () => {
    this.setState({s_aedTableEditItemFloatingBoxIsOpenTF:true});
  }

  onclick_close_edit_item_floating_box = () => {
    this.setState({s_aedTableEditItemFloatingBoxIsOpenTF:false});
  }

  render() {
    const s_aedTableEditItemFloatingBoxIsOpenTF = this.state.s_aedTableEditItemFloatingBoxIsOpenTF;

    const p_dataRowObj = this.props.p_dataRowObj;
    const p_aedTableObj = this.props.p_aedTableObj;
    const p_computedAedTableObj = this.props.p_computedAedTableObj;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    var itemSort = undefined;
    if(p_aedTableObj.maskResortFieldDbName !== undefined) {
      itemSort = p_dataRowObj[p_aedTableObj.maskResortFieldDbName];
    }
    else if(p_aedTableObj.dragToResortFieldDbName !== undefined) {
      itemSort = p_dataRowObj[p_aedTableObj.dragToResortFieldDbName];
    }

    const alreadyAddedTF = (JSFUNC.is_array(p_aedTableObj.idsAlreadyAddedArray) && JSFUNC.in_array(p_dataRowObj.id, p_aedTableObj.idsAlreadyAddedArray));
    const highlightedTF = (p_aedTableObj.highlightedItemID === p_dataRowObj.id);

    return(
      <>
        <div id={(p_aedTableObj.canHighlightAlreadyAddedItemsTF ? ("adminDetailsFieldPoolRow_" + p_dataRowObj.id) : (undefined))}>
          <CEGeneralReact.CEDragToResortItemWithinDbTbl
            p_canResortTF={(p_aedTableObj.dragToResortFieldDbName !== undefined)}
            p_uniqueString={"AddEditDeleteTableRow_" + p_aedTableObj.tblName}
            p_itemID={p_dataRowObj.id}
            p_itemSort={itemSort}
            p_itemSortColumnWidth={p_computedAedTableObj.sortColumnWidth}
            p_itemSortNumberFontClass={undefined}
            p_isOnlyItemTF={(p_isOnlyItemTF && !p_aedTableObj.canAlwaysDragResortTF)}
            p_isLastItemTF={p_isLastItemTF}
            p_outerPadClass={undefined}
            p_itemClass="borderB1ddd bgWhite hoverLighterBlueGradient"
            p_itemStyleObj={{height:"2em", backgroundColor:(highlightedTF ? "#fff4c2" : undefined)}}
            p_lastItemExtraDropZoneHeight="2em"
            p_dragEntireItemTrueOnlySortNumberFalse={true}
            p_tblName={p_aedTableObj.tblName}
            p_tblSortFieldDbName={p_aedTableObj.dragToResortFieldDbName}
            p_filterFieldNamesArray={p_aedTableObj.insertDeleteResortFilterFieldNamesArray}
            p_filterValuesArray={p_aedTableObj.insertDeleteResortFilterValuesArray}>
            <div className="flex11a displayFlexRow">
              {p_aedTableObj.fieldsArrayOfObjs.map((m_fieldObj, m_index) =>
                (p_computedAedTableObj.computedFieldsArrayOfObjs[m_index].drawColumnTF) &&
                <AddEditDeleteTableBodyCell
                  key={m_fieldObj.dbName}
                  p_aedTableObj={p_aedTableObj}
                  p_fieldObj={m_fieldObj}
                  p_dataRowObj={p_dataRowObj}
                  f_onClick={this.onclick_open_edit_item_floating_box}
                />
              )}
              {(p_computedAedTableObj.includeUniqueIDColumnTF) &&
                <div
                  className="flex00a displayFlexRowVc textCenter cursorPointer"
                  style={{flexBasis:"6em"}}
                  onClick={this.onclick_open_edit_item_floating_box}>
                  <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLightester">
                    {p_dataRowObj.id}
                  </LibraryReact.NowrapEllipsis>
                </div>
              }
              {(p_computedAedTableObj.hasAddButtonColumnTF) &&
                <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:p_computedAedTableObj.addButtonColumnWidth}}>
                  {(!alreadyAddedTF) &&
                    <AddEditDeleteTableBodyRowAddItemButton
                      p_dataRowObj={p_dataRowObj}
                      p_aedTableObj={p_aedTableObj}
                      f_onClickAddItem={this.props.f_onClickAddItem}
                    />
                  }
                  {(p_aedTableObj.canAddItemsFromAddColumnTF && alreadyAddedTF && p_aedTableObj.canHighlightAlreadyAddedItemsTF) &&
                    <button
                      type="button"
                      title="Highlight this field in the receiving table"
                      className={((highlightedTF) ? ("bgDarkGold fontBold fontWhite") : ("bgLightestYellow")) + " font08 fontItalic cursorPointer"}
                      style={{border:"1px solid #ddb", borderRadius:"0.2em", padding:"0.1em 0.25em"}}
                      onClick={() => {
                        if(JSFUNC.is_function(p_aedTableObj.functionOnClickViewItemToHighlight)) {
                          p_aedTableObj.functionOnClickViewItemToHighlight(p_dataRowObj.id);
                        }
                      }}>
                      {(highlightedTF) ? ("Viewing") : ("View ->")}
                    </button>
                  }
                </div>
              }
              {(p_computedAedTableObj.canDeleteItemsTF) &&
                <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
                  <AddEditDeleteTableBodyRowDeleteMenu
                    p_dataRowObj={p_dataRowObj}
                    p_aedTableObj={p_aedTableObj}
                  />
                </div>
              }
            </div>
          </CEGeneralReact.CEDragToResortItemWithinDbTbl>
        </div>
        {(s_aedTableEditItemFloatingBoxIsOpenTF) &&
          <AddEditDeleteTableEditItemFloatingBox
            p_dataRowObj={p_dataRowObj}
            p_aedTableObj={p_aedTableObj}
            f_onClickClose={this.onclick_close_edit_item_floating_box}
          />
        }
      </>
    );
  }
}

const AddEditDeleteTableBodyRowAddItemButton = inject("AdminMobx")(observer(
class AddEditDeleteTableBodyRowAddItemButton extends Component { //props: p_dataRowObj, p_aedTableObj, f_onClickAddItem
  onclick_add_item_button = () => {
    const p_dataRowObj = this.props.p_dataRowObj;
    const f_onClickAddItem = this.props.f_onClickAddItem;

    if(JSFUNC.is_function(f_onClickAddItem)) {
      f_onClickAddItem(p_dataRowObj.id);
    }
  }

  render() {
    const p_aedTableObj = this.props.p_aedTableObj;

    if(!p_aedTableObj.canAddItemsFromAddColumnTF) {
      return(null);
    }

    return(
      <CEGeneralReact.CEButton
        p_type="add"
        p_text="Add ->"
        f_onClick={this.onclick_add_item_button}
      />
    );
  }
}));

class AddEditDeleteTableBodyRowDeleteMenu extends Component { //props: p_dataRowObj, p_aedTableObj
  ondelete_item = () => {
    const p_dataRowObj = this.props.p_dataRowObj;
    const p_aedTableObj = this.props.p_aedTableObj;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AddEditDeleteTableBodyRowDeleteMenu", "ondelete_item", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    const itemID = p_dataRowObj.id;

    //handle resorting the list of items after the new insert if a sort column was provided
    var resortSortColumnName = undefined;
    var resortFilterFieldNamesArray = undefined;
    var resortFilterValuesArray = undefined;
    if(p_aedTableObj.dragToResortFieldDbName !== undefined) { //if a sort column was provided, resort the tbl by that column after delete
      resortSortColumnName = p_aedTableObj.dragToResortFieldDbName;
      if(JSFUNC.is_array(p_aedTableObj.insertDeleteResortFilterFieldNamesArray) && JSFUNC.is_array(p_aedTableObj.insertDeleteResortFilterValuesArray) && (p_aedTableObj.insertDeleteResortFilterFieldNamesArray.length === p_aedTableObj.insertDeleteResortFilterValuesArray.length)) {
        resortFilterFieldNamesArray = p_aedTableObj.insertDeleteResortFilterFieldNamesArray; //if resort filter fields/valuse were provided, use those as well when deleting/resorting
        resortFilterValuesArray = p_aedTableObj.insertDeleteResortFilterValuesArray;
      }
      else { //if not, simply resort entire table on sort column without filtering
        resortFilterFieldNamesArray = [];
        resortFilterValuesArray = [];
      }
    }

    //delete the item from the table using the itemID
    C_CallPhpTblUID.add_delete(p_aedTableObj.tblName, itemID, resortSortColumnName, resortFilterFieldNamesArray, resortFilterValuesArray);

    //add any custom delete operations that follow the main item being deleted if specified by the p_aedTableObj input "itemDeleteFunctionsArray"
    if(JSFUNC.is_array(p_aedTableObj.itemDeleteFunctionsArray)) {
      for(let itemDeleteFunction of p_aedTableObj.itemDeleteFunctionsArray) {
        if(JSFUNC.is_function(itemDeleteFunction)) {
          itemDeleteFunction(C_CallPhpTblUID, p_dataRowObj);
        }
      }
    }

    //add a post-success item delete function if specified by the p_aedTableObj input "itemDeleteOnSuccessFunction"
    if(JSFUNC.is_function(p_aedTableObj.itemDeleteOnSuccessFunction)) {
      const functionOnSuccessDeleteAllTableItems = (i_parseResponse) => {
        var successfullyDeletedRowIDsArray = [];
        if(i_parseResponse.outputObj.d0 === "1") { //"d0" in outputObj have a string value of "0" or "1" for failure/success
          successfullyDeletedRowIDsArray.push(itemID);
        }

        //if there's at least 1 successfully deleted data row, call the itemDeleteOnSuccessFunction
        if(successfullyDeletedRowIDsArray.length > 0) {
          p_aedTableObj.itemDeleteOnSuccessFunction(successfullyDeletedRowIDsArray);
        }
      }
      C_CallPhpTblUID.add_function("onSuccess", functionOnSuccessDeleteAllTableItems);
    }

    C_CallPhpTblUID.execute();
  }

  render() {
    const p_dataRowObj = this.props.p_dataRowObj;
    const p_aedTableObj = this.props.p_aedTableObj;

    var deleteMessage = "";
    if(p_aedTableObj.deleteItemNameFieldDbName !== undefined) {
      deleteMessage = "Delete " + p_aedTableObj.itemName + " '" + p_dataRowObj[p_aedTableObj.deleteItemNameFieldDbName] + "'" + "?"
    }
    else {
      deleteMessage = "Delete this " + p_aedTableObj.itemName + "?";
    }

    return(
      <CEGeneralReact.DeleteMenu
        p_menuItemText="Delete"
        p_message={deleteMessage}
        f_onDelete={this.ondelete_item}
      />
    );
  }
}

const AddEditDeleteTableBodyCell = inject("DatabaseMobx")(observer(
class AddEditDeleteTableBodyCell extends Component { //props: p_aedTableObj, p_fieldObj, p_dataRowObj, f_onClick
  render() {
    const p_aedTableObj = this.props.p_aedTableObj;
    const p_fieldObj = this.props.p_fieldObj;
    const p_dataRowObj = this.props.p_dataRowObj;

    const fieldObjExistsTF = (p_fieldObj !== undefined);

    var cellFlexClass = "flex11a";
    var cellFlexBasis = "1em";
    if(fieldObjExistsTF) {
      if(p_fieldObj.fixedWidthTF) {
        cellFlexClass = "flex00a";
      }
      cellFlexBasis = p_fieldObj.width;
    }

    //column for # matching Captures blue button
    if(p_fieldObj.matchingCapturesObjTF) {
      return(
        <div
          className={cellFlexClass + " displayFlexColumnHcVc cursorPointer"}
          style={{flexBasis:cellFlexBasis}}
          onClick={this.props.f_onClick}>
          {(p_dataRowObj.matchingCapturesObj !== undefined) &&
            <CapturesReact.NumberOfAssignedCapturesCountButton
              p_partialNumMatchingCaptures={p_dataRowObj.matchingCapturesObj.partialNumMatchingCaptures}
              p_matchingCaptureIDsArray={p_dataRowObj.matchingCapturesObj.matchingCaptureIDsArray}
              p_floatingBoxTitle={"All Captures with " + p_aedTableObj.itemName + " assigned as '" + p_dataRowObj[p_aedTableObj.deleteItemNameFieldDbName] + "'"}
            />
          }
        </div>
      );
    }

    const valueRaw = p_dataRowObj[p_fieldObj.dbName];

    var valueMask = undefined;
    var cellHoverText = undefined;
    if(p_fieldObj.rawValueDisplayedFieldNotOnFormTF || p_fieldObj.rawValueDisplayedFieldIsReadOnlyOnFormTF) {
      valueMask = valueRaw;
      cellHoverText = ((p_fieldObj.cellHoverTF) ? (valueRaw) : (undefined));
    }
    else {
      if(p_fieldObj.rawValueFalseDisplaysNAAndNoEditTF && (valueRaw === false)) {
        valueMask = this.props.DatabaseMobx.not_filled_out_font_html("N/A");
        cellHoverText = ((p_fieldObj.cellHoverTF) ? ("N/A") : (undefined));
      }
      else {
        const valueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(valueRaw, p_fieldObj.fieldTypeObj);
        if(p_fieldObj.cellDisplayBlankIfNotFilledOutTF && !valueMaskSortIfoObj.isFilledOutTF) {
          valueMask = "";
        }
        else {
          valueMask = valueMaskSortIfoObj.valueMask;
        }
        cellHoverText = ((p_fieldObj.cellHoverTF) ? (valueMaskSortIfoObj.valueMaskPlainText) : (undefined));
      }
    }

    return(
      <div
        className={cellFlexClass + " displayFlexRowVc lrPad cursorPointer " + ((p_fieldObj.cellCenterTF) ? ("textCenter") : (""))}
        style={{flexBasis:cellFlexBasis}}
        title={cellHoverText}
        onClick={this.props.f_onClick}>
        <LibraryReact.NowrapEllipsis>
          {valueMask}
        </LibraryReact.NowrapEllipsis>
      </div>
    );
  }
}));

function AddEditDeleteTableEditItemFloatingBox(props) { //props: p_dataRowObj, p_aedTableObj, f_onClickClose
  const p_dataRowObj = props.p_dataRowObj;
  const p_aedTableObj = props.p_aedTableObj;

  var editItemFloatingBoxTitle = "Editing " + p_aedTableObj.itemName;
  if(p_dataRowObj.name !== undefined) {
    editItemFloatingBoxTitle += " '" + p_dataRowObj.name + "'";
  }
  else if(p_dataRowObj.display_name !== undefined) {
    editItemFloatingBoxTitle += " '" + p_dataRowObj.display_name + "'";
  }
  else {
    editItemFloatingBoxTitle += " (ID: " + p_dataRowObj.id + ")";
  }

  return(
    <CEGeneralReact.FloatingBoxWithSaveCancel
      p_trblFlag="addEditDeleteTableEditItem"
      p_title={editItemFloatingBoxTitle}
      f_onClickSave={props.f_onClickClose}>
      <div className="flex11a yScroll medFullPad">
        {p_aedTableObj.fieldsArrayOfObjs.map((m_fieldObj) =>
          <AddEditDeleteTableEditItemFieldEditSaveCancel
            key={m_fieldObj.dbName}
            p_aedTableObj={p_aedTableObj}
            p_fieldObj={m_fieldObj}
            p_dataRowObj={p_dataRowObj}
          />
        )}
      </div>
    </CEGeneralReact.FloatingBoxWithSaveCancel>
  );
}

const AddEditDeleteTableEditItemFieldEditSaveCancel = inject("AdminMobx", "DatabaseMobx")(observer(
class AddEditDeleteTableEditItemFieldEditSaveCancel extends Component { //props: p_aedTableObj, p_fieldObj, p_dataRowObj
  onsavechanged_field = (i_newValue) => {
    const p_aedTableObj = this.props.p_aedTableObj;
    const p_fieldObj = this.props.p_fieldObj;
    const p_dataRowObj = this.props.p_dataRowObj;

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - AddEditDeleteTableEditItemFieldEditSaveCancel", "onsavechanged_field", ["i_newValue"], [i_newValue]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_update(p_aedTableObj.tblName, p_dataRowObj.id, p_fieldObj.dbName, i_newValue, p_fieldObj.fieldTypeObj.idsb);
    C_CallPhpTblUID.execute();
  }

  render() {
    const p_aedTableObj = this.props.p_aedTableObj;
    const p_fieldObj = this.props.p_fieldObj;
    const p_dataRowObj = this.props.p_dataRowObj;

    //if rawValueDisplayedFieldNotOnFormTF, the EditSaveCancel line item is completely omitted
    if(p_fieldObj.rawValueDisplayedFieldNotOnFormTF || p_fieldObj.matchingCapturesObjTF) {
      return(null);
    }

    const valueRaw = p_dataRowObj[p_fieldObj.dbName];

    if(p_fieldObj.fieldTypeObj.editOptionsForSelectFieldTF) { //AED table to edit the options for a select table (uses addNewItemInlineTextInputFieldDbName to have inline add new option for tbl_cap tables)
      if(!p_dataRowObj.fieldTypeObj.requiresSelectWithSearchDataObjTF) {
        return(null);
      }

      var aedTableComponent = null;
      if((p_dataRowObj.fieldTypeObj.selectWithSearchDataObj === undefined) || !JSFUNC.is_array(p_dataRowObj.fieldTypeObj.selectWithSearchDataObj.valueArray)) {
        aedTableComponent = (
          <div className="smallFullMargin">
            <font className="fontItalic fontTextLighter">
              {"--The Options reference table for this field does not exist--"}
            </font>
          </div>
        );
      }
      else if(p_dataRowObj.select_tbl_name === "tbl_a_contract_types") {
        const contractTypeSwsOptionsObj = undefined;
        const contractTypesSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Contract Type", [1, 2, 3], false, ["Single Award Contract", "IDIQ", "IDIQ Task Order"], contractTypeSwsOptionsObj);
        const selectContractTypeType123FieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", contractTypesSwsDataObj);

        const contractTypesAedTableObj = {
          tblName: "tbl_a_contract_types",
          dragToResortFieldDbName: "sort",
          initialSortedFieldDbName: "sort",
          tableWidth: "100%",
          itemName: "Contract Type",
          deleteItemNameFieldDbName: "name",
          fieldsArrayOfObjs: [
            {width:"100em", dbName:"sa1_idiq2_to3", displayName:"Contract Type", fieldTypeObj:selectContractTypeType123FieldTypeObj, initialValue:1, cellHoverTF:true, requiredNotEmptyTF:true},
            {width:"200em", dbName:"name", displayName:"Contract Type Name", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
            {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
          ]
        };

        aedTableComponent = (
          <AddEditDeleteTable
            p_dataArrayOfObjs={this.props.AdminMobx.c_contractTypesArrayOfObjs}
            p_aedTableObj={contractTypesAedTableObj}
          />
        );
      }
      else if(JSFUNC.in_array(p_dataRowObj.select_tbl_name, ["tbl_a_reasons_won_lost", "tbl_a_reasons_won", "tbl_a_reasons_lost"])) {
        const selectWonLostBothFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Won/Lost/Both", [1, 2, 3], false, ["Won", "Lost", "Both"], undefined);

        const reasonsWonLostAedTableObj = {
          tblName: "tbl_a_reasons_won_lost",
          dragToResortFieldDbName: undefined,
          initialSortedFieldDbName: ["won1_lost2_both3", "name"],
          tableWidth: "100%",
          itemName: "Reason Won/Lost",
          deleteItemNameFieldDbName: "name",
          fieldsArrayOfObjs: [
            {width:"400em", dbName:"name", displayName:"Reason Text", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, requiredNotEmptyTF:true},
            {width:"100em", dbName:"won1_lost2_both3", displayName:"Won/Lost/Both", fieldTypeObj:selectWonLostBothFieldTypeObj, initialValue:1, cellCenterTF:true, requiredNotEmptyTF:true}
          ]
        };

        aedTableComponent = (
          <AddEditDeleteTable
            p_dataArrayOfObjs={this.props.AdminMobx.c_reasonsWonLostArrayOfObjs}
            p_aedTableObj={reasonsWonLostAedTableObj}
          />
        );
      }
      else { //tbl_cap references and other tables
        const tblNameFirst10Chars = p_dataRowObj.select_tbl_name.substring(0, 10);
        const tblIsCapNameTF = (tblNameFirst10Chars === "tbl_cap_n_");
        const tblIsCapSortTF = (tblNameFirst10Chars === "tbl_cap_s_");
        if(tblIsCapNameTF || tblIsCapSortTF) { //tbl cap tables
          const tblRefMapOfMaps = this.props.DatabaseMobx.tbl_ref_from_tbl_name(p_dataRowObj.select_tbl_name);
          if(tblRefMapOfMaps === undefined) {
            aedTableComponent = (
              <div className="smallFullMargin">
                <font className="fontItalic fontTextLighter">
                  {"--The Options reference table for this field does not exist (" + p_dataRowObj.select_tbl_name + ")--"}
                </font>
              </div>
            );
          }
          else {
            const tblCapOptionsArrayOfObjs = JSFUNC.arrayOfObjs_from_mapOfMaps(tblRefMapOfMaps);

            var tblCapAedTableObj = {
              tblName: p_dataRowObj.select_tbl_name,
              dragToResortFieldDbName: ((tblIsCapSortTF) ? ("sort") : (undefined)),
              initialSortedFieldDbName: ((tblIsCapSortTF) ? ("sort") : ("name")),
              itemName: "Option",
              searchFieldDbName: "name",
              addNewItemInlineTextInputFieldDbName: "name",
              importFromCsvIntoFieldDbName: "name",
              importFromCsvLabel: "Import Options for Details Field '" + p_dataRowObj.display_name + "'",
              fieldsArrayOfObjs: [
                {width:"100em", dbName:"name", displayName:"Option", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true}
              ]
            };
            if(tblIsCapSortTF) {
              tblCapAedTableObj.fieldsArrayOfObjs.push({width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1});
            }

            aedTableComponent = (
              <AddEditDeleteTable
                p_dataArrayOfObjs={tblCapOptionsArrayOfObjs}
                p_aedTableObj={tblCapAedTableObj}
              />
            );
          }
        }
        else { //all highly specilized capture fields that are edited on other Admin subtabs, displays a message pointing to where to go to edit these values
          var optionsMessage = undefined;
          if(p_dataRowObj.fieldTypeObj.selectContactCompanyTF || p_dataRowObj.fieldTypeObj.selectContactPersonTF) { optionsMessage = "--Contacts can be added/edited in the main 'Contacts' tab in the left navigation menu--"; }
          else if(JSFUNC.in_array(p_dataRowObj.select_tbl_name, ["tbl_a_users", "tbl_a_users_contracts", "tbl_a_users_proposal", "tbl_a_users_budget"])) { optionsMessage = "--Users can be added/edited in the Admin 'System Setup' tab under subtab 'Users' in the left navigation menu--"; }
          else if(p_dataRowObj.select_tbl_name === "tbl_a_divisions") { optionsMessage = "--Divisions can be added/edited in the Admin 'System Setup' tab under subtab 'Company/Divisions' in the left navigation menu--"; }
          else if(p_dataRowObj.select_tbl_name === "tbl_a_capture_types") { optionsMessage = "--Capture Types can be added/edited in the Admin 'System Setup' tab under subtab 'Capture Types' in the left navigation menu--"; }
          else if(p_dataRowObj.select_tbl_name === "tbl_a_stages_pool") { optionsMessage = "--Stages can be added/edited in the Admin 'System Setup' tab under subtab 'Stages' in the left navigation menu--"; }
          else if(p_dataRowObj.select_tbl_name === "tbl_captures_idiq") { optionsMessage = "--New IDIQ Captures can be created on the 'Captures' tab in the left navigation menu--"; }
          else if(p_dataRowObj.select_tbl_name === "tbl_bit_master_set_asides") { optionsMessage = "--Set-Asides (Small Business Certifications) are kept as a Master List. You can view them and choose whether to use abbreviations in the Admin 'System Setup' tab under subtab 'Contacts Fields' in the left navigation menu. Once on that subtab, click the 'Set-Asides' tab from the tabs across the top--"; }
          else if(p_dataRowObj.select_tbl_name === "tbl_bit_master_naics_codes") { optionsMessage = "--NAICS Codes are kept as a Master List, and can be slimmed down using the tool in the Admin 'System Setup' tab under subtab 'Contacts Fields' in the left navigation menu. Once on that subtab, click the 'NAICS Codes' tab from the tabs across the top.--"; }
          else if(p_dataRowObj.select_tbl_name === "tbl_a_capture_priority_levels") { optionsMessage = "--Capture Priority Levels can be added/edited in the Admin 'System Setup' tab under subtab 'Details Fields Options' (then 'Capture Priority/Favorites' tab across the top) in the left navigation menu--"; }
          else if(p_dataRowObj.select_tbl_name === "tbl_a_capture_types_prime_sub") { optionsMessage = "--Prime/Sub is designated for each Capture Type in the Admin 'System Setup' tab under subtab 'Capture Types' in the left navigation menu--"; }
          else { optionsMessage = "--Select options reference table '" + p_dataRowObj.select_tbl_name + "' cannot be edited--"; }

          aedTableComponent = (
            <LibraryReact.DivFont p_class="smallFullMargin" p_fontClass="fontItalic fontTextLighter">
              {optionsMessage}
            </LibraryReact.DivFont>
          );
        }
      }

      return (
        <div className="tbMedMargin">
          <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontBlue">
            {p_fieldObj.displayName}
          </LibraryReact.DivFont>
          {aedTableComponent}
        </div>
      );
    }
    else if(p_fieldObj.fieldTypeObj.editAnswersForSelectQuestionTF) {
      if(valueRaw === undefined) { //questions with answer type 'text' or 'textarea' have the field 'answersArrayOfObjs' in the questionObj set as undefined
        return(null);
      }

      const aedTableObj = {
        tblName: "tbl_a_shaping_select_answers",
        initialSortedFieldDbName: "score0to100",
        initialSortedFieldIsAscTF: false,
        itemName: "Answer",
        newItemConstantFieldNamesArray: ["question_id"],
        newItemConstantValuesArray: [p_dataRowObj.id],
        newItemConstantIdsbArray: ["i"],
        fieldsArrayOfObjs: [
          {width:"200em", dbName:"name", displayName:"Answer", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, onkeydownenterAddsNewItemTF:true},
          {width:"100em", dbName:"score0to100", displayName:"Score (0-100%, or negative down to -1000%)", fieldTypeObj:this.props.DatabaseMobx.c_genericPercentIntm1000to100FieldTypeObj, initialValue:100, cellCenterTF:true, onkeydownenterAddsNewItemTF:true}
        ]
      };

      return (
        <div className="tbMedMargin">
          <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontBlue">
            {p_fieldObj.displayName}
          </LibraryReact.DivFont>
          <AddEditDeleteTable
            p_dataArrayOfObjs={valueRaw}
            p_aedTableObj={aedTableObj}
          />
        </div>
      );
    }

    var valueIsEditableTFU = true;
    var valueMask = undefined;

    //if rawValueFalseDisplaysNAAndNoEditTF is set to true and the valueRaw is false, display "N/A"
    if(p_fieldObj.rawValueFalseDisplaysNAAndNoEditTF && (valueRaw === false)) {
      valueMask = this.props.DatabaseMobx.not_filled_out_font_html("N/A");
      valueIsEditableTFU = undefined;
    }

    if(p_fieldObj.rawValueDisplayedFieldIsReadOnlyOnFormTF) {
      valueIsEditableTFU = undefined; //cannot edit this value on the form
    }

    if(p_fieldObj.onlyEditableDuringCreateUneditableOnEditTF) { //if set to true, then this field cannot be edited on the edit form
      valueIsEditableTFU = false; //false leaves the space for the pencil edit without drawing it
    }

    //if using the valuesToNotIncludeArray for a select, be sure to remove the id number of this item being edited so that it exists when selecting
    var valuesToNotIncludeArray = undefined;
    if(JSFUNC.is_array(p_fieldObj.valuesToNotIncludeArray)) {
      valuesToNotIncludeArray = JSFUNC.remove_all_values_from_array(valueRaw, p_fieldObj.valuesToNotIncludeArray);
    }

    //custom field display name renaming based on tblName and field dbName or type
    var fieldDisplayName = p_fieldObj.displayName;
    if(p_aedTableObj.tblName === "tbl_captures_fields") {
      if((p_fieldObj.dbName === "num_decimals") && (p_dataRowObj.input_type === "int_positive")) {
        fieldDisplayName = "# Leading Zeros [default 0]";
      }
      else if((p_fieldObj.dbName === "textarea_details_max_lines") && (p_dataRowObj.input_type === "verticalswitch")) {
        fieldDisplayName = "Displayed Height per Option (as max # lines of text shown)";
      }
    }

    //custom field with input or default of 15em
    var fieldWidth = "15em";
    if(JSFUNC.is_string_not_empty(p_aedTableObj.customFieldWidth)) {
      fieldWidth = p_aedTableObj.customFieldWidth;
    }

    return(
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString={"aedAddNewItemFieldESC_" + p_aedTableObj.tblName + "_" + p_fieldObj.dbName}
        p_fieldDisplayName={fieldDisplayName}
        p_fieldTypeObj={p_fieldObj.fieldTypeObj}
        p_valueRaw={valueRaw}
        p_valueMask={valueMask}
        p_valueIsEditableTFU={valueIsEditableTFU}
        p_valuesToNotIncludeArray={valuesToNotIncludeArray}
        p_containerClass="tbMargin"
        p_fieldClass="fontBlue"
        p_fieldWidth={fieldWidth}
        p_fieldNowrapTF={false}
        p_fieldValueVerticallyAlignedTF={true}
        p_floatingBoxTitle={"Editing " + p_aedTableObj.itemName + " (ID: " + p_dataRowObj.id + ") field '" + p_fieldObj.displayName + "'"}
        f_onSaveChanged={this.onsavechanged_field}
      />
    );
  }
}));


class AEDTableImportItemsFromCsvFile extends Component { //props: p_dataArrayOfObjs, p_aedTableObj
  onclick_import_csv_data_multiinsert_unique_values_and_sort_numbers_into_aed_tbl = (i_uniqueCsvEntriesArray, i_runThisFunctionUponSuccess, i_runThisFunctionUponError) => {
    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_aedTableObj = this.props.p_aedTableObj;

    const tblName = p_aedTableObj.tblName;
    const dragToResortFieldDbName = p_aedTableObj.dragToResortFieldDbName;
    const importFromCsvIntoFieldDbName = p_aedTableObj.importFromCsvIntoFieldDbName;

    var fieldNamesArray = [importFromCsvIntoFieldDbName]; //start with 'name' field stored in that AED var, add the new sort numbers as a column if this tbl has a resort column
    var valuesArrayOfArrays = [i_uniqueCsvEntriesArray];
    var valueIdsbArray = ["s"];
    if(dragToResortFieldDbName !== undefined) {
      const importedEntryNewSortNumbersArray = JSFUNC.array_fill_incrementing_x_to_xpnm1((p_dataArrayOfObjs.length + 1), i_uniqueCsvEntriesArray.length); //start new sort count at numExistingItems + 1, count through the number of new entries
      fieldNamesArray.push(dragToResortFieldDbName);
      valuesArrayOfArrays.push(importedEntryNewSortNumbersArray);
      valueIdsbArray.push("i");
    }

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - AEDTableImportItemsFromCsvFile", "onclick_import_csv_data_multiinsert_unique_values_and_sort_numbers_into_aed_tbl", ["i_uniqueCsvEntriesArray"], [i_uniqueCsvEntriesArray]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUID.add_multi_insert(tblName, fieldNamesArray, valuesArrayOfArrays, valueIdsbArray);

    const functionOnSuccess = (i_parseResponse) => {
      if(i_parseResponse.outputObj.mi0 === "0") {
        i_runThisFunctionUponError();
      }
      else {
        i_runThisFunctionUponSuccess();
      }
    };
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUID.add_function("onError", i_runThisFunctionUponError);

    C_CallPhpTblUID.execute();
  }

  render() {
    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_aedTableObj = this.props.p_aedTableObj;

    const importFromCsvLabel = p_aedTableObj.importFromCsvLabel;
    const importFromCsvIntoFieldDbName = p_aedTableObj.importFromCsvIntoFieldDbName;

    const instructionBulletsArray = [
      "The .csv file used for import is expected have 1 column with all of the new values to import.",
      "If you have multiple columns as well as rows of data in your file, the system will import all values from every row and column as separate values (including any headers).",
      "Duplicate values will be detected and only 1 of each unique value will be presented for final import. This also includes checking for duplicate values that already exist in the table prior to import."
    ];
    const importAEDTableItemsFromCsvInstructionsHtml = (
      <CEGeneralReact.BulletList
        p_linesArray={instructionBulletsArray}
        p_fontClass="fontItalic fontTextLight"
        p_dashFontClass="fontTextLight"
      />
    );

    const existingValuesArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_dataArrayOfObjs, importFromCsvIntoFieldDbName);

    return(
      <div className="displayFlexColumnHcVc">
        <ImportDataFromCsvFileButtonWithFloatingBoxInterface
          p_buttonLabel="Import Items from .csv File"
          p_importTitle={importFromCsvLabel}
          p_instructionsHtmlOrUndefined={importAEDTableItemsFromCsvInstructionsHtml}
          p_existingValuesArray={existingValuesArray}
          p_maxNumColumnsInCsvOrUndefined={1}
          p_maxNumColumnsToShow={1}
          p_combineAll2DDataInto1DTF={true}
          p_markAndPreventDuplicateEntriesTF={true}
          p_includeBlankColumn1EntriesTF={false}
          f_onClickImportCsvData={this.onclick_import_csv_data_multiinsert_unique_values_and_sort_numbers_into_aed_tbl}
        />
      </div>
    );
  }
}


//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//AEDTable - add new Capture Field
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
const AddEditDeleteTableAddNewCaptureFieldFloatingBox = inject("CaptureExecMobx", "AdminMobx", "DatabaseMobx")(observer(
class AddEditDeleteTableAddNewCaptureFieldFloatingBox extends Component { //props: p_aedTableObj, f_onClickClose
  constructor(props) {
    super(props);

    this.state = {
      s_processStep: "fieldType", //"fieldType", "fieldFields", "chooseSelectDataSource", "createOptionsForSelectType"
      s_selectedFieldInputType: undefined,
      s_selectedFieldInputTypeDisplay: undefined,
      s_selectedFieldTypeObj: undefined,
      s_newCaptureFieldName: "",
      s_textareaMaxLines: 0,
      s_verticalSwitchExampleValue: 1,
      s_numDecimals: -1,
      s_hoverText: "",
      s_displayNameStylingStringComma: "",
      s_codewordNamesComma: undefined, //undefined means there are 0 new codeword boxes open, if a new one is added, this changes to "" to signify 1 entry box that is empty
      s_newCaptureFieldNameErrorMessage: undefined,
      s_phpIsCreatingNewCaptureFieldTF: false,
      s_newlyCreatedCaptureFieldID: -1,
      s_selectExistingSourceDataTblNameOrNew: "newTblCapName", //undefined if the choice has not been made yet, "newTblCapName"/"newTblCapSort" for creating new options and a cap tbl, "existing_tbl_name" for choosing an existing select dataset for the options (system tbl or a different tbl_cap)
      s_newlyCreatedTblCapTblName: undefined
    }
  }

  onclick_choose_field_input_type = (i_selectedFieldInputType, i_selectedFieldInputTypeDisplay, i_selectedFieldTypeObj) => {
    this.setState({
      s_selectedFieldInputType: i_selectedFieldInputType,
      s_selectedFieldInputTypeDisplay: i_selectedFieldInputTypeDisplay,
      s_selectedFieldTypeObj: i_selectedFieldTypeObj,
      s_textareaMaxLines: ((i_selectedFieldInputType === "verticalswitch") ? (1) : (0))
    });
  }

  onclick_proceed_to_define_field_fields = () => {
    this.setState({s_processStep:"fieldFields"});
  }

  onclick_return_to_select_field_input_type = () => {
    this.setState({
      s_processStep: "fieldType",
      s_selectedFieldInputType: undefined,
      s_selectedFieldInputTypeDisplay: undefined,
      s_selectedFieldTypeObj: undefined,
    });
  }

  onchange_new_capture_field_name = (i_newValue) => {
    var newCaptureFieldName = i_newValue;
    var newCaptureFieldNameErrorMessage = undefined;
    if(i_newValue.length > 50) {
      newCaptureFieldName = i_newValue.substring(0, 51);
      newCaptureFieldNameErrorMessage = "Capture Field Name has a maximum length requirement of 50 characters";
    }
    else { //loop through all existing fields to check that the new dbName created will be unique
      const newCaptureFieldDbName = JSFUNC.db_name_from_display_name(newCaptureFieldName);
      if(JSFUNC.in_array(newCaptureFieldDbName, this.props.AdminMobx.c_allFieldDbNamesArray)) {
        newCaptureFieldNameErrorMessage = "Capture Field Name '" + newCaptureFieldName + "' already exists. Each field must have a unique name.";
      }
    }

    this.setState({
      s_newCaptureFieldName: newCaptureFieldName,
      s_newCaptureFieldNameErrorMessage: newCaptureFieldNameErrorMessage
    });
  }

  onswitch_textarea_max_lines = () => {
    const newTextareaMaxLines = ((this.state.s_textareaMaxLines > 0) ? (0) : (10)); //default of 10 lines when turned on (0 is the flag for turned off)
    this.onchange_textarea_max_lines(newTextareaMaxLines);
  }

  onswitch_num_decimals = () => {
    const s_selectedFieldTypeObj = this.state.s_selectedFieldTypeObj;
    const s_numDecimals = this.state.s_numDecimals;

    var newNumDecimals = -1; //if the switch is already on, turn it off
    if(s_numDecimals < 0) { //turn the switch on to a default value
      if(s_selectedFieldTypeObj.hasZeroPaddingOptionTF) { //if the selected field type for this new capture field is "int_positive", can use this decimals/digits value to specify the number of zero padded digits, default to 5 where ID 103 -> "00103"
        newNumDecimals = 5;
      }
      else { //default of 2 decimal places when turned on (-1 is the flag for turned off)
        newNumDecimals = 2;
      }

    }
    this.onchange_num_decimals(newNumDecimals);
  }

  onchange_textarea_max_lines = (i_newValue) => { this.setState({s_textareaMaxLines:i_newValue}); }
  onchange_verticalswitch_example_value = (i_newValue) => { this.setState({s_verticalSwitchExampleValue:i_newValue}); }
  onchange_num_decimals = (i_newValue) => { this.setState({s_numDecimals:i_newValue}); }
  onchange_hover_text = (i_newValue) => { this.setState({s_hoverText:i_newValue}); }
  onchange_display_name_styling_string_comma = (i_newValue) => { this.setState({s_displayNameStylingStringComma:i_newValue}); }
  onchange_codeword_names_comma = (i_newValue) => { this.setState({s_codewordNamesComma:i_newValue}); }

  onclick_create_new_generic_capture_field_or_proceed_to_select_data_source = () => {
    if(this.state.s_newCaptureFieldName === "") {
      this.setState({s_newCaptureFieldNameErrorMessage: "The new Capture Field name cannot be blank"});
    }
    else if(this.state.s_newCaptureFieldNameErrorMessage === undefined) {
      if(this.state.s_selectedFieldTypeObj.requiresSelectWithSearchDataObjTF) {
        this.setState({s_processStep: "chooseSelectDataSource"});
      }
      else {
        this.create_new_capture_field_from_state("close");
      }
    }
  }

  create_new_capture_field_from_state = (i_onFinishProcessStepOrClose) => {
    const s_selectedFieldInputType = this.state.s_selectedFieldInputType;
    const s_selectedFieldTypeObj = this.state.s_selectedFieldTypeObj;
    const s_newCaptureFieldName = this.state.s_newCaptureFieldName;
    const s_textareaMaxLines = this.state.s_textareaMaxLines;
    const s_numDecimals = this.state.s_numDecimals;
    const s_hoverText = this.state.s_hoverText;
    const s_displayNameStylingStringComma = this.state.s_displayNameStylingStringComma;
    const s_codewordNamesComma = this.state.s_codewordNamesComma;
    const s_selectExistingSourceDataTblNameOrNew = this.state.s_selectExistingSourceDataTblNameOrNew;

    this.setState({s_phpIsCreatingNewCaptureFieldTF:true});

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - AddEditDeleteTableAddNewCaptureFieldFloatingBox", "create_new_capture_field_from_state", ["i_onFinishProcessStepOrClose"], [i_onFinishProcessStepOrClose]);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    var tblCapturesFieldsDisplayName = s_newCaptureFieldName;
    var tblCapturesFieldsDbName = JSFUNC.db_name_from_display_name(tblCapturesFieldsDisplayName);
    var tblCapturesFieldsInputType = s_selectedFieldInputType;
    var tblCapturesFieldsAdminSort = JSFUNC.sort_max_mysqli_int();
    var tblCapturesFieldsTextareaMaxLines = s_textareaMaxLines;
    var tblCapturesFieldsNumDecimals = s_numDecimals;
    var tblCapturesFieldsHoverText = s_hoverText;
    var tblCapturesFieldsDisplayNameStylingStringComma = s_displayNameStylingStringComma;
    var tblCapturesFieldsCodewordNamesComma = s_codewordNamesComma;

    //set the textarea max lines to 0 if it is "" or a negative number
    if(!JSFUNC.is_number(tblCapturesFieldsTextareaMaxLines) || (tblCapturesFieldsTextareaMaxLines < 0)) {
      tblCapturesFieldsTextareaMaxLines = 0;
    }

    //the s_codewordNamesComma is initialized as undefined, which actually represents "" to go to the database
    if(tblCapturesFieldsCodewordNamesComma === undefined) {
      tblCapturesFieldsCodewordNamesComma = "";
    }

    //if creating a select with a new options dataset, create the tbl_cap table
    var tblCapturesFieldsSelectTblName = ""; //blank for all non-select field types
    if(s_selectedFieldTypeObj.requiresSelectWithSearchDataObjTF) {
      if(s_selectExistingSourceDataTblNameOrNew === "newTblCapName" || s_selectExistingSourceDataTblNameOrNew === "newTblCapSort") { //creating a new tbl_cap
        var snLetter = undefined;
        var hasSortTF = false;
        if(s_selectExistingSourceDataTblNameOrNew === "newTblCapSort") {
          snLetter = "s";
          hasSortTF = true;
        }
        else {
          snLetter = "n";
        }
        const newTblCapName = "tbl_cap_" + snLetter + "_" + tblCapturesFieldsDbName; //tbl_cap_n_db_name or tbl_cap_s_db_name
        C_CallPhpTblUID.add_db_create_tbl_cap_table(newTblCapName, hasSortTF);

        tblCapturesFieldsSelectTblName = newTblCapName;

        //set the state to know the new tbl_cap table name to use when populating the aedTable to add options
        this.setState({s_newlyCreatedTblCapTblName:newTblCapName});
      }
      else { //using an existing tbl_cap (chosen tblName is stored in state)
        tblCapturesFieldsSelectTblName = s_selectExistingSourceDataTblNameOrNew;
      }
    }

    //create the tbl_captures_field record
    const fieldNamesArray = ["display_name", "db_name", "input_type", "select_tbl_name", "admin_sort", "textarea_details_max_lines", "num_decimals", "hover_text", "display_name_styling_string_comma", "codeword_names_comma"];
    const valuesArray = [tblCapturesFieldsDisplayName, tblCapturesFieldsDbName, tblCapturesFieldsInputType, tblCapturesFieldsSelectTblName, tblCapturesFieldsAdminSort, tblCapturesFieldsTextareaMaxLines , tblCapturesFieldsNumDecimals, tblCapturesFieldsHoverText, tblCapturesFieldsDisplayNameStylingStringComma, tblCapturesFieldsCodewordNamesComma];
    const idsbArray = ["s", "s", "s", "s", "i", "i", "i", "s", "s", "s"];
    const resortSortColumnName = "admin_sort";
    const resortFilterFieldNameOrFieldNamesArray = [];
    const resortFilterValueOrValuesArray = [];
    C_CallPhpTblUID.add_insert("tbl_captures_fields", fieldNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);

    //alter tbl_captures to add a new column to the table with this new field dbName as the column name
    C_CallPhpTblUID.add_alter_db_tbl_insert_column("tbl_captures", tblCapturesFieldsDbName, s_selectedFieldTypeObj.mysqlColumnDataType, s_selectedFieldTypeObj.blankValue);

    //move to the next step in the process once complete
    const functionOnSuccess = (i_parseResponse) => {
      this.setState({s_newlyCreatedCaptureFieldID:i_parseResponse.outputObj.i0});
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    const functionOnFinish = () => {
      this.setState({s_phpIsCreatingNewCaptureFieldTF:false});

      if(i_onFinishProcessStepOrClose === "close") {
        if(JSFUNC.is_function(this.props.f_onClickClose)) {
          this.props.f_onClickClose();
        }
      }
      else {
        this.setState({s_processStep:i_onFinishProcessStepOrClose});
      }
    }
    C_CallPhpTblUID.add_function("onFinish", functionOnFinish);

    C_CallPhpTblUID.execute();
  }

  onclick_select_choose_create_new_tbl_cap_name = () => {
    const newValue = ((this.state.s_selectExistingSourceDataTblNameOrNew === "newTblCapName") ? (undefined) : ("newTblCapName"));
    this.setState({s_selectExistingSourceDataTblNameOrNew:newValue});
  }

  onclick_select_choose_create_new_tbl_cap_sort = () => {
    const newValue = ((this.state.s_selectExistingSourceDataTblNameOrNew === "newTblCapSort") ? (undefined) : ("newTblCapSort"));
    this.setState({s_selectExistingSourceDataTblNameOrNew:newValue});
  }

  onclick_select_existing_data_table_choice = (i_newValue) => {
    this.setState({s_selectExistingSourceDataTblNameOrNew:i_newValue});
  }

  onclick_create_new_select_capture_field_proceed_to_create_options = () => {
    const s_selectExistingSourceDataTblNameOrNew = this.state.s_selectExistingSourceDataTblNameOrNew;
    const onFinishProcessStepOrClose = (((s_selectExistingSourceDataTblNameOrNew === "newTblCapName") || (s_selectExistingSourceDataTblNameOrNew === "newTblCapSort")) ? ("createOptionsForSelectType") : ("close"));
    this.create_new_capture_field_from_state(onFinishProcessStepOrClose);
  }

  render() {
    const s_processStep = this.state.s_processStep;
    const s_selectedFieldInputType = this.state.s_selectedFieldInputType;
    const s_selectedFieldInputTypeDisplay = this.state.s_selectedFieldInputTypeDisplay;
    const s_selectedFieldTypeObj = this.state.s_selectedFieldTypeObj;
    const s_newCaptureFieldName = this.state.s_newCaptureFieldName;
    const s_textareaMaxLines = this.state.s_textareaMaxLines;
    const s_verticalSwitchExampleValue = this.state.s_verticalSwitchExampleValue;
    const s_numDecimals = this.state.s_numDecimals;
    const s_hoverText = this.state.s_hoverText;
    const s_displayNameStylingStringComma = this.state.s_displayNameStylingStringComma;
    const s_codewordNamesComma = this.state.s_codewordNamesComma;
    const s_newCaptureFieldNameErrorMessage = this.state.s_newCaptureFieldNameErrorMessage;
    const s_phpIsCreatingNewCaptureFieldTF = this.state.s_phpIsCreatingNewCaptureFieldTF;
    const s_newlyCreatedCaptureFieldID = this.state.s_newlyCreatedCaptureFieldID;
    const s_selectExistingSourceDataTblNameOrNew = this.state.s_selectExistingSourceDataTblNameOrNew;
    const s_newlyCreatedTblCapTblName = this.state.s_newlyCreatedTblCapTblName;

    const p_aedTableObj = this.props.p_aedTableObj;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_cardNameDetails = this.props.DatabaseMobx.c_cardNameDetails;

    var processInstructions = undefined;
    var processComponent = null;
    var useSaveTrueCancelFalse = false; //icon in top right corner of floating box, can cancel during process, but should be a save when finally adding options to a newly created select tbl_cap
    if(s_processStep === "fieldType") {
      processInstructions = "First, choose the Input Type for this new Capture Field, then proceed to the next step at the bottom (click the pencil icon next to each 'Example Field' to test out the edit interface.)";
      const selectFieldTypeIsTwoColumnTF = (this.props.CaptureExecMobx.o_mediaQueryFlag >= 4);
      const textChoices = (
        <div className="hugeBottomMargin">
          <NewCaptureFieldTypeDivider p_label="'Text' Field Input Types" />
          {["text", "textarea", "email", "phone", "website"].map((m_fieldInputType) =>
            <NewCaptureFieldTypeChoice key={m_fieldInputType} p_fieldInputType={m_fieldInputType} p_selectedFieldInputType={s_selectedFieldInputType} f_onClick={this.onclick_choose_field_input_type} />
          )}
        </div>
      );
      const numericChoices = (
        <div className="hugeBottomMargin">
          <NewCaptureFieldTypeDivider p_label="'Numeric' Field Input Types" />
          {["int", "int_positive", "decimal", "decimal_positive", "percent_int", "percent_int_0to100", "percent_decimal", "percent_decimal_0to100", "money", "money_cents"].map((m_fieldInputType) =>
            <NewCaptureFieldTypeChoice key={m_fieldInputType} p_fieldInputType={m_fieldInputType} p_selectedFieldInputType={s_selectedFieldInputType} f_onClick={this.onclick_choose_field_input_type} />
          )}
        </div>
      );
      const otherChoices = (
        <div className="hugeBottomMargin">
          <NewCaptureFieldTypeDivider p_label="'Other' Field Input Types" />
          {["color"].map((m_fieldInputType) =>
            <NewCaptureFieldTypeChoice key={m_fieldInputType} p_fieldInputType={m_fieldInputType} p_selectedFieldInputType={s_selectedFieldInputType} f_onClick={this.onclick_choose_field_input_type} />
          )}
        </div>
      );
      const dateChoices = (
        <div className="hugeBottomMargin">
          <NewCaptureFieldTypeDivider p_label="'Date' Field Input Types" />
          {["date", "date_DMjY", "date_dayMdyDaysUntil1", "date_dayMdyDaysUntil1Overdue", "date_dayMdyDaysUntil2", "date_dayMdyDaysUntil2Overdue", "dateWithDuration"].map((m_fieldInputType) =>
            <NewCaptureFieldTypeChoice key={m_fieldInputType} p_fieldInputType={m_fieldInputType} p_selectedFieldInputType={s_selectedFieldInputType} f_onClick={this.onclick_choose_field_input_type} />
          )}
        </div>
      );
      const dateTimeChoices = (
        <div className="hugeBottomMargin">
          <NewCaptureFieldTypeDivider p_label="'Date/Time' Field Input Types" />
          {["datetime", "datetime_MjYgiA", "datetime_dayMdyDaysUntil1", "datetime_dayMdyDaysUntil1Overdue", "datetime_dayMdyDaysUntil2", "datetime_dayMdyDaysUntil2Overdue"].map((m_fieldInputType) =>
            <NewCaptureFieldTypeChoice key={m_fieldInputType} p_fieldInputType={m_fieldInputType} p_selectedFieldInputType={s_selectedFieldInputType} f_onClick={this.onclick_choose_field_input_type} />
          )}
        </div>
      );
      const selectChoices = (
        <div className="hugeBottomMargin">
          <NewCaptureFieldTypeDivider p_label="'Select' Field Input Types" />
          {["select", "selectmulti", "sharedpercent", "selectadd", "selectmultiadd", "sharedpercentadd", "verticalswitch"].map((m_fieldInputType) =>
            <NewCaptureFieldTypeChoice key={m_fieldInputType} p_fieldInputType={m_fieldInputType} p_selectedFieldInputType={s_selectedFieldInputType} f_onClick={this.onclick_choose_field_input_type} />
          )}
        </div>
      );

      processComponent = (
        <div className="flex11a displayFlexColumn">
          <div className="flex11a yScroll yScrollBottomPad bgLighterGray">
            {(selectFieldTypeIsTwoColumnTF) ? (
              <div className="displayFlexRow">
                <div className="flex11a lrMedPad" style={{flexBasis:"100em", borderRight:"solid 3px #ddd"}}>
                  {textChoices}
                  {numericChoices}
                  {otherChoices}
                </div>
                <div className="flex11a lrMedPad" style={{flexBasis:"100em", borderRight:"solid 3px #ddd"}}>
                  {dateChoices}
                  {dateTimeChoices}
                </div>
                <div className="flex11a lrMedPad" style={{flexBasis:"100em"}}>
                  {selectChoices}
                </div>
              </div>
            ) : (
              <div className="lrMedPad">
                {textChoices}
                {numericChoices}
                {otherChoices}
                {dateChoices}
                {dateTimeChoices}
                {selectChoices}
              </div>
            )}
          </div>
          <div className="flex00a displayFlexRowHcVc tbPad borderT1ddd">
            {(s_selectedFieldInputType !== undefined) &&
              <div className="lrMedPad">
                <CEGeneralReact.CEButton p_type="blue" p_text="Proceed to Next Step Defining the Capture Field" f_onClick={this.onclick_proceed_to_define_field_fields} />
              </div>
            }
            <div className="lrMedPad">
              <CEGeneralReact.CEButton p_type="gray" p_text="Cancel" f_onClick={this.props.f_onClickClose} />
            </div>
          </div>
        </div>
      );
    }
    else if(s_processStep === "fieldFields") {
      processInstructions = "Next, name this new Capture Field and fill out any other information about it";
      processComponent = (
        <div className="flex11a displayFlexColumn">
          <div className="flex11a yScroll yScrollBottomPad">
            <div className="smallFullPad borderB1ddd">
              <font className="font12 fontItalic">{"Input Type for this new Capture Field: "}</font>
              <font className="font14 fontBold fontTextLighter">{s_selectedFieldInputTypeDisplay}</font>
            </div>
            <div className="medFullPad">
              <div className="displayFlexRowVc border1bbb borderRadius05 bgLighterGray medFullPad">
                <div className="flex00a smallRightMargin">
                  <font className="font12 fontBlue">
                    {"New Capture Field Name"}
                  </font>
                </div>
                <div className="flex11a lrMargin">
                  <LibraryReact.Text
                    p_value={s_newCaptureFieldName}
                    p_styleObj={{maxWidth:"30em", width:"100%"}}
                    p_tabIndex={1}
                    p_placeholder="Enter a name for this new Capture Field..."
                    p_errorTF={(s_newCaptureFieldNameErrorMessage !== undefined)}
                    f_onChange={this.onchange_new_capture_field_name}
                  />
                </div>
              </div>
              {(s_newCaptureFieldNameErrorMessage !== undefined) &&
                <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={s_newCaptureFieldNameErrorMessage} />
              }
              {((s_selectedFieldTypeObj !== undefined) && s_selectedFieldTypeObj.textareaTF) &&
                <>
                  <div className="massiveTopMargin microBottomMargin">
                    <font className="font12">
                      {"Textarea Field Maximum # of Lines Displayed on " + c_cardNameDetails + " Card"}
                    </font>
                  </div>
                  <CEGeneralReact.BulletList
                    p_linesArray={["If left off (0 lines), the field will display the full text in the " + c_cardNameDetails + " Card regardless of how long it is", "If turned on, the text will be cut off at a fixed number of lines", "This will not affect how the data is stored or edited in any way, but can be used to ensure other Details fields are not pushed off the screen by an exceptionally long block of text"]}
                    p_fontClass="fontItalic fontTextLighter"
                    p_dashFontClass="fontTextLighter"
                  />
                  <div className="displayFlexRowVc smallTopMargin">
                    <div className="flex00a">
                      <LibraryReact.Switch
                        p_isOnTF={(s_textareaMaxLines > 0)}
                        f_onClick={this.onswitch_textarea_max_lines}
                      />
                    </div>
                    {(s_textareaMaxLines > 0) ? (
                      <>
                        <div className="flex00a lrMargin">
                          <font className="font11">
                            {"Displayed text has a maximum height of "}
                          </font>
                        </div>
                        <div className="flex00a">
                          <LibraryReact.Integer
                            p_value={s_textareaMaxLines}
                            p_min={0}
                            p_max={JSFUNC.sort_max_mysqli_int()}
                            p_styleObj={{width:"5em"}}
                            f_onChange={this.onchange_textarea_max_lines}
                          />
                        </div>
                        <div className="flex11a lrMargin">
                          <font className="font11">
                            {" lines on the " + c_cardNameDetails + " Card"}
                          </font>
                        </div>
                      </>
                    ) : (
                      <div className="flex11a lrMedMargin">
                        <font className="font11">
                          {"Full text is displayed with no limit"}
                        </font>
                      </div>
                    )}
                  </div>
                </>
              }
              {((s_selectedFieldTypeObj !== undefined) && s_selectedFieldTypeObj.verticalSwitchTF) &&
                <div className="displayFlexRow massiveTopMargin">
                  <div className="flex00a" style={{flexBasis:"20em"}}>
                    <div className="microBottomMargin">
                      <font className="font12">
                        {"Vertical Switch height of each option when edited"}
                      </font>
                    </div>
                    <div className="displayFlexRowVc">
                      <div className="flex00a lrMargin">
                        <font className="font11">
                          {"# lines displayed:"}
                        </font>
                      </div>
                      <div className="flex00a">
                        <LibraryReact.Integer
                          p_value={s_textareaMaxLines}
                          p_min={0}
                          p_max={JSFUNC.sort_max_mysqli_int()}
                          p_styleObj={{width:"5em"}}
                          f_onChange={this.onchange_textarea_max_lines}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex00a" style={{flexBasis:"28em", marginLeft:"2em"}}>
                    <CEGeneralReact.GenericInputOrSelectFromInputType
                      p_fieldTypeObj={this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Example Option", [1,2,3], false, ["Example Option #1", "Example Option #2 with a significantly longer text line to show how this Vertical Switch option box when editing is affected by the maximum height setting that you can select here.", "Example Option #3"], (s_textareaMaxLines * 1.5))}
                      p_valueRaw={s_verticalSwitchExampleValue}
                      f_onChangeOrOnSelect={this.onchange_verticalswitch_example_value}
                    />
                  </div>
                </div>
              }
              {((s_selectedFieldTypeObj !== undefined) && (s_selectedFieldTypeObj.hasTrimDecimalsOptionTF || s_selectedFieldTypeObj.hasZeroPaddingOptionTF)) &&
                <>
                  <div className="massiveTopMargin microBottomMargin">
                    <font className="font12">
                      {((s_selectedFieldTypeObj.hasZeroPaddingOptionTF) ? ("Integer (Positive only) Field Optional Zero-Padded # of Digits") : ("Decimal Field Maximum # of Decimal Places Displayed on " + c_cardNameDetails + " Card"))}
                    </font>
                  </div>
                  <CEGeneralReact.BulletList
                    p_linesArray={[
                      "If turned off, the field will display " + ((s_selectedFieldTypeObj.hasZeroPaddingOptionTF) ? ("the normal integer number (like 103)") : ("the full number of entered decimal places (up to 9)")),
                      "If turned on, the displayed number will be " + ((s_selectedFieldTypeObj.hasZeroPaddingOptionTF) ? ("zero-padded to the specified number of digits (like 00103 for 5 digits)") : ("cut off at a fixed number of decimal places")),
                      "This will not affect how the data is stored or edited in any way"
                    ]}
                    p_fontClass="fontItalic fontTextLighter"
                    p_dashFontClass="fontTextLighter"
                  />
                  <div className="displayFlexRowVc smallTopMargin">
                    <div className="flex00a">
                      <LibraryReact.Switch
                        p_isOnTF={(s_numDecimals >= 0)}
                        f_onClick={this.onswitch_num_decimals}
                      />
                    </div>
                    {(s_numDecimals >= 0) ? (
                      <>
                        <div className="flex00a lrMargin">
                          <font className="font11">
                            {"Displayed number has " + ((s_selectedFieldTypeObj.hasZeroPaddingOptionTF) ? ("") : ("a maximum of"))}
                          </font>
                        </div>
                        <div className="flex00a">
                          <LibraryReact.Integer
                            p_value={s_numDecimals}
                            p_min={0}
                            p_max={9}
                            p_styleObj={{width:"5em"}}
                            f_onChange={this.onchange_num_decimals}
                          />
                        </div>
                        <div className="flex11a lrMargin">
                          <font className="font11">
                            {((s_selectedFieldTypeObj.hasZeroPaddingOptionTF) ? ("digits with zero-padding if necessary") : ("decimal places"))}
                          </font>
                        </div>
                      </>
                    ) : (
                      <div className="flex11a lrMedMargin">
                        <font className="font11">
                          {((s_selectedFieldTypeObj.hasZeroPaddingOptionTF) ? ("Normal number is displayed") : ("Full number is displayed with all entered decimal places"))}
                        </font>
                      </div>
                    )}
                  </div>
                </>
              }
              <div className="massiveTopMargin">
                <font className="font12">
                  {"(optional) Capture Field Hover Help Text"}
                </font>
              </div>
              <div className="microTopMargin">
                <font className="fontItalic fontTextLighter">
                  {"This text will show if the user hovers their mouse over the blue name of the field on the " + c_cardNameDetails + " Card"}
                </font>
              </div>
              <div className="smallTopMargin" style={{maxWidth:"30em"}}>
                <LibraryReact.Textarea
                  p_value={s_hoverText}
                  p_styleObj={{height:"6em"}}
                  p_tabIndex={3}
                  p_placeholder="Enter the hover help text..."
                  f_onChange={this.onchange_hover_text}
                />
              </div>
              {(false) &&
                <>
                  <div className="massiveTopMargin">
                    <font className="font12">
                      {"(optional) Report/Template Codeword Alternatives"}
                    </font>
                  </div>
                  <div className="microTopMargin">
                    <CEGeneralReact.BulletList
                      p_linesArray={[
                        "By default, when referencing a particular capture field to place into a Template or Report, two options are provided to place into the template (surrounded by double square brackets [[ ... ]]) to be replaced:",
                        " 1. [[contract_overall_value]] - an all lowercase version of the field name with underscores",
                        " 2. [[Contract Overall Value]] - the full name of the field (capitalization does not matter)",
                        "This optional alternative codewords interface allows the admin to specify extra alternative field codewords to use in Template and Reports to reference fields",
                        "An example for Contract Overall Value could be the admin would type 'COV' as an alternative codeword below (do not type the quotes). Then, in the Templates, using [[cov]] or [[COV]] would get that value"
                      ]}
                      p_fontClass="fontItalic fontTextLighter"
                      p_dashFontClass="fontTextLighter"
                    />
                  </div>
                  <div className="smallTopMargin">
                    <CreateNewFieldCodewordAlternativesAddEdit
                      p_newCaptureFieldName={s_newCaptureFieldName}
                      p_codewordNamesComma={s_codewordNamesComma}
                      f_onChange={this.onchange_codeword_names_comma}
                    />
                  </div>
                </>
              }
            </div>
          </div>
          <div className="flex00a displayFlexRow tbPad borderT1ddd">
            <div className="flex00a displayFlexColumnHcVc lrMedPad borderR1ddd">
              <CEGeneralReact.CEButton p_type="add" p_text="Go Back" f_onClick={this.onclick_return_to_select_field_input_type} />
            </div>
            <div className="flex11a displayFlexColumnHcVc">
              {(s_phpIsCreatingNewCaptureFieldTF) ? (
                <CEGeneralReact.PhpWorkingMessage p_text="Creating New Capture Field..." />
              ) : (
                (s_newCaptureFieldNameErrorMessage !== undefined) ? (
                  <font className="fontItalic fontTextLighter">
                    {"Cannot create this Capture Field until a unique Field Name is entered above"}
                  </font>
                ) : (
                  <CEGeneralReact.CEButton
                    p_type="blue"
                    p_text={((s_selectedFieldTypeObj && s_selectedFieldTypeObj.requiresSelectWithSearchDataObjTF) ? ("Proceed to Next Step Choosing Select Source Data") : ("Create This Capture Field"))}
                    f_onClick={this.onclick_create_new_generic_capture_field_or_proceed_to_select_data_source}
                  />
                )
              )}
            </div>
          </div>
        </div>
      );
    }
    else if(s_processStep === "chooseSelectDataSource") {
      const selectedNewTblCapNameTF = (s_selectExistingSourceDataTblNameOrNew === "newTblCapName");
      const selectedNewTblCapSortTF = (s_selectExistingSourceDataTblNameOrNew === "newTblCapSort");
      const selectedExistingTableTF = (!selectedNewTblCapNameTF && !selectedNewTblCapSortTF);

      var bottomButtonComponent = null;
      if(s_phpIsCreatingNewCaptureFieldTF) {
        bottomButtonComponent = (<CEGeneralReact.PhpWorkingMessage p_text="Creating New Capture Field..." />);
      }
      else if(s_selectExistingSourceDataTblNameOrNew === undefined) {
        bottomButtonComponent = (<font className="font12 fontItalic">{"Choose the Source Data Above for this new Select Capture Field"}</font>);
      }
      else {
        bottomButtonComponent = (
          <CEGeneralReact.CEButton
            p_type="blue"
            p_text={((selectedExistingTableTF) ? ("Create This Capture Field") : ("Proceed to Next Step Creating New Select Options"))}
            f_onClick={this.onclick_create_new_select_capture_field_proceed_to_create_options}
          />
        );
      }
      
      const c_valueDisplayArraysObjCaptures = this.props.DatabaseMobx.c_valueDisplayArraysObjCaptures;
      const c_valueDisplayArraysObjUsersNotDeactivated = this.props.DatabaseMobx.c_valueDisplayArraysObjUsersNotDeactivated;
      const doSwsDataObj = this.props.DatabaseMobx.c_fieldMapOfDivisionOwners.get("fieldTypeObj").selectWithSearchDataObj;

      //start with contact tbls and users/divisions
      var existingSystemTblsArrayOfObjs = [
        {tblName:"tbl_captures", tblDisplayName:"Captures", valueArray:c_valueDisplayArraysObjCaptures.valueArray, displayArray:c_valueDisplayArraysObjCaptures.displayArray, numOptions:c_valueDisplayArraysObjCaptures.valueArray.length},
        {tblName:"tbl_g_contacts_persons", tblDisplayName:"Contact Persons", valueArray:[1], displayArray:["--All Contact Persons in the Contacts System--"], numOptions:this.props.DatabaseMobx.o_tbl_g_contacts_persons.size},
        {tblName:"tbl_g_contacts_companies", tblDisplayName:"Contact Companies", valueArray:[1], displayArray:["--All Contact Companies in the Contacts System--"], numOptions:this.props.DatabaseMobx.o_tbl_g_contacts_companies.size},
        {tblName:"tbl_a_users", tblDisplayName:c_productStylingObj.productName + " Users", valueArray:c_valueDisplayArraysObjUsersNotDeactivated.valueArray, displayArray:c_valueDisplayArraysObjUsersNotDeactivated.displayArray, numOptions:c_valueDisplayArraysObjUsersNotDeactivated.valueArray.length},
        {tblName:"tbl_a_divisions", tblDisplayName:"Divisions", valueArray:doSwsDataObj.valueArray, displayArray:doSwsDataObj.displayArray, numOptions:doSwsDataObj.valueArray.length}
      ];

      //add contact company field admin tbls to be able to point to
      const adminSelectTblLabelsArray = [
        "Contact Company Business Types",
        "Contact Company Set-Asides (Small Business Certifications)",
        "Contact Company Capabilities",
        "Contact Company NAICS Codes"
      ];
      const adminSelectTblNamesArray = [
        "tbl_a_business_types",
        "tbl_bit_master_set_asides",
        "tbl_a_capabilities",
        "tbl_bit_master_naics_codes"
      ];
      for(let t = 0; t < adminSelectTblNamesArray.length; t++) {
        var tblName = adminSelectTblNamesArray[t];
        var tblLabel = adminSelectTblLabelsArray[t];
        var tblRef = this.props.DatabaseMobx.tbl_ref_from_tbl_name(tblName);
        var valueArray = JSFUNC.get_column_vector_from_mapOfMaps(tblRef, "id");
        var displayArray = JSFUNC.get_column_vector_from_mapOfMaps(tblRef, ((tblName === "tbl_bit_master_naics_codes") ? ("title") : ("name")));
        existingSystemTblsArrayOfObjs.push({tblName:tblName, tblDisplayName:tblLabel, valueArray:valueArray, displayArray:displayArray, numOptions:tblRef.size});
      }

      //add all custom tbl_cap tbls
      var existingCustomCapTblsArrayOfObjs = [];
      for(let fieldMap of this.props.DatabaseMobx.c_tbl_captures_fields.values()) {
        var fieldDbName = fieldMap.get("db_name");
        var selectTblName = fieldMap.get("select_tbl_name");
        var selectTblNameFirst10Chars = selectTblName.substring(0, 10);
        if(selectTblNameFirst10Chars === "tbl_cap_n_" || selectTblNameFirst10Chars === "tbl_cap_s_") {
          var displayName = fieldMap.get("display_name");
          var fieldTypeObj = fieldMap.get("fieldTypeObj");
          var selectTblName = fieldMap.get("select_tbl_name");
          if((fieldTypeObj !== undefined) && (fieldTypeObj.selectWithSearchDataObj !== undefined) && JSFUNC.is_array(fieldTypeObj.selectWithSearchDataObj.valueArray)) {
            var existingTableObj = {
              tblName: selectTblName,
              tblDisplayName: displayName,
              valueArray: fieldTypeObj.selectWithSearchDataObj.valueArray,
              displayArray: fieldTypeObj.selectWithSearchDataObj.displayArray,
              numOptions: fieldTypeObj.selectWithSearchDataObj.valueArray.length
            };
            existingCustomCapTblsArrayOfObjs.push(existingTableObj);
          }
        }
      }
      JSFUNC.sort_arrayOfObjs(existingCustomCapTblsArrayOfObjs, "tblDisplayName", true);

      //find the selected existing tbl if one is currently selected
      var selectedExistingTableObj = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(existingSystemTblsArrayOfObjs, "tblName", s_selectExistingSourceDataTblNameOrNew);
      if(selectedExistingTableObj === undefined) {
        selectedExistingTableObj = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(existingCustomCapTblsArrayOfObjs, "tblName", s_selectExistingSourceDataTblNameOrNew);
      }

      processInstructions = "For this new Select field, choose whether you will create a new list of options, or point to an existing set of options";
      processComponent = (
        <div className="flex11a displayFlexColumn">
          <div className="flex00a medFullPad">
            <font className="font16 fontItalic">{"New Select Field: "}</font>
            <font className="font16 fontBold fontBlue">{s_newCaptureFieldName}</font>
          </div>
          <div className="flex11a displayFlexRow medBottomPad lrMedPad">
            <NewCaptureSelectFieldSplitPageShell p_label="Create a New List of Options (most common)">
              <div className="flex11a yScroll medFullPad">
                <NewCaptureSelectFieldCreateNewListOfOptionsButton
                  p_selectedTF={selectedNewTblCapNameTF}
                  p_label="Create new list of options sorted alphabetically"
                  p_subLabel="The options list is manually entered (or imported from a .csv) in the next step. The list is automatically sorted alphabetically."
                  f_onClick={this.onclick_select_choose_create_new_tbl_cap_name}
                />
                <div className="bigTopMargin" />
                <NewCaptureSelectFieldCreateNewListOfOptionsButton
                  p_selectedTF={selectedNewTblCapSortTF}
                  p_label="Create new list of options with separate sort column"
                  p_subLabel="The options list is manually entered (or imported from a .csv) in the next step. There is an extra column for the list to be sorted non-alphabetically."
                  f_onClick={this.onclick_select_choose_create_new_tbl_cap_sort}
                />
              </div>
            </NewCaptureSelectFieldSplitPageShell>
            <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"6em"}}>
              <font className="font20 fontItalic fontTextLighter">
                {"OR"}
              </font>
            </div>
            <NewCaptureSelectFieldSplitPageShell p_label="Point to an Existing Set of Options">
              <div className="flex11a displayFlexRow">
                <div className="flex11a yScroll medFullPad borderR1bbb" style={{flexBasis:"100em"}}>
                  {(!JSFUNC.in_array(s_selectedFieldInputType, ["selectadd", "selectmultiadd", "sharedpercentadd"])) &&
                    <>
                      <div className="smallBottomMargin">
                        <font className="font14 fontItalic fontBlue">
                          {"System Datasets"}
                        </font>
                      </div>
                      {existingSystemTblsArrayOfObjs.map((m_tblObj) =>
                        <NewCaptureSelectFieldExistingDataTableChoice
                          p_tblName={m_tblObj.tblName}
                          p_tblDisplayName={m_tblObj.tblDisplayName}
                          p_numOptions={m_tblObj.numOptions}
                          p_selectedTblName={s_selectExistingSourceDataTblNameOrNew}
                          f_onClick={this.onclick_select_existing_data_table_choice}
                        />
                      )}
                      <div className="hugeTopMargin" />
                    </>
                  }
                  <div className="smallBottomMargin">
                    <font className="font14 fontItalic fontBlue">
                      {"User Made Datasets"}
                    </font>
                  </div>
                  {existingCustomCapTblsArrayOfObjs.map((m_tblObj) =>
                    <NewCaptureSelectFieldExistingDataTableChoice
                      p_tblName={m_tblObj.tblName}
                      p_tblDisplayName={m_tblObj.tblDisplayName}
                      p_numOptions={m_tblObj.numOptions}
                      p_selectedTblName={s_selectExistingSourceDataTblNameOrNew}
                      f_onClick={this.onclick_select_existing_data_table_choice}
                    />
                  )}
                </div>
                <div className="flex11a yScroll medFullPad" style={{flexBasis:"100em"}}>
                  <div className="smallBottomMargin">
                    <font className="font14 fontItalic fontTextLighter">
                      {"Click an Existing Dataset to view its Options"}
                    </font>
                  </div>
                  {(selectedExistingTableObj !== undefined) &&
                    <div className="medFullPad bgWhite border1bbb">
                      <div className="medBottomMargin">
                        <font className="font13 fontItalic fontTextLight">
                          {"Options for '" + selectedExistingTableObj.tblDisplayName + "':"}
                        </font>
                      </div>
                      {selectedExistingTableObj.displayArray.map((m_display, m_index) =>
                        <div key={selectedExistingTableObj.valueArray[m_index]} className="tbMicroMargin">
                          <font className="">
                            {m_display}
                          </font>
                        </div>
                      )}
                    </div>
                  }
                </div>
              </div>
            </NewCaptureSelectFieldSplitPageShell>
          </div>
          <div className="flex00a displayFlexRow tbPad borderT1ddd">
            <div className="flex00a displayFlexColumnHcVc lrMedPad borderR1ddd">
              <CEGeneralReact.CEButton p_type="add" p_text="Go Back" f_onClick={this.onclick_proceed_to_define_field_fields} />
            </div>
            <div className="flex11a displayFlexColumnHcVc">
              {bottomButtonComponent}
            </div>
          </div>
        </div>
      );
    }
    else if(s_processStep === "createOptionsForSelectType") {
      var tblCapAedTableComponent = null;
      const tblCapMapOfMaps = this.props.DatabaseMobx.tbl_ref_from_tbl_name(s_newlyCreatedTblCapTblName);
      if(tblCapMapOfMaps === undefined) {
        tblCapAedTableComponent = (
          <div>
            <font className="font12 fontItalic fontTextLighter">
              {"--The reference table for this new field was not created successfully (" + s_newlyCreatedTblCapTblName + ")--"}
            </font>
          </div>
        );
      }
      else {
        const selectTblCapOptionsArrayOfObjs = JSFUNC.arrayOfObjs_from_mapOfMaps(tblCapMapOfMaps);

        var selectTblCapsAedTableObj = undefined;
        if(s_selectExistingSourceDataTblNameOrNew === "newTblCapSort") {
          selectTblCapsAedTableObj = {
            tblName: s_newlyCreatedTblCapTblName,
            dragToResortFieldDbName: "sort",
            initialSortedFieldDbName: "sort",
            itemName: "Option",
            deleteItemNameFieldDbName: "name",
            searchFieldDbName: "name",
            addNewItemInlineTextInputFieldDbName: "name",
            importFromCsvIntoFieldDbName: "name",
            fieldsArrayOfObjs: [
              {width:"100em", dbName:"name", displayName:"Option", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true},
              {width:"3em", dbName:"sort", displayName:"Sort", fieldTypeObj:this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj, initialValue:1}
            ]
          };
        }
        else {
          selectTblCapsAedTableObj = {
            tblName: s_newlyCreatedTblCapTblName,
            initialSortedFieldDbName: "name",
            itemName: "Option",
            deleteItemNameFieldDbName: "name",
            searchFieldDbName: "name",
            addNewItemInlineTextInputFieldDbName: "name",
            importFromCsvIntoFieldDbName: "name",
            fieldsArrayOfObjs: [
              {width:"100em", dbName:"name", displayName:"Option", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true},
            ]
          };
        }

        tblCapAedTableComponent = (
          <AddEditDeleteTable
            p_dataArrayOfObjs={selectTblCapOptionsArrayOfObjs}
            p_aedTableObj={selectTblCapsAedTableObj}
          />
        );
      }

      processInstructions = "Finally, for this new custom Select field, add the Options that will appear in the field's pull-down menu for users to choose from";
      processComponent = (
        <div className="flex11a displayFlexColumn">
          <div className="flex11a displayFlexRow yScroll medFullPad">
            <div className="flex11a" style={{flexBasis:"100em"}} />
            <div className="flex11a" style={{flexBasis:"200em"}}>
              {tblCapAedTableComponent}
            </div>
            <div className="flex11a" style={{flexBasis:"100em"}} />
          </div>
          <div className="flex00a displayFlexColumnHcVc tbPad borderT1ddd">
            <CEGeneralReact.CEButton p_type="blue" p_text="Complete Process and Close" f_onClick={this.props.f_onClickClose} />
          </div>
        </div>
      );
      useSaveTrueCancelFalse = true;
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableNewCaptureField"
        p_title={"Adding a New " + p_aedTableObj.itemName}
        f_onClickSave={((useSaveTrueCancelFalse) ? (this.props.f_onClickClose) : (undefined))}
        f_onClickCancel={((useSaveTrueCancelFalse) ? (undefined) : (this.props.f_onClickClose))}>
        <div className="flex11a displayFlexColumn">
          <NewCaptureFieldOrDealShapingQuestionInstructionsBar p_label={processInstructions} />
          {processComponent}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));


function NewCaptureFieldOrDealShapingQuestionInstructionsBar(props) { //props: p_label
  return(
    <div className="flex00a smallFullPad" style={{background:"linear-gradient(#edb,#dca)", borderBottom:"solid 1px #ba8"}}>
      <font className="font14 fontItalic fontText">
        {props.p_label}
      </font>
    </div>
  );
}


function NewCaptureFieldTypeDivider(props) { //props: p_label
  return(
    <div className="smallFullPad bgDarkGrayGradient fontWhite">
      <LibraryReact.NowrapEllipsis p_fontClass="font14 fontItalic">
        {props.p_label}
      </LibraryReact.NowrapEllipsis>
    </div>
  );
}

function NewCaptureSelectFieldSplitPageShell(props) { //props: p_label, children
  return(
    <div className="flex11a displayFlexColumn border1bbb" style={{flexBasis:"100em"}}>
      <div className="flex00a displayFlexColumn borderB1bbb tbMedPad bgLightGray textCenter">
        <font className="font17 fontBold fontItalic fontBlue">
          {props.p_label}
        </font>
      </div>
      <div className="flex11a displayFlexColumn bgLighterGray">
        {props.children}
      </div>
    </div>
  );
}

function NewCaptureSelectFieldCreateNewListOfOptionsButton (props) { //props: p_selectedTF, p_label, p_subLabel, f_onClick
  const p_selectedTF = props.p_selectedTF;
  const p_label = props.p_label;
  const p_subLabel = props.p_subLabel;

  return(
    <div
      className={"displayFlexColumnHcVc border bevelBorderColors " + ((p_selectedTF) ? ("ticketResponseFromBITUnread") : ("bgAlmostWhite hoverLighterBlueGradient cursorPointer"))}
      style={{height:"10em", padding:"0 5em"}}
      onClick={props.f_onClick}>
      <div>
        <font className="font15 fontBold fontTextLighter">
          {p_label}
        </font>
      </div>
      <div className="smallTopMargin">
        <font className="font12 fontItalic fontTextLighter">
          {p_subLabel}
        </font>
      </div>
    </div>
  )
}


const NewCaptureFieldTypeChoice = inject("DatabaseMobx")(observer(
class NewCaptureFieldTypeChoice extends Component { //props: p_fieldInputType, p_selectedFieldInputType, f_onClick
  constructor(props) {
    super(props);

    const p_fieldInputType = this.props.p_fieldInputType;

    const c_cardNameDates = this.props.DatabaseMobx.c_cardNameDates;

    var typeDescriptionArray = [];
    var fieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    var exampleValueInit = "";
    if(p_fieldInputType === "text") {
      typeDescriptionArray = ["Best for short input of text data", "Editing has single line of input", "Can store approx 2,000 words, but is not ideal to use when typing more than ~15 words"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
      exampleValueInit = "Short sample text";
    }
    else if(p_fieldInputType === "textarea") {
      typeDescriptionArray = ["Best for long input of text data", "Editing has large input box in a separate window", "Can store approx 500,000 words"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericTextareaFieldTypeObj;
      exampleValueInit = "Long sample text to show the use of the textarea. This input can have multiple lines and multiple paragraphs.";
    }
    else if(p_fieldInputType === "email") {
      typeDescriptionArray = ["Displays email address with link to your native email system"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericEmailFieldTypeObj;
      exampleValueInit = "email.address@example.com";
    }
    else if(p_fieldInputType === "phone") {
      typeDescriptionArray = ["Displays phone number with link to you native dialing system"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericPhoneFieldTypeObj;
      exampleValueInit = "(555) 555-5555";
    }
    else if(p_fieldInputType === "website") {
      typeDescriptionArray = ["Displays a hyperlink that opens the specified website in a new tab", "Allows option for a user defined mask displayed instead of the address"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericWebsiteFieldTypeObj;
      exampleValueInit = "[[BIT Solutions Homepage]]http://www.bitsolutionsllc.com";
    }
    else if(p_fieldInputType === "int") {
      typeDescriptionArray = ["Numeric input of zero, positive, and negative whole numbers", "Can store up to 19 digits"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericIntFieldTypeObj;
      exampleValueInit = 2300;
    }
    else if(p_fieldInputType === "int_positive") {
      typeDescriptionArray = ["Numeric input of zero and positive whole numbers", "Can store up to 19 digits", "Optional zero-padding fixed # digits can be specified"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj;
      exampleValueInit = 2300;
    }
    else if(p_fieldInputType === "decimal") {
      typeDescriptionArray = ["Numeric input of zero, positive, and negative decimal or whole numbers", "Can store up to 9 leading digits and/or 9 decimals"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDecimalFieldTypeObj;
      exampleValueInit = 2300.47;
    }
    else if(p_fieldInputType === "decimal_positive") {
      typeDescriptionArray = ["Numeric input of zero and positive decimal or whole numbers", "Can store up to 9 leading digits and/or 9 decimals"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDecimalPositiveFieldTypeObj;
      exampleValueInit = 2300.47;
    }
    else if(p_fieldInputType === "percent_int") {
      typeDescriptionArray = ["Numeric input of zero, positive, and negative whole numbers, automatically masked with a '%'", "Can store up to 19 digits"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericPercentIntFieldTypeObj;
      exampleValueInit = 145;
    }
    else if(p_fieldInputType === "percent_int_0to100") {
      typeDescriptionArray = ["Numeric input of whole numbers between 0 and 100, automatically masked with a '%'"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericPercentInt0to100FieldTypeObj;
      exampleValueInit = 5;
    }
    else if(p_fieldInputType === "percent_decimal") {
      typeDescriptionArray = ["Numeric input of zero, positive, and negative decimal or whole numbers, automatically masked with a '%'", "Can store up to 9 leading digits and/or 9 decimals"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericPercentDecimalFieldTypeObj;
      exampleValueInit = 145.47;
    }
    else if(p_fieldInputType === "percent_decimal_0to100") {
      typeDescriptionArray = ["Numeric input of decimal or whole numbers between 0 and 100, automatically masked with a '%'"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericPercentDecimal0to100FieldTypeObj;
      exampleValueInit = 5.47;
    }
    else if(p_fieldInputType === "money") {
      typeDescriptionArray = ["Numeric input of zero, positive, and negative whole numbers, automatically masked with '$' and commas", "Can store up to 19 digits"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericMoneyFieldTypeObj;
      exampleValueInit = 67000000;
    }
    else if(p_fieldInputType === "money_cents") {
      typeDescriptionArray = ["Numeric input of zero, positive, and negative decimal or whole numbers, automatically masked with '$' and commas", "Can store up to 9 leading digits and/or 2 decimals"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericMoneyCentsFieldTypeObj;
      exampleValueInit = 67.89;
    }
    else if(p_fieldInputType === "color") {
      typeDescriptionArray = ["Allows choice of any user defined color"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericColorFieldTypeObj;
      exampleValueInit = "bfd5db";
    }
    else if(p_fieldInputType === "date") {
      typeDescriptionArray = ["Standard date (Day, Month, Year) displayed in 'company format' (which can be changed in Admin 'System' tab)", "Note: when placed onto the Capture " + c_cardNameDates + " Card, this field type will be automatically formatted into the 'Date (days until due)' format when viewed on the " + c_cardNameDates + " Card"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateFieldTypeObj;
      exampleValueInit = JSFUNC.now_dateYmd();
    }
    else if(p_fieldInputType === "date_DMjY") {
      typeDescriptionArray = ["Date displayed in format 'Day MMM dd, YYYY'"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateDMjYFieldTypeObj;
      exampleValueInit = JSFUNC.now_dateYmd();
    }
    else if(p_fieldInputType === "date_dayMdyDaysUntil1") {
      typeDescriptionArray = ["Date displayed in format 'Day MMM dd, YYYY', with a 'days until' box", "No 'days until' box drawn if date is passed", "Colors for the (color 1) 'days until' box can be changed in the Admin 'Upcoming Date Colors' tab"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateDayMdyDaysUntil1FieldTypeObj;
      exampleValueInit = JSFUNC.now_dateYmd();
    }
    else if(p_fieldInputType === "date_dayMdyDaysUntil1Overdue") {
      typeDescriptionArray = ["Same as Date Upcoming (color 1)", "'Overdue' displayed in 'days until' box if date is passed"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateDayMdyDaysUntil1OverdueFieldTypeObj;
      exampleValueInit = JSFUNC.now_dateYmd();
    }
    else if(p_fieldInputType === "date_dayMdyDaysUntil2") {
      typeDescriptionArray = ["Same as Date Upcoming (color 1)", "The 'days until' box uses (color 2)"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateDayMdyDaysUntil2FieldTypeObj;
      exampleValueInit = JSFUNC.now_dateYmd();
    }
    else if(p_fieldInputType === "date_dayMdyDaysUntil2Overdue") {
      typeDescriptionArray = ["Same as Date Upcoming (color 1)", "The 'days until' box uses (color 2) and 'Overdue' displayed if date is passed"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateDayMdyDaysUntil2OverdueFieldTypeObj;
      exampleValueInit = JSFUNC.now_dateYmd();
    }
    else if(p_fieldInputType === "dateWithDuration") {
      typeDescriptionArray = ["Standard date displayed in 'company format'", "Has an extra option to specify a 'duration' of the event in days/weeks/months/years", "Shows the duration width on the Gantt Chart view"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateWithDurationFieldTypeObj;
      exampleValueInit = JSFUNC.now_dateYmd() + " 00:00:00";
    }
    else if(p_fieldInputType === "datetime") {
      typeDescriptionArray = ["Standard date and time (Date, Month, Year, Hours, Minutes) displayed in 'company format' (which can be changed in Admin 'System' tab)"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateTimeFieldTypeObj;
      exampleValueInit = JSFUNC.now_naturalDateTimeUtcYmdHis();
    }
    else if(p_fieldInputType === "datetime_MjYgiA") {
      typeDescriptionArray = ["Date/Time displayed in format 'Month Date, Year Hours:Minutes AM/PM'"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateTimeMjYgiAFieldTypeObj;
      exampleValueInit = JSFUNC.now_naturalDateTimeUtcYmdHis();
    }
    else if(p_fieldInputType === "datetime_dayMdyDaysUntil1") {
      typeDescriptionArray = ["Date/Time displayed in format 'Day MMM dd, YYYY hh:mm A/P', with a 'days until' box", "No 'days until' box drawn if date is passed", "Colors for the (color 1) 'days until' box can be changed in the Admin 'Upcoming Date Colors' tab"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateTimeDayMdyDaysUntil1FieldTypeObj;
      exampleValueInit = JSFUNC.now_naturalDateTimeUtcYmdHis();
    }
    else if(p_fieldInputType === "datetime_dayMdyDaysUntil1Overdue") {
      typeDescriptionArray = ["Same as Date/Time Upcoming (color 1)", "'Overdue' displayed in 'days until' box if date is passed"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateTimeDayMdyDaysUntil1OverdueFieldTypeObj;
      exampleValueInit = JSFUNC.now_naturalDateTimeUtcYmdHis();
    }
    else if(p_fieldInputType === "datetime_dayMdyDaysUntil2") {
      typeDescriptionArray = ["Same as Date/Time Upcoming (color 1)", "The 'days until' box uses (color 2)"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateTimeDayMdyDaysUntil2FieldTypeObj;
      exampleValueInit = JSFUNC.now_naturalDateTimeUtcYmdHis();
    }
    else if(p_fieldInputType === "datetime_dayMdyDaysUntil2Overdue") {
      typeDescriptionArray = ["Same as Date/Time Upcoming (color 1)", "The 'days until' box uses (color 2) and 'Overdue' displayed if date is passed"];
      fieldTypeObj = this.props.DatabaseMobx.c_genericDateTimeDayMdyDaysUntil2OverdueFieldTypeObj;
      exampleValueInit = JSFUNC.now_naturalDateTimeUtcYmdHis();
    }
    else if(p_fieldInputType === "select") {
      typeDescriptionArray = ["Creates a drop-down list of admin defined 'options'", "Admin can define an unlimited number of options to choose from. A search is provided to filter the choices", "Users can select only 1 option from the list (or clear the selection and leave it 'unselected')"];
      const vA = [1, 2, 3, 4];
      const dA = ["Sample Option #1", "Sample Option #2", "Sample Option #3", "Sample Option #4"];
      const swsOptionsObj = {hasSearchTF:true, hasClearSelectionTF:true};
      const selectSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Option", vA, false, dA, swsOptionsObj);
      fieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectSwsDataObj);
      exampleValueInit = 1;
    }
    else if(p_fieldInputType === "selectmulti") {
      typeDescriptionArray = ["Creates a Select (described above)", "Users can select multiple options simultaneously", "All selected choices are displayed separated by commas"];
      const vA = [1, 2, 3, 4];
      const dA = ["Sample Multi Option #1", "Sample Multi Option #2", "Sample Multi Option #3", "Sample Multi Option #4"];
      const swsOptionsObj = {isMultiSelectTF:true, hasSearchTF:true, hasClearSelectionTF:true};
      const selectSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Option", vA, false, dA, swsOptionsObj);
      fieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectSwsDataObj);
      exampleValueInit = "3,1";
    }
    else if(p_fieldInputType === "sharedpercent") {
      typeDescriptionArray = ["Essentially a Multi-Select (described above) with user defined percent allocations (totalling up to 100%)", "All allocations must total 100% before the Shared Percent can be saved"];
      const vA = [1, 2, 3, 4];
      const dA = ["Sample Percent Option #1", "Sample Percent Option #2", "Sample Percent Option #3", "Sample Percent Option #4"];
      const swsOptionsObj = {hasSearchTF:true, hasClearSelectionTF:true};
      const selectSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Option", vA, false, dA, swsOptionsObj);
      fieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("sharedpercent", selectSwsDataObj);
      exampleValueInit = "4:75,1:20,3:5";
    }
    else if(p_fieldInputType === "selectadd") {
      typeDescriptionArray = ["Creates a Select (described above)", "Users can add new entries to the table of options without the admin's help"];
      const vA = [1, 2, 3, 4];
      const dA = ["Sample Option #1", "Sample Option #2", "Sample Option #3", "Sample Option #4"];
      const swsOptionsObj = {hasSearchTF:true, hasClearSelectionTF:true, selectAddTblName:"example", selectAddNameFieldDbName:"name"};
      const selectSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Option", vA, false, dA, swsOptionsObj);
      fieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectSwsDataObj);
      exampleValueInit = 1;
    }
    else if(p_fieldInputType === "selectmultiadd") {
      typeDescriptionArray = ["Creates a Multi-Select (described above)", "Users can add new entries to the table of options without the admin's help"];
      const vA = [1, 2, 3, 4];
      const dA = ["Sample Multi Option #1", "Sample Multi Option #2", "Sample Multi Option #3", "Sample Multi Option #4"];
      const swsOptionsObj = {isMultiSelectTF:true, hasSearchTF:true, hasClearSelectionTF:true, selectAddTblName:"example", selectAddNameFieldDbName:"name"};
      const selectSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Option", vA, false, dA, swsOptionsObj);
      fieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectSwsDataObj);
      exampleValueInit = "3,1";
    }
    else if(p_fieldInputType === "sharedpercentadd") {
      typeDescriptionArray = ["Essentially a Multi-Select (described above) with user defined percent allocations (totalling up to 100%)", "All allocations must total 100% before the Shared Percent can be saved", "Users can add new entries to the table of options without the admin's help"];
      const vA = [1, 2, 3, 4];
      const dA = ["Sample Percent Option #1", "Sample Percent Option #2", "Sample Percent Option #3", "Sample Percent Option #4"];
      const swsOptionsObj = {hasSearchTF:true, hasClearSelectionTF:true, selectAddTblName:"example", selectAddNameFieldDbName:"name"};
      const selectSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Option", vA, false, dA, swsOptionsObj);
      fieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("sharedpercent", selectSwsDataObj);
      exampleValueInit = "4:75,1:20,3:5";
    }
    else if(p_fieldInputType === "verticalswitch") {
      typeDescriptionArray = ["Identical function to a 'Select', but presented as a radio button list of the options", "Good when selecting between 2 or 3 options"];
      const vA = [1, 2, 3];
      const dA = ["Sample Vertical Option #1", "Sample Vertical Option #2", "Sample Vertical Option #3"];
      fieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Option", vA, false, dA, undefined);
      exampleValueInit = 1;
    }

    var fieldTypeDisplay = fieldTypeObj.inputTypeMask;
    if(JSFUNC.in_array(p_fieldInputType, ["selectadd", "selectmultiadd", "sharedpercentadd"])) {
      fieldTypeDisplay += " (with add)";
    }

    this.state = {
      s_fieldTypeDisplay: fieldTypeDisplay,
      s_typeDescriptionArray: typeDescriptionArray,
      s_fieldTypeObj: fieldTypeObj,
      s_exampleValue: exampleValueInit
    };
  }

  onchange_example_field = (i_newValue) => {
    this.setState({s_exampleValue:i_newValue});
  }

  onclick_field_type_choice = () => {
    const s_fieldTypeDisplay = this.state.s_fieldTypeDisplay;
    const s_fieldTypeObj = this.state.s_fieldTypeObj;

    const p_fieldInputType = this.props.p_fieldInputType;
    const p_selectedFieldInputType = this.props.p_selectedFieldInputType;

    if(JSFUNC.is_function(this.props.f_onClick)) {
      const newSelectedFieldType = ((p_fieldInputType === p_selectedFieldInputType) ? (undefined) : (p_fieldInputType))
      this.props.f_onClick(newSelectedFieldType, s_fieldTypeDisplay, s_fieldTypeObj);
    }
  }

  render() {
    const s_fieldTypeDisplay = this.state.s_fieldTypeDisplay;
    const s_typeDescriptionArray = this.state.s_typeDescriptionArray;
    const s_fieldTypeObj = this.state.s_fieldTypeObj;
    const s_exampleValue = this.state.s_exampleValue;

    const p_fieldInputType = this.props.p_fieldInputType;
    const p_selectedFieldInputType = this.props.p_selectedFieldInputType;

    const typeIsSelectedTF = (p_fieldInputType === p_selectedFieldInputType);

    return(
      <div
        className={"smallTopMargin smallFullPad border bevelBorderColors " + ((typeIsSelectedTF) ? ("ticketResponseFromBITUnread") : ("bgAlmostWhite hoverLighterBlueGradient cursorPointer"))}
        onClick={this.onclick_field_type_choice}>
        <div className="displayFlexRow">
          <div className="flex11a" style={{flexBasis:"100em"}}>
            <div className="smallBottomMargin">
              <font className="font15 fontBold fontTextLighter">
                {s_fieldTypeDisplay}
              </font>
            </div>
          </div>
          <div className="flex11a" style={{flexBasis:"150em"}}>
            {s_typeDescriptionArray.map((m_descriptionLine) =>
              <div className="displayFlexRow microTopMargin">
                <div className="flex00a lrMargin">
                  <font className="fontTextLighter">
                    {"-"}
                  </font>
                </div>
                <div className="flex11a">
                  <font className="fontItalic fontTextLighter">
                    {m_descriptionLine}
                  </font>
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString={"addNewCaptureFieldTypeExample" + p_fieldInputType}
            p_fieldDisplayName={"Example Field"}
            p_fieldTypeObj={s_fieldTypeObj}
            p_valueRaw={s_exampleValue}
            p_valueIsEditableTFU={true}
            p_fieldClass="fontBlue"
            p_fieldWidth="7em"
            p_fieldNowrapTF={false}
            p_valueMaxHeight="4em"
            p_fieldValueVerticallyAlignedTF={true}
            p_floatingBoxTitle={"Example " + s_fieldTypeDisplay + " Field"}
            f_onSaveChanged={this.onchange_example_field}
          />
        </div>
      </div>
    );
  }
}));

class NewCaptureSelectFieldExistingDataTableChoice extends Component { //props: p_tblName, p_tblDisplayName, p_numOptions, p_selectedTblName, f_onClick
  onclick_select_options_data_tbl_choice = () => {
    const p_tblName = this.props.p_tblName;
    const p_selectedTblName = this.props.p_selectedTblName;

    if(JSFUNC.is_function(this.props.f_onClick)) {
      const newSelectedTblName = ((p_tblName === p_selectedTblName) ? (undefined) : (p_tblName))
      this.props.f_onClick(newSelectedTblName);
    }
  }

  render() {
    const p_tblName = this.props.p_tblName;
    const p_tblDisplayName = this.props.p_tblDisplayName;
    const p_numOptions = this.props.p_numOptions;
    const p_selectedTblName = this.props.p_selectedTblName;

    const tblIsSelectedTF = (p_tblName === p_selectedTblName);

    return(
      <div
        className={"smallTopMargin smallFullPad border bevelBorderColors " + ((tblIsSelectedTF) ? ("ticketResponseFromBITUnread") : ("bgAlmostWhite hoverLighterBlueGradient cursorPointer"))}
        onClick={this.onclick_select_options_data_tbl_choice}>
        <div className="displayFlexRowVc">
          <div className="flex11a">
            <font className="font15 fontBold fontTextLighter">
              {p_tblDisplayName}
            </font>
            {((p_tblName === "tbl_g_contacts_persons") || (p_tblName === "tbl_g_contacts_companies")) &&
              <div className="microTopMargin">
                <font className="fontItalic fontTextLighter">
                  {"Uses special Contacts interface when selecting Contacts"}
                </font>
              </div>
            }
          </div>
          <div className="flex00a" style={{flexBasis:"10em"}}>
            <div className="textCenter">
              <font className="fontItalic fontTextLighter">
                {"# Options"}
              </font>
            </div>
            <div className="microTopMargin textCenter">
              <font className="font11 fontItalic fontTextLight">
                {p_numOptions}
              </font>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



class CreateNewFieldCodewordAlternativesAddEdit extends Component { //props: p_newCaptureFieldName, p_codewordNamesComma, f_onChange
  onclick_add_new_alt_codeword = () => {
    const p_codewordNamesComma = this.props.p_codewordNamesComma;

    var newCodewordNamesComma = undefined;
    if(p_codewordNamesComma === undefined) {
      newCodewordNamesComma = "";
    }
    else {
      newCodewordNamesComma = p_codewordNamesComma + ",";
    }
    this.call_onchange(newCodewordNamesComma);
  }

  onchange_codeword = (i_newValue, i_index) => {
    const p_codewordNamesComma = this.props.p_codewordNamesComma;
    
    if(JSFUNC.is_string(p_codewordNamesComma)) {
      var oldCodewordNamesArray = JSFUNC.convert_comma_list_to_array(p_codewordNamesComma);
      oldCodewordNamesArray[i_index] = i_newValue;
      const newCodewordNamesComma = JSFUNC.convert_array_to_comma_list(oldCodewordNamesArray);
      this.call_onchange(newCodewordNamesComma);
    }
    else {
      this.call_onchange(undefined);
    }
  }

  onremove_codeword = (i_index) => {
    const p_codewordNamesComma = this.props.p_codewordNamesComma;

    if(JSFUNC.is_string(p_codewordNamesComma)) {
      var oldCodewordNamesArray = JSFUNC.convert_comma_list_to_array(p_codewordNamesComma);
      var newCodewordNamesArray = [];
      for(let i = 0; i < oldCodewordNamesArray.length; i++) {
        if(i !== i_index) {
          newCodewordNamesArray.push(oldCodewordNamesArray[i]);
        }
      }

      if(newCodewordNamesArray.length === 0) {
        this.call_onchange(undefined);
      }
      else {
        this.call_onchange(JSFUNC.convert_array_to_comma_list(newCodewordNamesArray));
      }
    }
    else {
      this.call_onchange(undefined);
    }
  }

  call_onchange = (i_newValue) => {
    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange(i_newValue);
    }
  }

  render() {
    const p_newCaptureFieldName = this.props.p_newCaptureFieldName;
    const p_codewordNamesComma = this.props.p_codewordNamesComma;

    var codewordNamesArray = []; //default for undefined
    if(p_codewordNamesComma === "") {
      codewordNamesArray = [""];
    }
    else {
      codewordNamesArray = JSFUNC.convert_comma_list_to_array(p_codewordNamesComma);
    }

    return(
      <>
        <CEGeneralReact.CEButton
          p_type="add"
          p_text="Add Alternative Template Codeword(s)"
          f_onClick={this.onclick_add_new_alt_codeword}
        />
        <div className="smallTopMargin">
          <font className="font11 fontItalic fontTextLight">
            {"[[" + JSFUNC.db_name_from_display_name(p_newCaptureFieldName) + "]]"}
          </font>
        </div>
        {codewordNamesArray.map((m_codeword, m_index) =>
          <AlternativeCodewordInput
            p_codeword={m_codeword}
            p_index={m_index}
            f_onChange={this.onchange_codeword}
            f_onRemove={this.onremove_codeword}
          />
        )}
      </>
    );
  }
}

const AlternativeCodewordInput = inject("DatabaseMobx")(observer(
class AlternativeCodewordInput extends Component { //props: p_codeword, p_index, f_onChange, f_onRemove
  onchange_codeword = (i_newValue) => {
    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange(i_newValue, this.props.p_index);
    }
  }

  onclick_remove_codeword = () => {
    if(JSFUNC.is_function(this.props.f_onRemove)) {
      this.props.f_onRemove(this.props.p_index);
    }
  }

  render() {
    const p_codeword = this.props.p_codeword;
    return(
      <div className="displayFlexRowVc smallTopMargin">
        <div className="lrMargin">
          <font className="font11 fontItalic fontTextLight">
            {"[["}
          </font>
        </div>
        <div className="displayFlexRowVc">
          <CEGeneralReact.GenericInputOrSelectFromInputType
            p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
            p_valueRaw={p_codeword}
            f_onChangeOrOnSelect={this.onchange_codeword}
          />
        </div>
        <div className="lrMargin">
          <font className="font11 fontItalic fontTextLight">
            {"]]"}
          </font>
        </div>
        <div className="lrMedMargin">
          <CEGeneralReact.RemoveItemXWithRedHover
            f_onClick={this.onclick_remove_codeword}
          />
        </div>
      </div>
    );
  }
}));








//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//AEDTable - add new Deal Shaping Question
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
const AddEditDeleteTableAddNewDealShapingQuestionFloatingBox = inject("DatabaseMobx")(observer(
class AddEditDeleteTableAddNewDealShapingQuestionFloatingBox extends Component { //props: p_dataArrayOfObjs, p_aedTableObj, f_onClickClose
  constructor(props) {
    super(props);

    this.state = {
      s_processStep: "answerType", //"answerType", "questionFields", "createAnswers", "createAnswersSearchQuestionsToCopyAnswers"
      s_answerType123: undefined,
      s_questionName: "",
      s_tagIDsComma: "",
      s_hoverText: "",
      s_stylingStringCommaList: "",
      s_questionNameErrorMessage: undefined,
      s_phpIsCreatingQuestionTF: false,
      s_newlyCreatedQuestionID: -1
    }
  }

  onclick_select_answer_type = (i_selectedAnswerType123) => {
    this.setState({s_answerType123:i_selectedAnswerType123});
  }

  onclick_proceed_to_define_question = () => {
    this.setState({s_processStep:"questionFields"});
  }

  onclick_return_to_select_answer_type = () => {
    this.setState({
      s_processStep: "answerType",
      s_answerType123: undefined
    });
  }

  onchange_question_name = (i_newValue) => {
    this.setState({
      s_questionName: i_newValue,
      s_questionNameErrorMessage: undefined
    });
  }

  onchange_tag_ids_comma = (i_newValue) => {
    this.setState({s_tagIDsComma:i_newValue});
  }

  onchange_hover_text = (i_newValue) => {
    this.setState({s_hoverText:i_newValue});
  }

  onchange_styling_string_comma_list = (i_newValue) => {
    this.setState({s_stylingStringCommaList:i_newValue});
  }

  onclick_create_question_or_proceed_to_add_answers = () => {
    if(this.state.s_questionName === "") {
      this.setState({s_questionNameErrorMessage: "The question text cannot be blank"});
    }
    else {
      this.setState({s_phpIsCreatingQuestionTF:true});

      const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - AddEditDeleteTableAddNewDealShapingQuestionFloatingBox", "onclick_create_text_question", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      const fieldNamesArray = ["name", "answer_select1_text2_textarea3", "tag_ids_comma", "admin_sort", "hover_text", "question_name_styling_string_comma"];
      const valuesArray = [this.state.s_questionName, this.state.s_answerType123, this.state.s_tagIDsComma, JSFUNC.sort_max_mysqli_int(), this.state.s_hoverText, this.state.s_stylingStringCommaList];
      const idsbArray = ["s", "i", "s", "i", "s", "s"];
      const resortSortColumnName = "admin_sort";
      const resortFilterFieldNameOrFieldNamesArray = [];
      const resortFilterValueOrValuesArray = [];
      C_CallPhpTblUID.add_insert("tbl_a_shaping_questions_pool", fieldNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);

      const functionOnSuccess = (i_parseResponse) => {
        this.setState({s_newlyCreatedQuestionID:i_parseResponse.outputObj.i0});
      }
      C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

      const functionOnFinish = () => {
        this.setState({s_phpIsCreatingQuestionTF:false});

        if(this.state.s_answerType123 === 1) { //select question, proceed to add answers step after creating question in background
          this.setState({s_processStep:"createAnswers"});
        }
        else {
          if(JSFUNC.is_function(this.props.f_onClickClose)) {
            this.props.f_onClickClose();
          }
        }
      }
      C_CallPhpTblUID.add_function("onFinish", functionOnFinish);

      C_CallPhpTblUID.execute();
    }
  }

  onclick_copy_answers_from_an_existing_question_button = () => {
    this.setState({s_processStep:"createAnswersSearchQuestionsToCopyAnswers"});
  }

  onclose_copy_answers_from_existing_question = () => {
    this.setState({s_processStep:"createAnswers"});
  }

  render() {
    const s_processStep = this.state.s_processStep;
    const s_answerType123 = this.state.s_answerType123;
    const s_questionName = this.state.s_questionName;
    const s_tagIDsComma = this.state.s_tagIDsComma;
    const s_hoverText = this.state.s_hoverText;
    const s_stylingStringCommaList = this.state.s_stylingStringCommaList;
    const s_questionNameErrorMessage = this.state.s_questionNameErrorMessage;
    const s_phpIsCreatingQuestionTF = this.state.s_phpIsCreatingQuestionTF;
    const s_newlyCreatedQuestionID = this.state.s_newlyCreatedQuestionID;

    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_aedTableObj = this.props.p_aedTableObj;

    const c_cardNameDealShaping = this.props.DatabaseMobx.c_cardNameDealShaping;

    var processInstructions = undefined;
    var processComponent = null;
    if(s_processStep === "answerType") {
      processInstructions = "First, choose the answer type for this new Question";
      processComponent = (
        <div className="flex11a displayFlexColumn">
          <div className="flex11a yScroll bgLighterGray">
            {[1,3].map((m_answerType123) =>
              <NewQuestionAnswerTypeChoice
                p_answerType123={m_answerType123}
                p_selectedAnswerType123={s_answerType123}
                f_onClick={this.onclick_select_answer_type}
              />
            )}
          </div>
          <div className="flex00a displayFlexRowHcVc tbPad borderT1ddd">
            {(s_answerType123 !== undefined) &&
              <div className="lrMedPad">
                <CEGeneralReact.CEButton p_type="blue" p_text="Proceed to Next Step Defining the Question" f_onClick={this.onclick_proceed_to_define_question} />
              </div>
            }
            <div className="lrMedPad">
              <CEGeneralReact.CEButton p_type="gray" p_text="Cancel" f_onClick={this.props.f_onClickClose} />
            </div>
          </div>
        </div>
      );
    }
    else if(s_processStep === "questionFields") {
      var bottomButtonComponent = null;
      if(s_phpIsCreatingQuestionTF) {
        bottomButtonComponent = (
          <CEGeneralReact.PhpWorkingMessage p_text="Creating Question..." />
        );
      }
      else {
        if(s_answerType123 === 1) {
          bottomButtonComponent = (<CEGeneralReact.CEButton p_type="blue" p_text="Proceed to Next Step Creating Answers" f_onClick={this.onclick_create_question_or_proceed_to_add_answers} />);
        }
        else if(s_answerType123 === 2 || s_answerType123 === 3) {
          bottomButtonComponent = (<CEGeneralReact.CEButton p_type="blue" p_text="Create This Question" f_onClick={this.onclick_create_question_or_proceed_to_add_answers} />);
        }
        else {
          bottomButtonComponent = (<CEGeneralReact.CEButton p_type="gray" p_text="Cancel" f_onClick={this.props.f_onClickClose} />);
        }
      }

      processInstructions = "Next, fill out the question, and add any optional tags or help text";
      processComponent = (
        <div className="flex11a displayFlexColumn">
          <div className="flex11a yScroll yScrollBottomPad">
            <div className="smallFullPad borderB1ddd">
              <font className="font12 fontItalic">{"Answer Type for this Question: "}</font>
              <font className="font14 fontBold fontTextLighter">{JSFUNC.get_first_array2_value_and_found_match_tf_where_array1_matches_input(s_answerType123, [1,2,3], ["Scored Select", "Scored Text", "Scored Textarea"], "--Answer Type Does Not Exist (ID: " + s_answerType123 + ")--")}</font>
            </div>
            <div className="medFullPad">
              <div className="smallTopMargin">
                <font className="font12">
                  {"Question Text"}
                </font>
              </div>
              <div className="smallTopMargin">
                <LibraryReact.Textarea
                  p_value={s_questionName}
                  p_class=""
                  p_styleObj={{height:"8em"}}
                  p_tabIndex={1}
                  p_placeholder="Enter the question..."
                  p_errorTF={(s_questionNameErrorMessage !== undefined)}
                  f_onChange={this.onchange_question_name}
                />
              </div>
              {(s_questionNameErrorMessage !== undefined) &&
                <CEGeneralReact.ErrorText p_class="microTopMargin" p_text={s_questionNameErrorMessage} />
              }
              <div className="displayFlexRow hugeTopMargin">
                <div className="flex11a smallRightMargin" style={{flexBasis:"100em"}}>
                  <div className="">
                    <font className="font12">
                      {"Question Tag(s) (optional)"}
                    </font>
                  </div>
                  <div className="microTopMargin">
                    <font className="fontItalic fontTextLighter">
                      {"Tags can be applied to questions for users to easily filter their " + c_cardNameDealShaping + " card to view questions that match a selected tag. Tags can help group together questions about a certain topic that become relevant across different stages. Example tag ideas might include 'Customer Relationship', 'Pricing', 'Strategy', 'Technical', etc"}
                    </font>
                  </div>
                </div>
                <div className="flex11a lrMargin" style={{flexBasis:"150em"}}>
                  <CEGeneralReact.CaptureExecFieldEditSaveCancel
                    p_ceEditItemString="aedAddNewDSQFloatingBoxSelectMultiAddTags"
                    p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiAddDealShapingQuestionTagsFieldTypeObj}
                    p_valueRaw={s_tagIDsComma}
                    p_valueIsEditableTFU={true}
                    f_onSaveChanged={this.onchange_tag_ids_comma}
                  />
                </div>
              </div>
              <div className="hugeTopMargin">
                <font className="font12">
                  {"Question Hover Help Text (optional) "}
                </font>
              </div>
              <div className="microTopMargin">
                <font className="fontItalic fontTextLighter">
                  {"This text will show if the user hovers their mouse over the wording of the question"}
                </font>
              </div>
              <div className="smallTopMargin hugeBottomMargin">
                <LibraryReact.Textarea
                  p_value={s_hoverText}
                  p_styleObj={{height:"11em"}}
                  p_tabIndex={3}
                  p_placeholder="Enter the hover help text..."
                  f_onChange={this.onchange_hover_text}
                />
              </div>
            </div>
          </div>
          <div className="flex00a displayFlexRow tbPad borderT1ddd">
            <div className="flex00a displayFlexColumnHcVc lrMedPad borderR1ddd">
              <CEGeneralReact.CEButton p_type="add" p_text="Go Back" f_onClick={this.onclick_return_to_select_answer_type} />
            </div>
            <div className="flex11a displayFlexColumnHcVc">
              {bottomButtonComponent}
            </div>
          </div>
        </div>
      );
    }
    else if((s_processStep === "createAnswers") || (s_processStep === "createAnswersSearchQuestionsToCopyAnswers")) {
      const selectQuestionAnswersMapOfMaps = JSFUNC.filtered_mapOfMaps_from_matching_field_value(this.props.DatabaseMobx.o_tbl_a_shaping_select_answers, "question_id", s_newlyCreatedQuestionID);
      const selectQuestionAnswersArrayOfObjs = JSFUNC.arrayOfObjs_from_mapOfMaps(selectQuestionAnswersMapOfMaps, "score0to100", false);

      const selectQuestionAnswersAedTableObj = {
        tblName: "tbl_a_shaping_select_answers",
        initialSortedFieldDbName: "score0to100",
        initialSortedFieldIsAscTF: false,
        itemName: "Answer",
        newItemConstantFieldNamesArray: ["question_id"],
        newItemConstantValuesArray: [s_newlyCreatedQuestionID],
        newItemConstantIdsbArray: ["i"],
        fieldsArrayOfObjs: [
          {width:"250em", dbName:"name", displayName:"Answer", fieldTypeObj:this.props.DatabaseMobx.c_genericTextFieldTypeObj, initialValue:"", cellHoverTF:true, onkeydownenterAddsNewItemTF:true},
          {width:"100em", dbName:"score0to100", displayName:"Score (0-100%, or negative down to -1000%)", fieldTypeObj:this.props.DatabaseMobx.c_genericPercentIntm1000to100FieldTypeObj, initialValue:100, cellCenterTF:true, onkeydownenterAddsNewItemTF:true}
        ]
      };

      processInstructions = "Finally, create (or copy) the Answers that will appear in the list of choices for this new Question";
      processComponent = (
        <div className="flex11a displayFlexColumn">
          <div className="flex11a yScroll medFullPad">
            <div className="medBottomMargin">
              <font className="font11 fontBold fontTextLighter">{"Question: "}</font>
              <font className="font11 fontBlue">{s_questionName}</font>
            </div>
            <div className="hugeBottomPad borderB1ddd">
              <AddEditDeleteTable
                p_dataArrayOfObjs={selectQuestionAnswersArrayOfObjs}
                p_aedTableObj={selectQuestionAnswersAedTableObj}
              />
            </div>
            <div className="hugeTopMargin">
              {(s_processStep === "createAnswers") ? (
                <div className="displayFlexColumnHcVc">
                  <CEGeneralReact.CEButton
                    p_type="gray"
                    p_text="Copy Answers from an Existing Question"
                    f_onClick={this.onclick_copy_answers_from_an_existing_question_button}
                  />
                </div>
              ) : (
                <NewSelectQuestionCopyAnswersFromExistingQuestion
                  p_newlyCreatedQuestionID={s_newlyCreatedQuestionID}
                  f_onCloseCopyAnswersFromExistingQuestion={this.onclose_copy_answers_from_existing_question}
                />
              )}
            </div>
          </div>
          <div className="flex00a displayFlexColumnHcVc tbPad borderT1ddd">
            {(s_processStep === "createAnswers") &&
              <CEGeneralReact.CEButton
                p_type="blue"
                p_text="Complete Process and Close"
                f_onClick={this.props.f_onClickClose}
              />
            }
          </div>
        </div>
      );
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="addEditDeleteTableEditQuestion"
        p_title={"Adding a New " + p_aedTableObj.itemName}
        f_onClickCancel={this.props.f_onClickClose}>
        <div className="flex11a displayFlexColumn">
          <NewCaptureFieldOrDealShapingQuestionInstructionsBar p_label={processInstructions} />
          {processComponent}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));


class NewQuestionAnswerTypeChoice extends Component { //props: p_answerType123, p_selectedAnswerType123, f_onClick
  onclick_answer_type_choice = () => {
    const p_answerType123 = this.props.p_answerType123;
    const p_selectedAnswerType123 = this.props.p_selectedAnswerType123;

    if(JSFUNC.is_function(this.props.f_onClick)) {
      const newSelectedAnswerType123 = ((p_answerType123 === p_selectedAnswerType123) ? (undefined) : (p_answerType123));
      this.props.f_onClick(newSelectedAnswerType123);
    }
  }

  render() {
    const p_answerType123 = this.props.p_answerType123;
    const p_selectedAnswerType123 = this.props.p_selectedAnswerType123;

    const typeIsSelectedTF = (p_answerType123 === p_selectedAnswerType123);

    var typeName = "";
    var typeDescriptionArray = [];
    var typeExamplesArray = [];
    if(p_answerType123 === 1) {
      typeName = "Scored Select";
      typeDescriptionArray = [
        "Creates a 'Select' (pull-down list) of admin defined answers",
        "Each individual answer is assigned a score from 0-100%, which contributes to the overall Shaping Progress score",
        "Answers can also be given negative scores from -1000% to 0% for answers that are very detrimental to winning a Capture",
        "Users can select 1 answer from the list (or clear the selection and leave it 'unanswered')"
      ];
      typeExamplesArray = [
        "'Does the customer express the business need?'  (Answers: 'Yes, the customer wants this solution' (100%), 'No, the customer is only interested' (-400%))",
        "'What type of competition is this?'  (Answers: 'Incumbent' (100%), 'One of few' (70%), 'One of many' (20%))",
        "'Rate our capability to deliver the technical solution 0-10'  (Answers: '10' (100%), '9' (90%), '8' (80%), '7' (70%), '6' (60%), '5' (50%), '4' (40%), '3' (30%), '2' (20%), '1' (10%), '0' (0%))"
      ];
    }
    else if(p_answerType123 === 2) {
      typeName = "Scored Text";
      typeDescriptionArray = [
        "For the 'Text' type, answering the question opens a single line text input for the user to enter their self typed answer to the question.",
        "There is no limit to the amount of text that can be entered, but it can be difficult to see what you have typed if the answer is longer than a few words.",
        "To the left of this input is a slider where the user can give their answer a self evaluated 'completeness score' from 0-100% for the answer they just typed."
      ];
      typeExamplesArray = [

      ];
    }
    else if(p_answerType123 === 3) {
      typeName = "Scored Textarea";
      typeDescriptionArray = [
        "Provides a large area for text input, can store approx 500,000 words",
        "User can enter a self evaluated rating score for their given answer"
      ];
      typeExamplesArray = [
        "'What is our marketing approach with the customer?'",
        "'Explain the customer business case.'",
        "'List the customer's top 5 priorities.'"
      ];
    }

    return(
      <div
        className={"medFullMargin medFullPad border bevelBorderColors " + ((typeIsSelectedTF) ? ("ticketResponseFromBITUnread") : ("bgAlmostWhite hoverLighterBlueGradient cursorPointer"))}
        onClick={this.onclick_answer_type_choice}>
        <div className="displayFlexRow">
          <div className="flex11a" style={{flexBasis:"100em"}}>
            <div className="smallBottomMargin">
              <font className="font15 fontBold fontTextLighter">
                {typeName}
              </font>
            </div>
          </div>
          <div className="flex11a" style={{flexBasis:"200em"}}>
            <CEGeneralReact.BulletList p_linesArray={typeDescriptionArray} p_fontClass="fontItalic fontTextLighter" p_dashFontClass="fontTextLighter" />
          </div>
        </div>
        {(typeExamplesArray.length > 0) &&
          <>
            <div className="smallTopMargin microBottomMargin">
              <font className="fontBold fontItalic fontBlue">
                {"Examples"}
              </font>
            </div>
            <CEGeneralReact.BulletList p_linesArray={typeExamplesArray} p_fontClass="fontBlue" />
          </>
        }
      </div>
    );
  }
}



const NewSelectQuestionCopyAnswersFromExistingQuestion = inject("AdminMobx")(observer(
class NewSelectQuestionCopyAnswersFromExistingQuestion extends Component { //props: p_newlyCreatedQuestionID, f_onCloseCopyAnswersFromExistingQuestion
  constructor(props) {
    super(props);

    this.state = {
      s_viewingQuestionID: undefined,
      s_viewingQuestionAnswersArrayOfObjs: undefined,
      s_isCopyingTF: false
    }
  }

  onclick_cancel_search_questions = () => {
    this.setState({
      s_viewingQuestionID: undefined,
      s_viewingQuestionAnswersArrayOfObjs: undefined,
      s_isCopyingTF: false
    });

    if(JSFUNC.is_function(this.props.f_onCloseCopyAnswersFromExistingQuestion)) {
      this.props.f_onCloseCopyAnswersFromExistingQuestion();
    }
  }

  onclick_question = (i_selectedQuestionObj) => {
    this.setState({
      s_viewingQuestionID: i_selectedQuestionObj.id,
      s_viewingQuestionAnswersArrayOfObjs: i_selectedQuestionObj.answersArrayOfObjs
    });
  }

  onclick_copy_answers_to_new_question = () => {
    const p_newlyCreatedQuestionID = this.props.p_newlyCreatedQuestionID;

    const jsDescription = JSFUNC.js_description_from_action("AdminReact - NewSelectQuestionCopyAnswersFromExistingQuestion", "onclick_copy_answers_to_new_question", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    var allNewAnswerNamesArray = [];
    var allNewAnswerScoresArray = [];
    for(let answerObj of this.state.s_viewingQuestionAnswersArrayOfObjs) {
      allNewAnswerNamesArray.push(answerObj.name);
      allNewAnswerScoresArray.push(answerObj.score0to100);
    }
    const fieldNamesArray = ["question_id", "name", "score0to100"];
    const valuesArrayOfArrays = [p_newlyCreatedQuestionID, allNewAnswerNamesArray, allNewAnswerScoresArray];
    const valueIdsbArray = ["i", "s", "i"];
    C_CallPhpTblUID.add_multi_insert("tbl_a_shaping_select_answers", fieldNamesArray, valuesArrayOfArrays, valueIdsbArray);

    const functionOnFinish = () => {
      this.onclick_cancel_search_questions();
    }
    C_CallPhpTblUID.add_function("onFinish", functionOnFinish);

    C_CallPhpTblUID.execute();

    this.setState({s_isCopyingTF:true});
  }

  render() {
    const s_viewingQuestionID = this.state.s_viewingQuestionID;
    const s_viewingQuestionAnswersArrayOfObjs = this.state.s_viewingQuestionAnswersArrayOfObjs;
    const s_isCopyingTF = this.state.s_isCopyingTF;

    const p_newlyCreatedQuestionID = this.props.p_newlyCreatedQuestionID;

    const c_questionsPoolArrayOfObjs = this.props.AdminMobx.c_questionsPoolArrayOfObjs;

    return(
      <div className="">
        <div className="displayFlexColumnHcVc">
          <CEGeneralReact.CEButton
            p_type="gray"
            p_text="Cancel Copying Answers"
            f_onClick={this.onclick_cancel_search_questions}
          />
        </div>
        <div className="displayFlexRow medTopMargin" style={{height:"40em", border:"solid 1px #ccc"}}>
          <div className="flex11a displayFlexColumn borderR1ddd" style={{flexBasis:"100em"}}>
            <div className="flex00a smallFullPad bgDarkGrayGradient" style={{borderBottom:"solid 1px #666"}}>
              <font className="font12 fontBold fontItalic fontWhite">
                {"Existing Select Questions (and # Answers)"}
              </font>
            </div>
            <div className="flex11a yScroll yScrollBottomPad bgLightestGray">
              {c_questionsPoolArrayOfObjs.map((m_questionObj) =>
                (m_questionObj.answer_select1_text2_textarea3 === 1) &&
                <NewSelectQuestionCopyAnswersSingleQuestion
                  key={m_questionObj.id}
                  p_questionObj={m_questionObj}
                  f_onClick={this.onclick_question}
                />
              )}
            </div>
          </div>
          <div className="flex11a displayFlexColumn" style={{flexBasis:"100em"}}>
            <div className="flex00a smallFullPad bgDarkGrayGradient" style={{borderBottom:"solid 1px #666"}}>
              <font className="font12 fontBold fontItalic fontWhite">
                {"Answers to Selected Question (with % Score)"}
              </font>
            </div>
            {(s_viewingQuestionID === undefined) ? (
              <CEGeneralReact.EmptyScreenGray>
                {"Select a Question to view its Answers"}
              </CEGeneralReact.EmptyScreenGray>
            ) : (
              <div className="flex11a yScroll yScrollBottomPad bgLightestGray">
                <div className="displayFlexColumnHcVc tbMargin">
                  {(s_isCopyingTF) ? (
                    <font className="fontItalic fontTextLight">
                      {"Copying Answers..."}
                    </font>
                  ) : (
                    <CEGeneralReact.CEButton p_type="blue" p_text="Copy these Answers to New Question" f_onClick={this.onclick_copy_answers_to_new_question} />
                  )}
                </div>
                {s_viewingQuestionAnswersArrayOfObjs.map((m_answerObj) =>
                  <div key={"q" + s_viewingQuestionID + "a" + m_answerObj.id} className="displayFlexRow smallFullPad border bevelBorderColors bgAlmostWhite">
                    <div className="flex11a smallRightMargin">
                      <font className="">
                        {m_answerObj.name}
                      </font>
                    </div>
                    <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"4em"}}>
                      <font className="fontItalic">
                        {m_answerObj.score0to100 + "%"}
                      </font>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}));

class NewSelectQuestionCopyAnswersSingleQuestion extends Component { //props: p_questionObj, f_onClick
  onclick_question = () => {
    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick(this.props.p_questionObj);
    }
  }

  render() {
    const p_questionObj = this.props.p_questionObj;
    
    return(
      <div className="displayFlexRow smallFullPad border bevelBorderColors bgAlmostWhite hoverLightBlueGradient cursorPointer" onClick={this.onclick_question}>
        <div className="flex11a smallRightMargin">
          <font className="fontBlue">
            {p_questionObj.name}
          </font>
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"4em"}}>
          <font className="font11 fontItalic">
            {p_questionObj.numAnswers}
          </font>
        </div>
      </div>
    );
  }
}











export function UnassignedMatchingCapturesBoxAndCountButton(props) { //props: p_unassignedMatchingCapturesObj, p_fieldDisplayName
  const p_unassignedMatchingCapturesObj = props.p_unassignedMatchingCapturesObj;
  const p_fieldDisplayName = props.p_fieldDisplayName;

  if(p_unassignedMatchingCapturesObj.numMatchingCaptures === 0) {
    return(null);
  }

  return(
    <div className="displayFlexRow bgLighterGray lrMedPad" style={{width:"22em", height:"4em", border:"solid 1px #aaa"}}>
      <div className="flex11a displayFlexRowVc">
        <font className="font11 fontTextLight">
          {"Captures with unassigned " + p_fieldDisplayName}
        </font>
      </div>
      <div className="flex00a displayFlexColumnHcVc">
        <div className="">
          <font className="fontItalic fontTextLight">
            {"# Captures"}
          </font>
        </div>
        <CapturesReact.NumberOfAssignedCapturesCountButton
          p_partialNumMatchingCaptures={p_unassignedMatchingCapturesObj.partialNumMatchingCaptures}
          p_matchingCaptureIDsArray={p_unassignedMatchingCapturesObj.matchingCaptureIDsArray}
          p_floatingBoxTitle={"All Captures with unassigned " + p_fieldDisplayName}
        />
      </div>
    </div>
  );
}
